
import { makeStyles } from "@mui/styles";
import AccordionIcon from "../images/icon_actions/AccordionIcon.svg";
import loading from "../images/loading_new.gif";
import scrollBar from "../images/scrollBar.png";
import scrollBarMobile from "../images/scrollBarMobile.png";
import resizeIcon from "../images/icon_actions/resizeIcon.svg";
import whiteCross from "../images/whiteCross.png";
import AccordionUpIconWithBG from "../images/icon_actions/AccordionUpIconWithBG.svg";
import AccordionDownIconWithBG from "../images/icon_actions/AccordionDownIconWithBG.svg";




const customStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    changePasswordContainer: {},
    authContainer: {
        margin: 'auto',
        // maxWidth: 1320,
        flexGrow: 1,
        position: "relative",
        backgroundColor: "transparent",
        "& $CloseIcon": {
            bottom: "auto",
            top: 10,
            right: 10,
            zIndex: 999,
            "& .ant-image": {
                padding: 0
            }
        }
    },
    header: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: "#fff",
        fontSize: 0,
        position: "relative",
        paddingBottom: 15,
    },
    headerLogo: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        left: 40,
    },
    fontSize0: {
        fontSize: 0,
    },
    colCount: {
        columnCount: 2,
        columnGap: 50
    },
    // bgImg: {
    //     position: 'relative',
    //     height: '100%',
    //     width: '100%',
    //     backgroundImage: `url(${bgImg})`,
    //     objectFit: 'contain'
    // },
    primaryFont: {
        fontSize: '16px'
    },
    heightFull: {
        height: "100%"
    },
    positionRelative: {
        position: 'relative',
    },
    customIcon: {
        position: "absolute",
        top: 10,
        right: 25
    },
    salessignatureLogo: {},
    signatureLogo: {
        width: "90%",
        height: "20%",
        objectFit: "contain",
        objectPosition: "right",
        position: "absolute",
        right: 10,
        bottom: 35,
        "&$salessignatureLogo": {
            height: "25%",
        }
    },
    primaryPaperProduct: {},
    primaryPaper: {
        backgroundColor: 'white',
        padding: "10px 20px 10px 20px",
        borderRadius: '10px',
        boxShadow: "0 2px 5px 0 #8ac8d5",
        border: '1px solid #14A4C2',
        marginTop: 25,
        flex: 1,
        "& > div> *": {
            justifyContent: "space-between"
        },
        "&$primaryPaperProduct": {
            marginTop: 0
        }

    },
    zIndex: {
        zIndex: 999999
    },
    margin10tb: {
        margin: '10px 0'
    },
    margin5t: {
        marginTop: 5
    },
    margin10b: {
        marginBottom: 10
    },
    margin15b: {
        marginBottom: 15
    },
    margin10t: {
        marginTop: 10
    },
    margin10PaymentTop: {
        marginTop: "10px !important"
    },
    margin45t: {
        marginTop: 45
    },
    margin15: {
        margin: 15
    },
    margin15t: {
        marginTop: 15
    },
    margin25t: {
        marginTop: 25
    },
    margin15tb: {
        margin: '15px 0'
    },
    margin15lr: {
        margin: '0 15px'
    },
    paddding15nb: {
        padding: '10px 15px'
    },
    padding55t: {
        paddingTop: "55px !important"
    },
    padding24: {
        padding: 24
    },
    priceTopbar: {
        padding: "10px 0 24px 0"
    },
    padding24tb: {
        padding: "24px 0"
    },
    padding25r: {
        paddingRight: '25px'
    },
    padding10r: {
        paddingRight: '10px'
    },
    padding20r: {
        paddingRight: '20px'
    },
    profileIconHover: {
        position: "relative"
    },
    padddingIcons: {
        padding: '12px 7px 14px 12px'
    },
    padddingIconsProfile: {
        padding: '12px 14px'
    },
    margin15nb: {
        margin: '8px 15px'
    },
    margin20: {
        margin: '20px'
    },
    margin30Topb: {
        margin: '20px 0'
    },
    margin30t: {
        marginTop: '30px !important'
    },
    margin35t: {
        marginTop: '35px'
    },
    margin40aa: {
        margin: '40px'
    },
    padding4: {
        padding: '4px'
    },
    padding0: {
        padding: '0px !important'
    },
    padding5: {
        padding: '5px 10px'
    },

    padding5t: {
        paddingTop: '5px'
    },
    padding15t: {
        paddingTop: '15px'
    },
    padding20t: {
        paddingTop: '20px'
    },
    padding25t: {
        paddingTop: '25px'
    },
    padding20tb: {
        padding: '20px 0'
    },
    padding10t: {
        paddingTop: "10px"
    },
    padding30tb: {
        padding: '30px 0 !important'
    },
    padding30b: {
        paddingBottom: "30px !important"
    },
    padding10tb: {
        padding: '10px 0'
    },
    padding20LR: {
        padding: '0 20px'
    },
    padding25LR: {
        padding: '0 25px'
    },
    PaddingRight15: {
        paddingRight: '15px'
    },
    PaddingRight5: {
        paddingRight: '5px'
    },
    PaddingRight50: {
        paddingRight: '50px'
    },
    paddingright0: {
        paddingRight: '0 !important',
    },
    PaddingRight10: {
        paddingRight: '10px'
    },
    PaddingRight30: {
        paddingRight: '30px !important'
    },
    PaddingRight20: {
        paddingRight: '20px',
    },
    paddingRight70: {
        paddingRight: '70px !important'
    },

    marginRight20: {
        marginRight: '20px',
    },

    paddingRight75: {
        paddingRight: '75px',
    },
    paddingright90: {
        paddingRight: '90px',
    },
    menuIcons: {
        gap: "0 !important"
    },
    a: {},
    iconDropDown: {},
    menu: {
        paddingRight: '20px',
        display: 'flex',
        border: 'none',
        backgroundColor: 'white',
        '& .ant-space:last-child': {
            fontSize: '0',
        },
        '& a': {
            position: "relative",
            "&::before": {
                transition: "background-color .5s"
            }
        },
        '& .ant-dropdown-open': {
            '&$profileIconHover': {
                '& .ant-image': {
                    position: "relative",

                }
            },
            '&$iconDropDown': {
                '& .ant-image': {
                    transform: "rotate(180deg)"
                }
            }
        }
    },
    menuButton: {
        borderRadius: 10,
        backgroundColor: "#f7f7f7",
        color: "#FCB364",
        fontSize: 10,

        '&:hover': {
            color: "#FCB364",
            backgroundColor: "#f7f7f7",
        },
    },
    modal: {
        width: '325px',
        borderRadius: 10
    },
    modalPaper: {
        // margin: '0 25px 40px',
        // borderRadius: 10,
        "&.ant-space": {
            display: "block",
            textAlign: "center",
        },
        "& $loginForm": {
            maxWidth: "none"
        }
    },
    popupSuccess: {

    },
    modalBtn: {
        padding: "7px 30px",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 16,
        backgroundColor: "#FCB364",
        color: "#000",
        textTransform: 'none',
        lineHeight: 1,
        fontWeight: 500,
        fontSize: '14px !important',
        border: "2px solid #FCB364 !important",
        WebkitAppearance: "button",
        transition: "background-color .5s, border .5s, box-shadow .5s",
        '&:hover': {
            backgroundColor: "#fff2e4",
            color: "#000",
            boxShadow: "none",
        },
    },
    whiteBtn: {
        padding: "7px 30px",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 16,
        backgroundColor: "#fff",
        border: 'solid 2px #d9d9d9',
        color: "#979797",
        textTransform: 'none',
        lineHeight: 1,
        WebkitAppearance: "button",
        transition: "background-color .5s, border .5s, box-shadow .5s",
        '&:hover': {
            backgroundColor: "#ffe6b3",
            color: "#979797",
            boxShadow: "none",
        },
    },
    deleteBtn: {
        display: "inline-block",
        padding: "7px 30px",
        backgroundColor: "#fff",
        color: "#d20b0b",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 16,
        lineHeight: 1,
        border: '2px solid #d20b0b',
        textTransform: 'none',
        WebkitAppearance: "button",
        transition: 'background-color .4s, color .4s, box-shadow .4s',
        '&:hover': {
            backgroundColor: "#FFE4E4",
            color: "#d20b0b",
            boxShadow: "none"
        },

    },
    transitionBtn: {
        '& .MuiTouchRipple-root': {
            transition: ' .5s all ease',
        }
    },
    colorRed: {
        color: "#d32f2f !important"
    },
    rejectRed: {
        color: '#ff6b6b !important'
    },
    deleteRed: {
        color: '#d32f2f',
    },
    colorRedRequired: {
        color: "#ff6b6b"
    },
    AddMoreBtnFull: {
        width: "100%"
    },
    bigMenuColorsNo: {
        "& .ant-dropdown-menu-item": {
            cursor: "auto"
        }
    },
    noNotificationText: {
        color: "#000", fontWeight: 400,
        "& $customLink": {
            display: "inline-block",
            color: "#317787",
            cursor: "pointer",
            "&:hover": {
                color: "#01A4A6",
            }
        }
    },
    AddMoreBtn: {
        padding: "7px 30px",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 25,
        backgroundColor: "#fff",
        color: "#000 !important",
        textTransform: 'none',
        border: '2px solid #fcb364 !important',
        lineHeight: 1,
        fontSize: '14px !important',
        transition: "background-color .4s, box-shadow .4s",
        WebkitAppearance: "button",
        '&$AddMoreBtnFull': {
            width: "100%"
        },
        '&:hover': {
            backgroundColor: "#FFF2E4",
            boxShadow: "none"
        },
    },
    btnParent: {
        padding: "10px 20px",
        backgroundColor: "#fff",
        margin: "10px -20px 0 -20px",
        boxShadow: "3px 0 6px 0 rgba(0, 0, 0, 0.16)"
    },
    modalBtnTransparent: {
        minWidth: 120,
        padding: "8px 20px",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 25,
        backgroundColor: "#fff",
        border: "2px solid #FCB364 !important",
        color: "#000",
        fontWeight: 500,
        textTransform: 'none',

        '&:hover': {
            backgroundColor: "#ffe6b3",
            color: "#000",
            boxShadow: "none",
        },
    },
    title: {
        flexGrow: 1,
        color: "#000",
    },
    navBar: {
        // backgroundColor: "#000",
        backgroundColor: "#fff",
        // padding: theme.spacing(1, 2),
        boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 4%)",
        // rgb(0 0 0 / 4%) 0px 3px 6px 0px;
    },
    iconSize: {
        fontSize: 16,
    },
    bannerSize: {
        height: 500,
        // backgroundImage: `url(${image})`,

        '&::before': {
            content: '',
            backgroundColor: '#aaa',
        },
    },
    secBtn: {
        padding: "7px 30px",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 16,
        backgroundColor: "#FFF",
        color: "#000",
        border: "2px solid #FCB364",
        lineHeight: 1,
        display: "inline-block",
        textTransform: "none",
        transition: "background-color .4s, color .4s, box-shadow .4s",
        '&:hover': {
            backgroundColor: "#ffe6b3",
            color: "#000",
            boxShadow: "none",
        },
    },
    fontWeightNormal: {
        fontWeight: 'normal',
    },
    postBtn: {
        padding: "8px 30px",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 16,
        backgroundColor: "#FCB364",
        color: "#000",
        lineHeight: "1.08",
        textTransform: 'none',
        fontWeight: 'normal',
        width: '100%',
        display: "inline-block",
        '&:hover': {
            backgroundColor: "#ffe6b3",
            color: "#000",
            // border: "1px solid #ffe6b3",
            boxShadow: "none",
        },
    },
    textDecoration: {
        textDecoration: "none"
    },
    navLink: {
        color: "#FCB364",
        margin: 0,
        textDecoration: "none",

        '&:hover': {
            color: "#000",
            backgroundColor: "inherit",
        }
    },
    links: {
        margin: "0 10px",
        color: "#f7f7f7",

        '&:hover': {
            color: "#ffe6b3",
        }
    },
    authRoot: {
        flexGrow: 1,
    },
    loginHome: {
        flexGrow: 1,
        // background: `url(${bannerMatrimony})`,
        padding: "80px 0",
    },
    loginHomeGrid: {
        display: "flex",
        justifyContent: "center",
        width: "50vw",
    },
    registerHome: {
        flexGrow: 1,
        // background: 'linear-gradient(to right, #fbbb00 20%, #000 80%)',
        padding: "80px 0",
    },
    registerHomeBg: {
        backgroundColor: "#FFF5E4",
    },
    gridSize: {
        display: "flex",
        justifyContent: "center",
        // width: "49vw",
    },
    flexCenter: {
        display: "flex",
        justifyContent: "center",
    },
    fullWidth: {
        width: "100vw"
    },
    cardBg: {
        backgroundColor: "#FFF5E4",
        borderRadius: 10
    },
    cardSize: {
        padding: '24px',
        borderRadius: 10,
        boxShadow: "none",
    },
    noWrap: {
        whiteSpace: "nowrap",
    },
    typo: {
        padding: "50px 15px",
        margin: "1rem",
        color: "#000",
        backgroundColor: "inherit",
        borderRadius: 10,
        boxShadow: "none",
        // textAlign: "center"
    },
    inputImgFile: {

    },
    media: {
        height: 250,
        // width: 250,
        // paddingTop: '56.25%',
    },
    // maxWidth: {
    //     minWidth: 400,
    //     maxWidth: 500,
    // },
    typeAlignCenter: {
        textAlign: "center",
        justifyContent: "center"
    },
    padding10L: {
        paddingLeft: '10px !important'
    },

    margin20t: {
        marginTop: "20px"
    },
    padding15L: {
        paddingLeft: '15px !important'
    },
    padding40L: {
        paddingLeft: '40px !important'
    },
    padding10R: {
        paddingRight: '10px !important'
    },
    padding16: {
        padding: "15px 0",
    },
    padding16a: {
        padding: "25px",
    },
    padding1rem: {
        padding: "1rem",
    },
    padding40: {
        padding: "40px",
    },
    paddingRight40: {
        paddingRight: '40px',
    },
    padding80: {
        padding: "80px",
    },
    paddingRight80: {
        paddingRight: "80px",
    },
    margin8: {
        margin: "9px 0",
    },
    margin8a: {
        margin: "10px",
    },
    margin25a: {
        margin: "0 25px",
    },
    margin60: {
        margin: "0 60px",
    },
    margin40: {
        margin: "40px",
    },
    backBtn: {
        height: 42,
        width: 42,
        color: "#317787",
        borderRadius: 50,
        padding: 10,
        // padding: "12px 10px 8px 10px",
        backgroundColor: "#ffe6b3",
    },
    inline: {
        display: "inline"
    },

    textAlignRight: {
        textAlign: "right !important",
        "&.MuiTableCell-root": {
            "& > span": {
                marginLeft: "auto"
            }
        }
    },
    textAlignLeft: {
        textAlign: 'left !important'
    },
    defaultColor: {
        color: "#000 !important",
    },
    nonEditable: {},
    textFieldColor: {
        color: "#000 !important",
        fontSize: "14px",
        "&.Mui-disabled": {
            color: "#d9d9d9 !important",
            WebkitTextFillColor: "#d9d9d9 !important"
        },
        "& pre": {
            whiteSpace: "break-spaces !important"
        },
        "&$nonEditable": {
            "&.Mui-disabled": {
                color: "#000 !important",
                WebkitTextFillColor: "#000 !important"
            },
        },
        "& > p": {
            color: "#000 !important",
            fontSize: "14px",
        },
        "& > p.MuiFormHelperText-root.Mui-error": {
            color: "#d32f2f !important",
            fontSize: "12px"
        },
        '&::placeholder': {
            textOverflow: 'ellipsis !important',
            color: "#d9d9d9 !important",
            opacity: "1 !important",
            fontSize: "13px"
        },
        '&::-ms-input-placeholder': {
            textOverflow: 'ellipsis !important',
            color: "#d9d9d9 !important",
            fontSize: "13px",
            opacity: "1 !important",
        },
        '&::-webkit-input-placeholder': {
            textOverflow: 'ellipsis !important',
            color: "#d9d9d9 !important",
            opacity: "1 !important",
            fontSize: "13px"
        }
    },
    customAutoLabel: {
        position: "absolute",
        top: 0,
        right: 0,
        width: "100%",
        zIndex: 999,
        "& >*": {
            display: "inline-block",
            verticalAlign: "middle",
            marginLeft: 5
        },
        "& .ant-image": {
            width: "14px !important",
            height: "auto !important", padding: "0 !important",
            "& .ant-image-img": {
                width: "100%",
                height: "auto",
            }
        }
    },
    customToolTipBusiness: {
        "& .ant-image": {
            width: "14px !important",
            height: "auto !important", padding: "0 !important",
            "& .ant-image-img": {
                width: "100%",
                height: "auto",
            }
        }
    },
    customDisabled: {
        pointerEvents: "none"
    },
    textFieldLableColor: {
        color: "#d9d9d9",
        fontSize: 14,
        paddingRight: 15,
        "&.MuiInputLabel-shrink": {
            color: "#8a8a8e !important"
        }
    },
    placeholderColor: {
        fontSize: "14px",
        color: '#d9d9d9',
    },
    color: {
        color: "#317787",
        transition: "color .4s",
        '&a:hover': {
            color: "#01A4A6",
        }
    },
    logo: {
        width: 200,
        margin: 10,
    },
    formControl: {
        margin: "10px 0",
        width: '100%',
    },
    simpleFooter: {
        padding: 40,
        backgroundColor: "#FFF5E4",
        color: '#000',
    },
    profileSlider: {
        // margin: "10px 40px 40px 40px",
        padding: 25,
    },
    chooseUs: {
        padding: 25,
    },
    viewProfileBtn: {
        minWidth: 120,
        padding: "8px 20px",
        margin: "0 25px 15px 15px",
        boxShadow: "none",
        borderRadius: 10,
        backgroundColor: "#FCB364",
        color: "#f7f7f7",
        border: "1px solid #FCB364",
        fontWeight: 500,

        '&:hover': {
            backgroundColor: "#ffe6b3",
            color: "#000",
            border: "1px solid #ffe6b3",
            boxShadow: "none",
        },
    },
    cardTitle: {
        color: '#000',
        margin: "20px 20px",
        // padding: "25px 0",
        textAlign: "center",
        fontWeight: 500,
    },
    topBarHeight: {
        height: 218,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    secondBarHeight: {
        height: 125,
        display: "flex",
        flexDirection: "column"
    },
    thirdBarHeight: {
        height: 100,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    profileCardStyle: {
        margin: "12px 20px",
        // maxWidth: 320,
        borderRadius: 10,
        // border: "1px solid #FCB364",
        boxShadow: "none",
        backgroundColor: "#FFF5E4",
    },
    listingCardFilterGrid: {
        width: "28vw",
        padding: 30,
    },
    listingCardProfileGrid: {
        width: "68vw",
        padding: 30,
    },
    widthFull: {
        width: "100%"
    },
    primaryTypo: {
        margin: "2 10",
        fontWeight: 500
    },
    paddingBottom20: {
        paddingBottom: "20px !important"
    },
    paddingBottom10: {
        paddingBottom: "10px !important"
    },
    paddingLeft10: {
        paddingLeft: "10px !important"
    },
    paddingLeft20: {
        paddingLeft: "20px !important"
    },
    paddingLeft50: {
        paddingLeft: '50px !important',
    },
    paddingLeft30: {
        paddingLeft: '30px',
    },
    leftFloat: {
        float: "left",
    },
    paddingLeft0: {
        paddingLeft: 0
    },
    paddingLeft15: {
        paddingLeft: '15px'
    },
    basicDetailPaper: {
        margin: "15px 0"
    },
    bgColor: {
        backgroundColor: '#FFF5E4'
    },
    whiteBg: {
        backgroundColor: '#fff'
    },
    darkOrange: {
        color: 'rgba(0, 0, 0, 0.87)'
    },
    mdWidth: {
        width: '450px'
    },
    modalPaperTitle: {
        fontSize: '20px'
    },
    linkColor: {
        color: '#317787',
    },
    rMarginRight: {

    },
    marginRight0: {
        marginRight: 0
    },
    margin10: {
        marginRight: 10
    },
    marginLeft10: {
        marginLeft: 10
    },
    marginLeft20: {
        marginLeft: 20
    },
    toggleClassLabel: {
        '&$rMarginRight': {
            marginRight: 0
        },
        '& .MuiFormControlLabel-label': {
            fontSize: '12px',
            paddingLeft: '5px'
        }
    },

    breadcrumbRoot: {
        '& span': {
            display: 'inline-block',
            verticalAlign: 'middle',
        },
        '& .ant-breadcrumb-link .ant-image': {
            verticalAlign: 'middle',
        }
    },
    businessDesignBox: {
        "& >div": {
            paddingRight: 10
        }
    },
    loginForm: {
        maxWidth: "400px",
        width: "100%",
        margin: "auto",
        "& .tickRound path": {
            strokeWidth: 35
        },
        "& .insideTick path": {
            strokeWidth: 35
        }
    },
    authForm: {
        maxWidth: "380px",
        margin: "auto",
        '& .MuiFormGroup-root': {
            justifyContent: "center"
        }
    },
    fullHeightBlock: {},
    regSuccess: {},
    fullHei: {
        alignItems: 'center',
        '& .MuiGrid-root': {
            height: '100%',
            position: 'relative',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        '&$regSuccess': {
            '& .MuiGrid-root': {
                flexDirection: "column"
            }
        },
        '& .ant-image': {
            height: '100%',
            padding: "40px 0 0"
        },
        '& .ant-image > img': {
            height: '100%',
            width: 'auto',
        },
        '& .MuiAvatar-img': {
            objectFit: "contain"
        },
        '&$fullHeightBlock': {
            '& .MuiGrid-root': {
                display: "block"
            }
        }
    },
    registerForm: {
        overflow: "auto",
        maxHeight: "100%",
        "& $cardSize": {
            padding: "24px 24px 24px 24px"
        }
    },
    customRegisterForm: {
        "& $cardSize": {
            maxWidth: "500px",
            backgroundColor: "transparent"
        }
    },
    registerPage: {
        position: "relative"
    },
    comInput: {
        '& > .MuiInput-root::before, & > .MuiInput-root::after': {
            borderBottom: '0'
        },
        '& > .MuiInput-root:hover:not(.Mui-disabled):before,  & > .MuiInput-root:hover:not(.Mui-disabled):after': {
            borderBottom: '0'
        },
        '& input': {
            padding: '5px 0 5px 0',
            fontSize: '14px',
        },
    },
    staySigned: {
        margin: "0 0 0 10px",
        '& > .MuiTypography-body1': {
            fontSize: "13px !important"
        },
        '& .MuiCheckbox-root': {
            padding: 0
        },
        '& .MuiSvgIcon-root': {
            fontSize: 18
        }
    },
    registerText: {
        marginLeft: "10px"
    },
    generalTitle: {
        color: '#14A4C2 !important',
    },
    aTitle: {
        fontSize: "18px",
        color: "#000"
    },
    tableTextLeft: {
    },
    minHeight0: {},
    customRow: {},
    collapseTable: {
        '&.MuiCollapse-root': {
            '& .MuiCollapse-wrapper': {
                boxShadow: 'none',
            },
            '& .MuiTableRow-root': {
                '& .MuiTableCell-root': {
                    '&::first-of-type': {
                        opacity: '0',
                        width: "350px"
                    }
                }
            },
            '& .MuiTableCell-root': {
                padding: "16px",
                border: "none",
                '&::first-child': {
                    opacity: '0',
                    width: "350px"
                }
            }
        }
    },
    customRowRoles: {},
    customerSettlementModule: {},
    boxShadow: {
        boxShadow: "0 3px 6px 0 #8ac8d5",
    },
    headActive: {

    },
    headBorderActive: {},
    tableResize: {},
    tableColHoverColor: {
        "&.MuiTableCell-root": {
            backgroundColor: "#fafafa",
        },
        "&.MuiTableCell-head.MuiTableCell-root": {
            backgroundColor: "#e8f6f9 !important"
        }
    },

    tableRoot: {
        marginTop: 15,
        borderRadius: '10px !important',
        border: '1px solid #14A4C2',
        boxShadow: "0 3px 6px 0 rgb(20 164 194 / 16%), inset 0 3px 6px 0 rgb(20 164 194 / 16%)",
        "&:first-child": {
            marginTop: '0',
        },
        '& .checkbox': {
            '& .MuiSvgIcon-root': {
                fontSize: "1.2rem"
            }
        },
        '&$heightAuto': {
            height: "auto !important"
        },
        '& .MuiTableCell-root': {
            fontWeight: "normal",
            lineHeight: 1.15,
            padding: "16px 10px 16px 10px",
            "& span.MuiCheckbox-root": {
                display: "inline-block",
            },
            "& > span": {
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            },
            "& a": {
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            },
        },
        '& th.MuiTableCell-root.MuiTableCell-head': {
            padding: "5px 10px 5px 10px",
            backgroundColor: "#fafafa",
            borderBottom: "6px solid #fff",
            lineHeight: 1,
            "&$headActive": {
                backgroundColor: "#e8f6f9",
            }
        },
        '&$customerSettlement': {
            '&$customerSettlementModule': {
                '& .MuiTabPanel-root': {
                    height: "calc(100% - 70px)",
                }
            },
            '& .MuiTabPanel-root': {
                height: "calc(100% - 100px)",
                padding: "25px 0 0",
                '& $scrollParent': {
                    height: "100%",
                    '& .ant-col': {
                        height: "100%",
                        '& $customRow': {
                            height: "100%",
                            '&$customRowRoles': {
                                '& $tablecontain': {
                                    height: "100%",
                                    '& th.checkbox$tablealign': {
                                        '& span': {
                                            opacity: 1
                                        }
                                    }
                                },
                            },
                            '& $tablecontain': {
                                height: "calc(100% - 40px)",
                                width: "100% !important",
                                '& th.checkbox$tablealign': {
                                    '& span': {
                                        opacity: 0,
                                        pointerEvents: "none"
                                    }
                                },
                                '& th': {
                                    whiteSpace: "nowrap"
                                },
                                '& td': {
                                    whiteSpace: "nowrap"
                                }
                            },
                            '& .ant-col': {
                                height: "100%",
                                '& .ant-row': {
                                    height: "calc(100% - 30px)",
                                    '& .MuiTableContainer-root': {
                                        height: "100%;"
                                    }
                                }
                            },
                            '& $sortCol': {
                                padding: 0,
                            },
                            '& .MuiTableContainer-root ': {
                                // marginTop: '15px',
                            },
                            '& $customSortIcon': {
                                marginLeft: '5px !important',
                                width: '10px',
                                height: '10px',
                            },
                            '& $sortIconUp': {
                                marginLeft: '5px !important',
                                width: '10px',
                                height: '10px',
                            },
                        }
                    },
                },
            },
        },
        '& .MuiTableRow-root.Mui-selected': {
            backgroundColor: '#e8f6f9',
            transition: 'background-color .4s',
            '& .MuiTableCell-root': {
                color: '#14a4c2',
            },
        },
        '&$margin20t': {
            '&.Mui-expanded': {
                margin: "20px 0 0 0"
            },
        },
        '& .ant-card-head': {
            position: 'relative',
            borderRadius: '10px 10px 0 0',
            margin: "-1px -2px",
            backgroundColor: '#8AC8D5',
            minHeight: 'auto',
            boxShadow: '0 3px 6px 0 rgb(0 0 0 / 16%)',
            borderBottom: "1px solid transparent",
            '& .ant-card-head-title': {
                padding: '16px 0',
                fontWeight: 500,
                lineHeight: 1
            },
        },
        '& .ant-card-body': {
            height: "calc(100% - 47px)",
            position: "relative"
        },
        '& .MuiTableContainer-root': {
            height: "calc(100% - 50px)",
            overflow: "auto",
            paddingRight: "15px",
            overflowY: "scroll",
            "&$catelogueProducts": {
                paddingBottom: 30
            }
        },
        '& .ant-card-head:before': {

        },
        '& .ant-card-head-wrapper': {
            position: 'relative',
        },
        '& .MuiTable-root tr th:last-child': {
            textAlign: 'right',
            padding: "5px 0 5px 10px"
        },
        '& $tableTextLeft': {
            '&.MuiTable-root tr th:last-child': {
                textAlign: 'left',
            },
            '&.MuiTable-root tr td:last-child': {
                textAlign: 'left',
            },
        },
        '& $catelogueProducts': {
            '& .MuiTable-root tr td:last-child': {
                textAlign: 'left',
                padding: "16px 0 16px 10px"
            },
            '& .MuiTable-root tr th:last-child': {
                textAlign: 'right',
            },
        },
        '& .MuiTable-root tr td:last-child': {
            textAlign: 'right',
            padding: "16px 0 16px 10px"
        },
        '& .MuiTableCell-root:first-child': {
            padding: "16px 10px 10px 10px"
        },
        '& .MuiTableCell-root:last-child': {
            paddingRight: 0
        },
        '& .MuiCheckbox-root': {
            padding: 0,
        },
        '& .MuiTabPanel-root': {
            padding: '25px 0 25px'
        },
        "& $leftStoreSales": {
            '& .MuiTabPanel-root': {
                padding: '0 0 0 0'
            },
        }
    },
    mixedPaymentHeader: {
        backgroundColor: "#f0f0f0",
        padding: 10,
        borderRadius: 8,
        "& .ant-col": {
            position: "relative",
            display: "flex",
            justifyContent: "space-between",
            lineHeight: 1,
            "&:before": {
                content: "''",
                width: 2,
                height: "100%",
                backgroundColor: "#FFA539",
                position: "absolute",
                top: "50%",
                right: 0,
                transform: "translateY(-50%)"
            },
            "&:last-child": {
                "&:before": {
                    content: "none"
                }
            }
        }
    },
    modalBtnTab: {
        position: "absolute",
        right: 0, top: -5,
        zIndex: 99
    },
    customerSettlement: {

    },
    productNamesModal: {
        maxHeight: 450,
        overflow: "auto",
        marginTop: 10
    },
    productTableRoot: {
        '& tr th': {
            padding: "10px"
        },
        '& tr td': {
            padding: "10px",
            '& .MuiInput-root': {
                margin: 0
            },
            '& .MuiInputLabel-root': {
                top: "-15px"
            }
        },
    },
    commonPopupText: {},
    notificationRight: {
        "&>*": {
            display: "inline-block",
            verticalAlign: "middle"
        },
        "& svg": {
            width: 10,
            "& path": {
                stroke: "#317787"
            }
        }
    },

    commonPopup: {
        '&$popupSuccess': {
            "& $modalPaper": {
                margin: '0',
                borderRadius: "0",
                gap: "0 !important"
            },
            '& .ant-modal-body': {
                padding: '20px 45px',
            },
            '& $modalPaperTitle': {
                fontSize: "20px",
                color: "#1c314c",
            },

        },
        padding: '0',
        '& .ant-modal-header': {
            padding: '15px',
            borderBottom: '2px solid #ffa539',
            borderRadius: '20px 20px 0 0'
        },
        '& .ant-modal-title': {
            fontSize: '15px',
            color: '#1c314c',
        },
        '& .ant-modal-content': {
            position: 'relative',
            borderRadius: '20px',
            '& $modelCloseIcon': {
                position: 'absolute',
                top: '15px',
                right: '20px',
                transition: '0.5s all ease',
                cursor: 'pointer',
                '& svg': {
                    width: '25px',
                    height: 'auto',
                },
                '&:hover': {
                    transform: 'scale(1.2)'
                },
            },
        },
        '& .ant-modal-content form': {
            margin: '0',
        },
        '& .ant-modal-body': {
            // padding: '25px 65px 25px 65px',
        },
        "&$commonPopupText": {
            '& .ant-modal-body': {
                padding: '25px',
                textAlign: "center"
            },
        },
        '& .ant-modal-close': {
            display: "inline-block",
            transition: "0.3s all ease",
            "&:hover": {
                transform: "scale(1.3)"
            }
        },
        '& .MuiButton-fullWidth': {
            margin: '30px 0 0 0',
        },
    },
    breadBg: {
        padding: '10px 40px 0 40px',
        position: 'relative',
    },
    colorBg: {
        position: 'absolute',
        left: '0',
        top: '0',
        width: '100%',
        height: '65%',
        backgroundColor: '#8AC8D5',
        boxShadow: "0 3px 6px 0 rgb(0 0 0 / 16%)"
    },
    paddingRight60: {
        paddingRight: '60px !important'
    },
    breadImg: {
        position: 'relative',
        width: '60px',
        height: '60px',
        borderRadius: ' 50%',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '24px',
        justifyContent: 'center',
        border: '5px solid #8AC8D5',
        boxShadow: '0 4px 5px 0px rgb(0 0 0 / 10%)',

    },
    breadTitle: {
        paddingLeft: '20px',
        position: 'relative',
        marginTop: '-22px',
    },
    breadTitleChild: {
        position: 'absolute',
        whiteSpace: 'nowrap',
        bottom: '-31px',
        '& .ant-breadcrumb-link a': {
            color: '#317787',
            "&:hover": {
                color: "#01A4A6"
            }
        }
    },

    breadTit: {
        paddingBottom: '12px',
        fontWeight: 500,
    },
    dFlex: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    customTitle: {
        color: '#000'
    },
    bold: {
        fontWeight: '500 !important',
    },
    forgotPassword: {
        display: "flex",
        justifyContent: "space-between"
    },
    flexWithSpaceBT: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start"
    },
    margint0: {},


    margin40t: {
        marginTop: "40px !important"
    },
    margin50t: {
        marginTop: "50px"
    },
    margin80t: {
        marginTop: "80px"
    },
    margin70t: {
        marginTop: "70px"
    },
    margin90t: {
        marginTop: '90px'
    },
    margin91t: {
        marginTop: '93px'
    },
    margin75t: {
        marginTop: '75px'
    },
    margin65t: {
        marginTop: "60px"
    },
    margin60t: {
        marginTop: "65px"
    },
    margin55t: {
        marginTop: "55px"
    },
    margin100t: {
        marginTop: "100px"
    },
    fonSize14: {
        fontSize: "14px"
    },
    fonSize16: {
        fontSize: "16px !important"
    },
    fonSize15: {
        fontSize: "15px !important"
    },
    listItemStatic:{},
    productDetails: {
        height: "calc(100% - 95px)",
        overflow: "auto",
        "& .MuiAccordionSummary-root": {
            minHeight: 'auto',
            "&.Mui-expanded": {
                minHeight: 'auto',
                "& $typographyHeader": {
                    "&:before": {
                        backgroundImage: `url(${AccordionUpIconWithBG})`,
                    }
                }
            },
            "& .MuiAccordionSummary-content": {
                margin: "12px 0 !important"
            },
            padding: 0,
        },
        "& .MuiAccordionDetails-root": {
            padding: 0,
        },
        "& $typographyHeader": {
            position: "relative",
            paddingLeft: 20,
            lineHeight: 1,
            "& > *": {
                display: "inline-block",
                verticalAlign: "middle",
                position: "relative"
            },
            "&:before": {
                content: "''",
                backgroundImage: `url(${AccordionDownIconWithBG})`,
                width: 15,
                height: 12,
                position: "absolute",
                top: "50%",
                left: 0,
                transform: "translateY(-50%)",
                transition: "background .4s",
                backgroundSize: "contain"
            }
        },
        "& .MuiPaper-elevation": {
            "&.Mui-expanded": {
                margin: 0
            },

        }
    },
    totalQuantity: {
        position: "relative",
        paddingLeft: 10,
        marginLeft: 10,
        "&:before": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            width: 2,
            backgroundColor: "#ffa539",
            height: '100%'
        }
    },
    accordionInvoiceDetails: {
        padding: 0,
        "& $typographyHeader": {
            color: "#000"
        },
        "& $tablecontain": {
            "& .MuiTableCell-root": {
                padding: 8,
                border: "none",
                "&:first-child": {
                    padding: 8
                },
                "&:last-child": {
                    padding: 8
                }
            }
        }
    },
    padding15: {
        padding: "15px"
    },
    menuActive: {
        position: "relative",
        '&::before': {
            content: '""',
            position: "absolute",
            top: "100%",
            marginTop: "2px",
            left: 0,
            width: "100%",
            height: "2px",
            backgroundColor: "#ffa539"
        }
    },
    fonSize11: {
        fontSize: "11px"
    },
    fonSize13: {
        fontSize: "13px"
    },
    fontWeight500: {
        fontWeight: 500
    },
    primaryDrawer: {
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
    },
    antImage: {
        verticalAlign: "middle",
    },
    customLinkEnd: {
        justifyContent: "end"
    },
    customLink: {
        display: "block",
        "& span": {
            whiteSpace: "nowrap",
        },
        "& .ant-image": {
            fontSize: 0,
        },
        '&>*': {
            display: "inline-block !important",
            verticalAlign: "middle !important"
        },
        "&:hover": {
            "& $color": {
                color: "#01A4A6"
            }
        }
    },
    payingLabels: {
        "& >*": {
            fontSize: 14
        }
    },
    linkProductsMain: {
    },
    linkPublish: {
        textAlign: "right",
        padding: "10px 0",
        boxShadow: "3px 0 6px 0 rgb(0 0 0 / 16%)"
    },
    verticalAlignMiddle: {
        verticalAlign: "middle"
    },
    addLink: {
        textTransform: "none",
        padding: 0,
        minWidth: "auto",
        display: "inline-block",
        verticalAlign: "middle",
        marginLeft: '5px',
        fontSize: 14,
        '&>*': {
            display: "inline-block",
            verticalAlign: "middle"
        },
    },
    priceDesign: {
        padding: "3px 3px 2px",
        borderRadius: 8,
        border: "solid 1px #979797",
        backgroundColor: "#f0f0f0",
        display: "inline-block",
        marginTop: 20,
        marginRight: 10,
        fontWeight: "500",
        fontSize: 15,
        lineHeight: 1,
        cursor: "pointer",
        width: 90
    },
    keywordInnerFlex: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    keywordInnerDirection: {
        flexDirection: "row !important",
    },
    storeInvoiceRoundOffAmount: {},
    storeInvoiceAmount: {
        backgroundColor: "#f0f0f0",
        padding: "6px 10px",
        "& h4": {
            color: "#979797",
            margin: 0
        },
        "&$storeInvoiceRoundOffAmount": {
            "& $removeUnderline": {
                '& > .MuiInput-root::before': {
                    borderBottom: '1px solid rgb(177 177 177 / 75%) !important'
                },
            },
        },
        "& $removeUnderline": {
            '& > .MuiInput-root::before, & > .MuiInput-root::after': {
                borderBottom: '0 !important'
            },
        },
        "& p": {
            color: "#000",
            fontSize: 19,
            fontWeight: 500,
            margin: 0
        }
    },
    storeAmountReceived: {
        backgroundColor: "#e8f6f9"
    },
    amountReceived: {
        fontSize: "21px !important", lineHeight: 1,
        height: "15px",
        fontWeight: 500
    },
    eqStoreHeight: {
        height: 56
    },
    textTransformNone: {
        textTransform: "none"
    },
    margin20r: {
        marginRight: "20px"
    },
    margin15r: {
        marginRight: "15px"
    },
    tableLastColumn: {
        width: "90px"
    },
    stroeQuantity: {
        width: 80,
        "& >*": {
            display: "inline-block",
            verticalAlign: "middle"
        }
    },
    customFormProducts: {},
    customForm: {
        '& .MuiInput-input': {
            fontSize: "14px"
        },
        display: 'flex',
        flex: 1,
        padding: "20px 20px 0 20px",
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflowX: "hidden",
        overflowY: "auto",
        '& .MuiTableCell-root': {
            fontWeight: "normal",
            padding: 8,
            '&:first-child': {
                paddingLeft: 0
            },
            '&:last-child': {
                paddingRight: 0
            },
        },
        '&$customFormProducts': {
            flexDirection: 'row',
            padding: 0
        }
    },
    partyGstFormTable: {},
    customFormFlexProducts: {},
    dropDownWithSearch: {
        display: "flex",
        alignItems: "center",
        border: "1px solid #14A4C2",
        boxShadow: "0 3px 6px 0 rgb(20 164 194 / 16%), inset 0 3px 6px 0 rgb(20 164 194 / 16%)",
        borderRadius: 30,
        "& $customAutoComplete": {
            width: 110,
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none !important",
                boxShadow: "none",
                borderRight: "solid 1px #14a4c2 !important",
                borderRadius: 0
            },
            "& .MuiOutlinedInput-input": {
                height: "1.437em",
                padding: "5px 5px 5px 12px",
                "& + svg": {
                    right: "10px !important"
                }
            }
        },
        "& $searchAnimation": {
            flex: 1,
            border: "none",
            boxShadow: "none",
            borderRadius: 0,
        }
    },
    prevNextButton: {
        position: "sticky",
        left: "100%",
        top: 0,
        zIndex: 999,
        "&>*": {
            display: "inline-block",
            verticalAlign: "middle",
            lineHeight: 1
        },
        "&>a": {

        },
    },
    customFormFlexGrid: {},
    customFormLeftSel: {},
    customFormRightSel: {},
    customFormLeft: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        padding: "20px 0px 0 20px",
        "&$customFormLeftSel": {
            width: "75%"
        },
        "& $btnParent": {
            margin: "10px 0px 0 -20px",
        }
    },
    logoImgStoreSales: {

    },
    customFormRight: {
        width: "0",
        borderLeft: "1px solid #14a4c2",
        "&$customFormRightSel": {
            width: "35%"
        },
        "& $customForm": {
            height: "calc(100% - 20px)"
        }
    },
    customerProductAdd: {
        "& $customFormFlex": {
            '&$customFormFlexGrid': {
                '& $gridColoum': {
                    width: "20%"
                },
            },
            '& $gridColoum': {
                width: "20%"
            },
        }
    },
    customFormFlex: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
        overflowY: "auto",
        paddingRight: 15,
        '& $partyGstFormTable': {
            height: "calc(100vh - 440px)",
            overflow: "hidden",
            overflowY: "auto",
            paddingRight: "15px"
        },
        '& .MuiTable-root': {
            minWidth: "auto"
        },
        '& $gridColoum': {
            width: "14%"
        },
        '&$customFormFlexGrid': {
            '& $gridColoum': {
                width: "25%"
            },
            '& $prod_grp_tit': {
                width: "50%",
                marginBottom: 5
            },
        },
        '& $prod_grp_tit': {
            width: "50%",
            marginBottom: 5
        },
        "&$customFormFlexProducts": {
            "& $dropDownPointer": {
                '& $gridRow': {
                    paddingRight: 0
                }
            }
        }
    },
    customFormFlexRemoveOverflow: {
        display: "flex",
        flexDirection: "column",
    },
    cursor: {
        cursor: "pointer"
    },
    labelAjustment: {
        marginTop: 2
    },
    notificationCloseIcon: {
        position: "relative",
        display: "inline-block",
        transition: '0.3s all ease',
        "&:hover": {
            transform: "scale(1.3)"
        }
    },
    clientBgColor: {
        transition: "background-color .4s",
        "& $clientPadding5": {
            backgroundColor: "#e8f6f9"
        }
    },
    textFieldLableColorCustom: {
        color: '#d9d9d9',
        fontSize: "13px",
        paddingRight: '15px',
        "&.Mui-disabled": {
            color: '#979797',
        },
        "&>*": {
            display: "inline-block",
            verticalAlign: "middle",
            lineHeight: 1
        },
        "&.MuiInputLabel-shrink": {
            color: '#8a8a8e !important',
            "&.Mui-disabled": {
                color: '#979797 !important',
            },
            "&.MuiInputLabel-formControl": {
                transform: "translate(0, -1.5px) scale(1)"
            },
            "&.Mui-focused": {
                color: '#FCB364 !important',
            }
        },
        '&$fonSize13': {
            fontSize: "13px",
        },
        '&.MuiFormLabel-filled': {
            transform: "translate(0, -1.5px) scale(1)"
        },
        '&.Mui-focused': {
            transform: "translate(0, -1.5px) scale(1)"
        },
        '&+.MuiInputBase-root': {
            marginTop: "14px"
        },
        '& .MuiInputLabel-asterisk': {
            color: "#ff6b6b"
        }
    },
    noInternetContainer: {
        padding: 15,
        color: "#000",
        "& p": {
            marginTop: 10
        }
    },
    appliedDiscount: {
        padding: "1px 4px 0",
        borderRadius: 3,
        backgroundColor: "#16c88b",
        display: "inline-block !important",
        fontSize: 12,
        color: "#fff",
        verticalAlign: "middle"
    },
    noInternet: {
        fontWeight: 500,
        fontSize: 19,
        color: "#1c314c"
    },
    categoryListLink: {
        position: "relative",
        margin: "0 auto 28px",
        maxWidth: 75,
        "& .MuiCheckbox-root": {
            position: "absolute",
            top: 30,
            right: "100%",
            zIndex: 999
        },
        "& .MuiSvgIcon-root": {
            fontSize: 16
        },
        "& > a": {
            position: "relative",
            zIndex: 2,
        },
        "&:hover": {
            "& $catalogueDesign": {
                borderRadius: "10px 10px 0 0"
            },
            "& $categoryListActionIcons": {
                top: "100%",
                opacity: 1
            }
        }
    },
    editIcon: {

    },
    categoryListActionIcons: {
        width: "100%",
        top: "80%",
        position: "absolute",
        left: 0,
        justifyContent: "center",
        transition: "top .4s",
        boxShadow: "0px 0px 4px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#fff",
        borderRadius: "0 0 10px 10px",
        opacity: 0,
        padding: 5,
        border: "1px solid rgba(0, 0, 0, 0.16)",
        fontSize: 0,
        "& .ant-image": {
            width: 11
        },
        "& $editIcon .ant-image": {
            width: 14
        }
    },
    categoryListAction: {
        width: "100%",
        justifyContent: "center",
        opacity: 0,
    },
    suggestionBox: {
        position: "absolute",
        top: "100%",
        left: 0,
        width: "100%",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        border: "solid 1px #16c88b",
        backgroundColor: "#fff",
        color: "#000",
        borderRadius: 5,
        marginTop: "-2px",
        padding: "10px 8px",
        zIndex: 9,
        fontSize: 11,
        "& $infoSuggestion": {
            border: "none",
            boxShadow: "none",
            backgroundColor: "transparent",
            marginBottom: 0,
            width: 125,
            padding: "4px 9px",
        },
        "&:before": {
            left: 16,
            width: 10,
            bottom: "100%",
            height: 10,
            //content: "''",
            position: "absolute",
            backgroundColor: "#f9f7f8",
            border: "solid 0.3px #c8c8c8",
            transform: "rotate(45deg) translateY(6px)",
            borderBottom: "none",
            borderRight: "none",
        },
        "& svg": {
            position: "absolute",
            top: 16,
            right: 8,
            width: 10,
            height: 10,
            cursor: "pointer",
            zIndex: 999,
        },
    },
    purchaseCustomUnitPrice: {
        "& $infoSuggestion": {
            width: 160,
        },
        "& $suggestionBox": {
            "& $infoSuggestion": {
                width: 148,
            }
        }
    },
    infoSuggestion: {
        display: "flex",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        border: "solid 1px #16c88b",
        backgroundColor: "#ffffff",
        padding: "4px 15px",
        borderRadius: 5,
        lineHeight: 1,
        width: 140,
        marginLeft: "auto",
        marginBottom: 4,
        marginRight: 2,
        "& >*": {
            display: "inline-block",
            verticalAlign: "middle",
            fontSize: 12,
            lineHeight: 1,
        },
        "& img": {
            marginRight: 5,
            height: 13
        },
        "& span": {
            marginTop: 1,
        }
    },
    locationRow: {
        margin: "15px -20px 0 -20px"
    },
    locationCol: {
        padding: "0 20px",
        width: "20%",
        display: "inline-block",
        verticalAlign: "top"
    },
    locationColInner: {
        border: "1px solid #000",
        height: 150,
        borderRadius: 10,
        padding: 15,
        position: "relative",
        fontSize: 16,
    },
    locationTitle: {
        color: "#000"
    },
    locationBatch: {
        position: "absolute",
        left: 0,
        bottom: 15,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        padding: "0 15px",
        color: "#8a8a8e",
        "& span": {
            fontWeight: 500,
            color: "#000"
        }
    },
    locationColYellow: {
        border: "solid 1px #ffc27a"
    },
    locationColBlue: {
        border: "solid 1px #16c88b"
    },
    infoSuggestionPos: {
        position: "absolute", right: 25, bottom: 0
    },
    historicalData: {
        maxHeight: "100px",
        overflow: "auto",
        paddingRight: 5,
        "& >a": {
            display: "block",
            borderBottom: "solid 0.5px #d9d9d9",
            paddingRight: 60,
            marginTop: 10,
            fontSize: 13,
            color: "#000"
        }
    },

    suggestionBoxTitle: {
        position: "relative",
        textAlign: "right",
        color: "#979797",
        "& img": {
            width: 13,
            height: "auto"
        }
    },
    suggestionBoxClose: {
        position: "absolute",
        right: 0,
        top: 0,
        width: 15,
        height: 15,
        cursor: "pointer",
        padding: 3,
        lineHeight: 1,
        "& svg": {
            width: "100%",
            height: "100%",
            "& path": {
                stroke: "#d9d9d9"
            }
        }
    },
    lastSalesPrice: {

    },
    customUnitPrice: {
        position: "relative"
    },
    salesSelfBill: {
        customDescription: {
            "& .MuiOutlinedInput-root": {
                padding: "10px",
                height: 75
            },
        }
    },
    customDescription: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: "rgb(177 177 177 / 75%) !important",
            borderWidth: 1,
            '&::hover': {
                borderColor: "rgb(177 177 177 / 75%) !important",
                borderWidth: 1,
            }
        },
        "& .MuiOutlinedInput-root": {
            padding: "10px"
        },
        '& .Mui-focused': {
            borderColor: "rgb(177 177 177 / 75%) !important",
            borderWidth: 1,
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: "rgb(177 177 177 / 75%) !important",
                borderWidth: 1,
            }
        }
    },
    textAreaLableColorCustom: {
        color: '#8a8a8e',
        fontSize: "14px",
        '&.MuiFormLabel-filled': {
            transform: "translate(14px, 7px) scale(0.85)"
        },
        '&.Mui-focused': {
            transform: "translate(14px, 7px) scale(0.85)",
        },
        '&+.MuiInputBase-root': {
            marginTop: "14px",
            borderColor: "rgba(0, 0, 0, 0.42) !important",
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: "rgba(0, 0, 0, 0.42) !important",
                }
            },
        }
    },
    textAreaLableColorUpload: {
        color: '#8a8a8e',
    },
    customLogoLink: {
        position: "absolute",
        left: 0,
        top: 0,

        marginTop: "20px",
        marginLeft: "20px",
        cursor: "pointer",
        zIndex: 1,
    },
    customLogo: {
        width: "125px",
        height: "auto",
    },
    selectOptions: {
        border: 'none',
        "& .MuiSelect-select": {
            border: 'none',
            position: "relative",
            zIndex: 1,
            paddingTop: 0,
            paddingBottom: 0, fontSize: 13
        }
    },
    primaryNavbar: {
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        minHeight: '50px',
        padding: "0 20px"

    },
    dropdownStyle: {
        border: "solid 1px #14a4c2",
        borderRadius: '5px',
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        '& .Mui-selected': {
            backgroundColor: '#fff !important',
            color: "#14A4C2"
        },
        '& .MuiMenu-list': {
            padding: '0 0 12px 0',
        },
        '& .MuiMenuItem-root': {
            backgroundColor: '#fff !important',
            minHeight: 0,
            padding: "12px 5px 0 5px",
            fontSize: 14,
            '&:hover': {
                backgroundColor: '#e8f6f9 !important'
            },
        },
        "& .MuiAutocomplete-noOptions": {
            padding: "5px 10px",
            fontSize: 12
        },
        '&.MuiMenu-paper': {
            maxHeight: 200
        }
    },
    dropDownHighlight: {
        '& .MuiSelect-select': {
            fontSize: 13
        },
        '& .MuiInputBase-input:focus': {
            backgroundColor: '#00000000'
        }
    },
    iconStyle: {
        position: 'absolute',
        right: '0px',
        top: 0,
        transfrorm: "translateX(-50%)",
        pointerEvents: 'none'
    },
    addressDropdown: {
        border: "solid 1px #14a4c2",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: '5px'
    },
    customPdfViewer: {
        position: "relative"
    },
    customVideoViewerMain: {},
    customPdfViewerMain: {
        height: "100%",
        overflow: "hidden",
        overflowY: "auto",
        "&$customVideoViewerMain": {
            position: "relative",
            "&::before": {
                content: "''",
                display: "block",
                paddingTop: "56.25%"
            },
            overflow: "hidden",
            "& $hamburgerMenu": {
                display: "none"
            }
        },
        "& $hamburgerMenu": {
            // backgroundColor: "#fff",
            backgroundImage: `url(${whiteCross})`,
            top: 22,
            transform: "none",
            right: 25,
            padding: "10px 40px 10px 40px"
        },
        "& iframe": {
            width: "100%",
            height: "100%",
            border: "none",
            borderRadius: 15,
            position: "absolute",
            top: 0,
            left: 0,
        },
        "&:hover  $customPdfViewerbutton": {
            opacity: 1,
            visibility: "visible",
        }
    },
    customPdfViewerbutton: {
        opacity: 0,
        visibility: "hidden",
        top: 0,
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#fff",
        boxShadow: "0 30px 40px 0 rgba(16, 36, 94, .2)",
        borderRadius: 4,
        transition: "opacity .4s, visibility .4s",
        zIndex: 99,
        "& span$pdfPreview": {
            padding: 10,
            fontSize: 22,
            cursor: "pointer"
        },
        "& span$pdfNext": {
            padding: 10,
            fontSize: 22,
            cursor: "pointer"
        }
    },
    pdfPreview: {

    },
    pdfNext: {

    },
    boxBorderImport: {},
    boxBorderInner: {},
    chartDivClient: {},
    clientsCircle: {
        position: "absolute",
        content: "''",
        top: 109,
        left: 125,
        width: 100,
        height: 100,
        backgroundColor: "#fff",
        zIndex: 9,
        borderRadius: "50%"
    },
    chartDiv: {
        position: "relative",
        padding: "18px 40px",
        height: "100%",
        "&$mobileDevice": {
            padding: "15px"
        },
        "&$chartDivClient": {
            padding: "20px 20px 20px 40px",
            "& foreignObject": {
                overflow: "visible"
            },
            "& .apexcharts-legend": {
                marginRight: 0
            },
            "& $chartDivDownload": {
                right: 23
            }
        },
        "& svg:not(:root)": {
            overflow: "visible"
        },
        "& .apexcharts-toolbar": {
            "& > div": {
                transform: "scale(.7)",
                marginRight: 7,
                "& img": {
                    width: 21,
                    height: "auto"
                },
                "&.apexcharts-pan-icon": {
                    "& img": {
                        width: 19,
                    }
                },
                "&.apexcharts-menu-icon": {
                    opacity: 0
                },
            }

        }
    },
    invoiceAmount: {
        position: "absolute",
        left: "-14%",
        top: "50%",
        transform: 'translateY(-50%) rotate(-90deg)',
        backgroundColor: "#e8f6f9",
        fontSize: 12,
        width: "40%",
        textAlign: "center",
        color: "#1c314c",
        borderRadius: "110px 110px 0 0",
        padding: "1.5px"
    },
    invoiceCounts: {
        position: "absolute",
        right: "-14%",
        top: "50%",
        transform: 'translateY(-50%) rotate(-90deg)',
        backgroundColor: "#e8f6f9",
        fontSize: 12,
        width: "40%",
        textAlign: "center",
        color: "#1c314c",
        borderRadius: "0 0 110px 110px",
        padding: "1.5px"
    },
    invoiceMonths: {
        position: "absolute",
        bottom: 12,
        width: "70%",
        textAlign: "center",
        backgroundColor: "#e8f6f9",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "0 0 110px 110px",
        color: "#1c314c",
        fontSize: 12,
        padding: "1.5px"
    },
    invoiceMonthsClients: { bottom: 22 },
    boxBorder: {
        border: '1px solid #14A4C2',
        paddingTop: "62%",
        borderRadius: "10px",
        boxShadow: "0 2px 5px 0 #8AC8D5",
        position: "relative",
        "& $boxBorderInner": {
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            "& > div": {
                height: "100%",
            },
            "& .swiper": {
                position: "static"
            },
            "& $loadMoreCircle": {
                height: "100%",
                "&:before": {
                    top: "50%",
                    marginTop: "-17px",
                    transform: "translate(-50%, -50%)"
                }
            },
            "& .swiper-pagination-bullets.swiper-pagination-horizontal": {
                left: "20px !important"
            }
        },
        "&$boxBorderImport": {
            position: "relative"
        },
        "& .swiper": {
            height: "100%",
            "& .swiper-wrapper": {
                height: "100%",
                "& .swiper-slide": {
                    height: "100%",

                }
            },
        },

    },
    boxBorderH: {
        border: '1px solid #14a4c2',
        height: 300,
        borderRadius: "10px",
        boxShadow: "0 2px 5px 0 #8AC8D5",
        position: "relative",
        "& $loadMoreCircle": {
            height: "100%",
            "&:before": {
                top: "50%",
                marginTop: "-17px",
                transform: "translate(-50%, -50%)"
            }
        },
        "& .swiper": {
            height: "100%",
            position: "static"
        },
        "& .swiper#swiper-net_gst_15": {
            height: "auto",
        }
    },
    overFolwBigContent: {
        overflow: "auto",
        paddingRight: 5,
        overflowX: "hidden",
    },
    heightAuto: { height: "auto" },
    boxBorder1: {
        '& .MuiGrid-container': {
            position: "relative",
            border: '1px solid #14a4c2',
            borderRadius: '10px',
            height: "calc(100dvh - 35px)",
            minHeight: 350,
            boxShadow: '0 3px 6px 0 rgba(20, 164, 194, 0.16), inset 0 3px 6px 0 rgba(20, 164, 194, 0.16)',
            overflow: "hidden"
        },
        '&$heightAuto': {
            '& .MuiGrid-container': {
                height: "auto"
            }
        }
    },
    logoImg: {
        height: 30,
        width: 'auto'
    },
    CloseIcon: {
        position: 'absolute',
        bottom: '-10px',
        right: '0',
        transition: '0.3s all ease',
        '&:hover': {
            transform: 'scale(1.3)'
        },
    },
    selectedLineView: {
        "& .MuiTableCell-root": {
            borderTop: "12px solid #000",
            padding: "0 10px 0 10px"
        }
    },
    selectedIconView: {
        // position: 'absolute',
        // top: "50%",
        // left: 0,
        // transform: "translateY(-50%)",
        // marginLeft: -30
    },
    listTableMargin: {
        margin: '0px 40px 20px 40px',
        '& $List': {
            listStyle: "none",
            marginRight: "-6px !important"
        },
        '&$minHeight0': {
            '& .ant-card': {
                minHeight: '0 !important',
            },
        },
    },
    listTableMargin2: {
        margin: '25px 40px 0px 40px',
        '&$minHeight0': {
            '& .ant-card': {
                minHeight: '0 !important',
            },
        },
    },
    dropDownadjust: {},
    MenuColors: {
        border: '1px solid #14A4C2',
        borderRadius: '5px',
        position: "relative",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        width: "180px",
        overflow: "hidden",
        '& li': {
            position: "relative",
            backgroundColor: "#fff",
        },
        '& .ant-dropdown-menu-item:hover': {
            backgroundColor: "#e8f6f9"

        },
        '& .ant-dropdown-menu-submenu-title:hover': {
            backgroundColor: "#e8f6f9",
        }
    },
    notificationDropDown: {
        "&.ant-dropdown-show-arrow.ant-dropdown-placement-bottomRight": {
            width: "640px",
            border: '1px solid #14A4C2',
            borderRadius: '5px',
            position: "relative",
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            padding: "10px !important",
            backgroundColor: "#fff"
        }
    },
    bigMenuColors: {
        width: "100%",
        maxHeight: "229px",
        overflow: "auto",
        boxShadow: "none",
        position: "relative",
        zIndex: 11,
        padding: "0 10px !important",
        '& li.ant-dropdown-menu-item': {
            padding: "10px 0px 0",
            whiteSpace: "normal",
            display: "block"
        },
        '& li.ant-dropdown-menu-item:first-child': {
            textAlign: "right",
            padding: "0",
            fontSize: "13px",
            "&:hover": {
                backgroundColor: "#fff !important"
            }
        },
        '& li .ant-row': {
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
            paddingBottom: "5px",
        },
        '& li:last-child .ant-row': {
            borderBottom: "none",
        }
    },
    accordionMenu: {
        border: '1px solid #14A4C2',
        borderRadius: '5px',
        position: "relative",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        margin: '5px -15px 0 -85px !important',
        overflow: "hidden",
        '& li': {
            padding: '5px 10px',
            backgroundColor: '#fff',
        },
        '& .ant-dropdown-menu-item:hover': {
            backgroundColor: "#e8f6f9"
        },
    },
    groupMenu: {
        border: '1px solid #14A4C2',
        borderRadius: '5px',
        position: "relative",
        // padding: "1px !important",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        margin: '5px -15px 0 -85px !important',
        '& li': {
            // backgroundColor: '#fff',
            padding: '0'
        },
        '& li a': {
            padding: '5px 10px 6px 20px',
            display: 'block',
        },
        '& .ant-dropdown-menu-item:hover': {
            backgroundColor: "#e8f6f9"
        },
    },
    groupMenuSales: {
        border: '1px solid #14A4C2',
        borderRadius: '5px',
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        margin: '18px 280px 0 -110px !important',

    },
    paymentMenu: {
        border: '1px solid #14A4C2',
        borderRadius: '5px',
        position: "relative",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        margin: '5px -15px 0 -85px !important',
        '& li': {
            padding: '10px 20px 10px 75px',
            backgroundColor: '#fff',
        },
        '& .ant-dropdown-menu-item:hover': {
            backgroundColor: "#e8f6f9"
        },
    },
    submenuArrow: {
        position: "absolute !important",
        width: "15px",
        height: "15px",
        border: '1px solid #14A4C2',
        backgroundColor: "#fff !important",
        transform: "rotate(45deg) translateY(10px)",
        bottom: "100%",
        right: "5px",
        borderRadius: "0 !important",
        marginTop: "0  !important",
        padding: "0",
        '&::hover': {
            backgroundColor: "#fff !important",
        }
    },
    parentDropDown: {
        backgroundColor: 'red'
    },
    '&.ant-dropdown-placement-topRight': {
        '& $accordionSubmenuArrow': {
            bottom: "0",
        }
    },
    accordionSubmenuArrow: {
        display: "none",
        position: "absolute !important",
        width: "12px",
        height: "12px",
        border: '1px solid #14A4C2',
        backgroundColor: "#fff !important",
        transform: "rotate(45deg) translateY(10px)",
        bottom: "101%",
        right: "2px",
        borderRadius: "0 !important",
        marginTop: "0  !important",
        padding: "0 !important",
        borderBottom: 0,
        borderRight: 0
    },
    subMcls: {
        border: '1px solid #000'
    },
    ProductGrid: {
        position: 'relative',
        marginTop: '10px'
    },
    Col: {
        display: 'inline-block',
        padding: '0 30px',
        verticalAlign: 'middle'
    },
    Col3: {
        width: '30%'
    },
    Col7: {
        width: '70%'
    },
    ProductTop: {
        backgroundColor: '#8ac8d5',
        padding: '11px 15px',
        borderRadius: '9px 9px 0 0',
        fontSize: '16px',
        fontWeight: '500',
        color: '#1c314c',
        position: 'relative',
        '&::before': {
            content: '""',
            top: '-2px',
            left: '-2px',
            position: 'absolute',
            width: 'calc(100% + 4px)',
            height: 'calc(100% + 4px)',
            borderRadius: '9px 9px 0 0',
            backgroundColor: '#8ac8d5',
        },
        '& span': {
            position: "relative"
        }
    },
    productGridParent: {
        padding: '20px',
        '& $ProductGrid:first-child': {
            marginTop: 0,
        },
        '& $Col': {
            padding: '0 10px',
        },
    },
    productsParent: {

    },
    ProductImg: {
        '& > .ant-image': {
            width: '60px',
            height: 'auto'
        }
    },
    ProductName: {
        color: '#317787',
        lineHeight: '1.5',
        fontWeight: 500
    },
    addressSmall: {
        color: "#14a4c2",
        fontSize: 14,
        "& span": {
            marginTop: 5,
        },
        "& > *": {
            display: "inline-block",
            verticalAlign: "middle",
            lineHeight: 1,
        }
    },
    catalogueRefresh: {
        width: 18,
        height: 'auto',
        marginLeft: 7
    },
    Error404: {
        fontSize: "60px",
        textAlign: "center"
    },
    disInline: {
        display: "inline-block"
    },
    disBlock: {
        display: 'block'
    },
    primaryMenuColor: {
        padding: "15px 15px 0 15px",
        cursor: "pointer",
        '& a': {
            color: "#1c314c !important",
            fontWeight: 500
        }

    },
    cardAddMoreBtn: {
        position: "absolute",
        right: 24,
        bottom: 24
    },
    customRadioButtonRight: {
        "& .MuiFormControlLabel-root": {
            marginTop: 10
        },
        "& .MuiFormControlLabel-root:first-child": {
            marginTop: 0
        }
    },
    errorBarcode: {
        position: "absolute",
        color: "#d32f2f",
        bottom: "-8px",
        left: 0
    },
    loading: {
        position: "relative",
        pointerEvents: "none",
        backgroundColor: "rgb(252 179 100 / 50%)",
        '& .MuiTouchRipple-root': {
            position: "absolute",
            border: "3px solid #317787",
            borderTop: "3px solid #F5F5F5",
            borderRadius: " 50%",
            width: "21px",
            height: "21px",
            animation: "spin 2s linear infinite",
            top: "50%",
            left: "50%",
            marginTop: "-10px",
            marginLeft: "-10px",
        }
    },
    loadingA: {
        position: "relative",
        pointerEvents: "none",
        backgroundColor: "rgb(252 179 100 / 50%)",
        "&>*": {
            display: "none"
        },
        '&:after': {
            content: "''",
            position: "absolute",
            border: "3px solid #317787",
            borderTop: "3px solid #F5F5F5",
            borderRadius: " 50%",
            width: "21px",
            height: "21px",
            animation: "spin 2s linear infinite",
            top: "50%",
            left: "50%",
            marginTop: "-10px",
            marginLeft: "-10px",
        }
    },
    loadingForm: {
        position: "relative",
        pointerEvents: "none",
        '&:before': {
            content: "''",
            backgroundColor: "rgb(255 255 255 / 70%)",
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            zIndex: 9999
        },
        '&:after': {
            content: "''",
            position: "absolute",
            border: "3px solid #317787",
            borderTop: "3px solid #F5F5F5",
            borderRadius: " 50%",
            width: "21px",
            height: "21px",
            animation: "spin 2s linear infinite",
            top: "50%",
            left: "50%",
            marginTop: "-10px",
            marginLeft: "-10px",
            zIndex: 99999
        }
    },
    textUpper: {
        textTransform: "uppercase"
    },
    textCapital: {
        textTransform: "capitalize"
    },
    sortCol: {},
    sortColParent: {
        padding: "16px",
        "&:first-child": {
            padding: "16px 16px 16px 0",
            "& $sortCol": {
                padding: "0"
            }
        }
    },
    customAutocomplete: {
        '& .MuiAutocomplete-popupIndicatorOpen': {
            right: "15px"
        },
        '& .MuiAutocomplete-inputRoot': {
            paddingRight: "20px !important"
        },
        '& .MuiInput-input': {
            fontSize: "14px",
            position: "relative",
            backgroundColor: "transparent",
            zIndex: 99,
        },
        "& $textFieldColor": {

        },
        '&$customAutocompleteBorder': {
            "& .Mui-disabled": {
                '&.MuiInputLabel-root.MuiInputLabel-formControl': {
                    color: "#d9d9d9"
                },
                '&.MuiInput-root.MuiInput-underline': {
                    boxShadow: 'none',
                    border: "solid 0.5px #d9d9d9",
                    borderRadius: '4px',
                    marginTop: "15px",

                    "& path": {
                        stroke: "#d9d9d9"
                    },
                    '&::before': {
                        borderBottom: 'none !important',
                    },
                },
            },
            '& .MuiInput-root.MuiInput-underline': {
                boxShadow: '0 1px 5px 0 #8ac8d5',
                border: ' solid 1px #14a4c2',
                borderRadius: '4px',
                marginTop: "15px",
                "&.Mui-error": {
                    border: "solid 1px #d32f2f !important",
                    boxShadow: "0 1px 5px 0 rgb(211 47 47 / 30%)",
                    "& path": {
                        stroke: "#d32f2f"
                    },
                },
                '&::before': {
                    borderBottom: 'none !important',
                },
            },
            '& .MuiFormControl-root.MuiFormControl-fullWidth': {
                marginTop: '-15px',
            },
            '& .MuiInputLabel-root.MuiInputLabel-formControl': {
                paddingLeft: '10px',
                fontSize: '13px',
                color: 'rgb(0, 0, 0, 0.87)',
            },
            '& .MuiInputLabel-root.MuiInputLabel-shrink': {
                display: 'none',
            },
            '& .MuiAutocomplete-endAdornment': {
                paddingRight: '7px'
            },
            '& .MuiInput-input.MuiInputBase-input': {
                padding: '2px 0 2px 10px',
            },
            '& .MuiAutocomplete-clearIndicator': {
                paddingRight: '15px'
            }
        },
    },
    deletePopup: {
        '& $modalBtn': {
            margin: "0px 15px 0 0"
        },
        '& > .ant-modal-content,.ant-modal-footer': {
            borderRadius: '15px',
        },
        '& .ant-modal-header': {
            borderBottom: '2px solid #ffa539',
            borderRadius: '15px 15px 0 0',
        },
        "&$textAlignCenter": {
            '& .ant-modal-footer': {
                textAlign: 'center',
            }
        },
        '& .ant-modal-footer': {
            borderTop: 'none',
            textAlign: 'left',
            padding: '10px 24px 20px'
        },
        '& .anticon.anticon-close': {
            transition: '0.3s all ease',
            '& svg': {
                width: '20px',
                height: 'auto',
                color: '#1c314c',
            },
            '&:hover': {
                transform: 'scale(1.1)'
            },
        },
    },
    addButon: {},
    gridColoumQuantity: {
        position: "absolute",
        top: "100%",
        left: 0,
        width: "100%",
        borderRadius: "0 0 4px 4px",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.25)",
        overflow: "hidden",
        height: 18,
        "& .ant-image": {
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            lineHeight: 1,
            cursor: "pointer",
            "&$addButon": {
                right: 0,
                left: "auto"
            },
            "& .ant-image-img": {
                height: "100%",
                width: "auto"
            }
        },
        "& .MuiInputBase-root": {
            "& input": {
                padding: "4px 22px",
                height: "100%",
                lineHeight: 1,
                fontSize: 12,
                textAlign: "center"
            },
            "&:before": {
                border: "none !important"
            }
        }
    },
    filterViewParent: {
        "& $customLink": {
            display: "inline-block",
        }
    },
    filterView: {
        border: "1px solid #14A4C2",
        boxShadow: "0 3px 6px 0 rgb(20 164 194 / 16%), inset 0 3px 6px 0 rgb(20 164 194 / 16%)",
        borderRadius: 10,
        padding: 24,
        height: "100%",
        "& $customLink": {
            position: "absolute",
            top: "50%",
            right: 0,
            transform: "translateY(-50%)"
        },
        "& $categoryDropDownScroll": {
            height: "calc(100% - 55px)",
            padding: 0,
            width: 300
        }
    },
    gridColoumSub: {

    },
    gridColoumAdd: {

    },
    filterViewPopover: {
        "& .MuiPaper-root": {
            height: "65%"
        }
    },
    // cancelPopup: {
    //     '& $modalBtn': {
    //         margin: "25px 15px 0 0"
    //     },
    //     '& .ant-modal-body': {
    //         padding: '30px',
    //     },
    //     '& > .ant-modal-content,.ant-modal-footer': {
    //         borderRadius: '15px',
    //     },
    //     '& .ant-modal-header': {
    //         borderBottom: '2px solid #ffa539',
    //         borderRadius: '15px 15px 0 0',
    //         padding: '25px 24px 17px',
    //     },
    //     '& .ant-modal-footer': {
    //         borderTop: 'none',
    //         textAlign: 'left',
    //         padding: '10px 24px 35px'
    //     },
    //     '& .ant-modal-title':{
    //         fontSize: '24px'
    //     },
    // },
    labelWidth50: {
        width: '50%'
    },
    PrimaryCard2RowAlign: {
        margin: '15px 0',
        justifyContent: 'flex-end'
    },
    marginLeft0: {
        marginLeft: '0'
    },
    PrimaryCard2: {
        backgroundColor: '#8ac8d5',
        fontSize: '16px',
        padding: '13px 25px',
        margin: '50px -20px 0',
        boxShadow: '0 3px 6px 0 #00000029'

    },
    licenseUsed: {
        marginRight: "50px"
    },
    userLimit: {

    },
    fieldwith180: {
        minWidth: 180
    },
    disabled: {
        pointerEvents: "none",
        opacity: .2
    },
    marginBottom20: {
        marginBottom: '20px'
    },
    width100p: {
        width: '100%',
        "& .ant-image": {
            width: '100%',
        },
    },
    width200: {
        width: 200
    },
    width250: {
        width: 250
    },
    width25: {
        width: '25%',
    },
    width100: {
        width: 100
    },
    width130: {
        width: 130
    },
    width150: {
        width: 150
    },
    textAreaOverflow: {
        resize: 'none',
        height: '94px !important',
        width: '100%',
        padding: '5px 12px'
    },
    overflowXHidden: {
        overflowX: 'hidden',
    },
    ExpandRotate: {
        transform: 'none'
    },
    flexStart: {
        alignItems: 'flex-start'
    },
    dropDownBorder: {
        boxShadow: '0 3px 6px 0 rgb(20 164 194 / 16%)',
        border: 'solid 1px #14a4c2',
        borderRadius: '6px',
        '& .MuiSelect-select': {
            padding: 0
        },
        '&.MuiInput-underline': {
            '&::before': {
                content: 'none'
            },
        },
        '& svg': {
            right: "10px !important"
        }
    },
    dateAdjust: {
        paddingLeft: '0 !important',
        '& .MuiOutlinedInput-root': {
            borderRadius: 0,
            padding: 0,
            marginTop: "14px !important",
            '&.Mui-error': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderBottom: '1px solid #d32f2f !important',
                }
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: '0',
                borderBottom: '1px solid rgb(177 177 177 / 75%) !important',
                padding: 0
            },
            '& .MuiInputBase-input': {
                padding: '4px 0 5px',
                fontSize: 13,
                '&.Mui-disabled': {
                    color: "rgba(0, 0, 0, 0.87) !important",
                    WebkitTextFillColor: "rgba(0, 0, 0, 0.87) !important",
                }
            },
            '&.Mui-disabled': {
                color: "rgba(0, 0, 0, 0.87) !important",
                WebkitTextFillColor: "rgba(0, 0, 0, 0.87) !important",
            }
        },
        '& .MuiInputLabel-root': {
            fontSize: 13,
            color: '#d9d9d9',
            transform: "translate(0, 20px) scale(1)",
            "&.MuiInputLabel-shrink": {
                color: '#8a8a8e',
            },
            '&.MuiFormLabel-filled': {
                transform: "translate(0, -1.5px) scale(1)"
            },
            '&.Mui-focused': {
                transform: "translate(0, -1.5px) scale(1)",
                color: '#FCB364 !important',
            },
        },
        '& .MuiInputLabel-shrink': {},
        '& .MuiFormControl-root': {
            width: '100%'
        },
        '& .MuiInputAdornment-root ': {
            '& .MuiButtonBase-root': {
                padding: 0,
                margin: 0,
                '& .cls-1': {
                    fill: '#fff',
                    stroke: '#14a4c2',
                },
                '& .cls-2, .cls-4 ': {
                    fill: 'none',
                },
                '& .cls-2': {
                    stroke: '#ffa539',
                    strokeLinecap: 'round',
                },
                '& .cls-3': {
                    stroke: ' none'
                },
            },
        },
        '& .MuiFormHelperText-root': {
            margin: 0
        }
    },
    dateAdjustBatch: {
        "&$dateAdjust": {
            paddingLeft: '0 !important',
            '& .MuiOutlinedInput-root': {
                marginTop: "0px !important",
                backgroundColor: "#e8f6f9", padding: "0px 5px", borderRadius: 4,
                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                    padding: 0,
                    borderBottom: 'none !important',
                },
            }
        },
    },
    dateAdjustToDate: {
        "& label": {
            paddingLeft: "10px !important"
        },
        "& input": {
            paddingLeft: "10px !important"
        },
    },
    dateFilterdateAdjustUpdated: {
        '& .MuiOutlinedInput-root ': {
            borderRadius: '6px',
            border: 'solid 1px #14a4c2 !important',
            boxShadow: '0 1px 5px 0 #8ac8d5',
            padding: 0,
            '& .MuiOutlinedInput-notchedOutline': {
                border: '0',
                padding: 0
            },
            '& .MuiInputBase-input': {
                padding: '4px 0 4px 6px',
                fontSize: '13px'
            },
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
            color: '#8a8a8e',
            transform: "translate(0, 20px) scale(1)",
            '&.MuiFormLabel-filled': {
                transform: "translate(0, -1.5px) scale(0.85)"
            },
            '&.Mui-focused': {
                transform: "translate(0, -1.5px) scale(0.85)",
                color: '#FCB364 !important',
            },
        },
        '& .MuiInputLabel-shrink': {

        },
        '& .MuiFormControl-root.MuiTextField-root': {
            width: '100%',
            '& .MuiInputLabel-shrink': {
                display: 'none',
            },
            '& .MuiInputLabel-root': {
                position: 'absolute',
                top: '-14px',
                left: '8px',
                fontSize: '13px',
                color: '#000',
            },
        },
        '& .MuiInputAdornment-root ': {
            '& .MuiButtonBase-root': {
                padding: '0 5px 0 10px',
                margin: 0,
                '& .cls-1': {
                    fill: '#fff',
                    stroke: '#14a4c2',
                },
                '& .cls-2, .cls-4 ': {
                    fill: 'none',
                },
                '& .cls-2': {
                    stroke: '#ffa539',
                    strokeLinecap: 'round',
                },
                '& .cls-3': {
                    stroke: ' none'
                },
            },
        },
    },
    dateFilterdateAdjust: {
        position: "absolute",
        top: "100%",
        left: 0,
        zIndex: 999,
        '& .MuiOutlinedInput-root ': {
            borderRadius: '6px',
            border: '1px solid #8AC8D5 ',
            padding: 0,
            '& .MuiOutlinedInput-notchedOutline': {
                border: '0',
                padding: 0
            },
            '& .MuiInputBase-input': {
                padding: '4px 0 4px 6px',
                fontSize: '13px'
            },
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
            color: '#8a8a8e',
            transform: "translate(0, 20px) scale(1)",
            '&.MuiFormLabel-filled': {
                transform: "translate(0, -1.5px) scale(0.85)"
            },
            '&.Mui-focused': {
                transform: "translate(0, -1.5px) scale(0.85)",
                color: '#FCB364 !important',
            },
        },
        '& .MuiInputLabel-shrink': {

        },
        '& .MuiFormControl-root.MuiTextField-root': {
            width: '50%',
            '& .MuiInputLabel-shrink': {
                display: 'none',
            },
            '& .MuiInputLabel-root': {
                position: 'absolute',
                top: '-14px',
                left: '8px',
                fontSize: '13px',
                color: '#000',
            },
        },
        '& .MuiInputAdornment-root ': {
            '& .MuiButtonBase-root': {
                padding: '0 5px 0 10px',
                margin: 0,
                '& .cls-1': {
                    fill: '#fff',
                    stroke: '#14a4c2',
                },
                '& .cls-2, .cls-4 ': {
                    fill: 'none',
                },
                '& .cls-2': {
                    stroke: '#ffa539',
                    strokeLinecap: 'round',
                },
                '& .cls-3': {
                    stroke: ' none'
                },
            },
        },
    },
    textAreaAdjust: {
        '& .MuiOutlinedInput-root': {
            border: '1px solid rgb(177 177 177 / 75%)',
            borderRadius: "5px",
            padding: '9px 14px',
            '&.Mui-error': {
                borderColor: "#d32f2f"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: '0',
            }
        },
        '& .MuiFormHelperText-root': {
            margin: "0 !important"
        }
    },
    fieldAdjust: {
        border: 'solid 1px rgba(151, 151, 151, 0.75)',
        '&.MuiInputBase-root': {
            '&:hover': {
                border: 'none',
            },
            '& .Mui-focused': {
                border: 'none',
            },
        },
    },

    searchInputpadding: {},
    searchInput: {
        '& .Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                display: "none"
            }
        },
        '& .MuiOutlinedInput-notchedOutline': {
            display: "none"
        },
        '&$searchInputpadding': {
            '& $textFieldLableColorCustom': {
                '&+.MuiInputBase-root': {
                    marginTop: "0px"
                }
            },
            '& .MuiInputLabel-root': {
                position: "relative",
                transform: "none"
            },
            '& .MuiSelect-select.MuiSelect-standard': {
                padding: '2px 10px'
            },
        }
    },
    dropDownPadding: {
        padding: '0 15px',
    },
    selectPadding: {
        padding: '4px 10px',
        '&.MuiInput-underline': {
            marginTop: '5px'
        },
        '& .MuiInput-input': {
            padding: '4px 10px'
        }
    },
    margin5b: {
        marginBottom: 5
    },
    borderTop0: {
        borderTop: '0 !important '
    },
    labelShrinkColor: {
        color: '#B9B9B9'
    },
    productFormImageRow: {},
    removeUnderline: {
        '& $comInput': {
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            border: '2px solid #14A4C2',
            borderRadius: '20px',
            padding: '0 15px',
            '& > .MuiInput-root::before, & > .MuiInput-root::after': {
                borderBottom: '0 !important'
            },
            '& > .MuiInput-root:hover:not(.Mui-disabled):before,  & > .MuiInput-root:hover:not(.Mui-disabled):after': {
                borderBottom: '0 !important'
            },
            '& input': {
                padding: '3px 0',
                fontSize: '14px',
                width: '300px',
            },
            '& .ant-image-img': {
                width: '13px',
            }
        },
        '& .MuiInput-root': {
            '&::after': {
                borderBottom: "1px solid transparent"
            },
            '&.Mui-error': {
                '&::after': {
                    borderBottomColor: "#d32f2f"
                },
            },
            "&.Mui-disabled": {
                '&::before': {
                    borderBottom: "1px solid #d9d9d9 !important"
                }
            },
            '&::before': {
                borderBottom: "1px solid rgb(177 177 177 / 75%) !important"
            },
        },
        "&$registerPage": {
            '& .ant-row': {
                alignItems: "flex-start"
            },
        },
        '& $productFormImageRow': {
            '&.ant-row': {
                alignItems: "end"
            },
        }
    },
    removeUnderlineImport: {
        '& .MuiInput-root': {
            '&::after': {
                borderBottom: "1px solid transparent"
            },
            '&.Mui-error': {
                '&::after': {
                    borderBottomColor: "#d32f2f"
                },
            },
            '&::before': {
                borderBottom: "1px solid rgba(0, 0, 0, 0.42) !important"
            }
        },
        "& $btnParent": {
            margin: "10px 0 0 0",
            padding: "10px 0",
            boxShadow: "none"
        }
    },
    colorLine: {
        paddingRight: "5px",
        position: "relative",
        "&::after": {
            content: '""',
            position: "absolute",
            top: "50%",
            right: 0,
            transform: "translateY(-50%)",
            height: "100%",
            width: "2px",
            backgroundColor: "#FCB364"
        }
    },
    opaCity: {
        "& select": {
            opacity: "0.1"
        },
    },
    dropDownPointer: {
        '& .MuiFormGroup-root': {
            flexWrap: "nowrap",
            WebkitBoxFlexWrap: "nowrap",
            WebkitFlexWrap: "nowrap",
            MsFlexWrap: "nowrap"
        },
        '& .MuiInputBase-input': {
            position: 'relative',
            zIndex: '1'
        },
    },
    backgroundWhite: {
        backgroundColor: '#FFFFFF !important'
    },
    closeBackGround: {
        '& .MuiIconButton-root': {
            transition: '0.3s all ease',
            '&:hover': {
                transform: 'scale(1.3)',
                backgroundColor: 'transparent'
            },
        },
    },
    NestedDropDown: {
        position: 'relative',
        '& .ant-dropdown-menu-submenu-popup': {
            left: '30px !important',
            backgroundColor: 'red !important'
        },
    },
    menuArrowIcon: {
        '& .anticon-right': {
            width: '8px',
            height: '8px',
            borderTop: '4px solid transparent',
            borderBottom: '4px solid transparent',
            borderLeft: '6px solid #ffa539',
            fontSize: '0 !important'
        },
        '& .anticon svg': {
            display: 'none'
        },
        '& .ant-dropdown-menu-submenu-title': {
            fontWeight: '500 !important',
        },
    },
    menuPadding: {
        padding: '0px 0px 0px 19px',
        height: '20px',
        fontSize: '14px'
    },
    bgRed: {
        '& .MuiAccordionSummary-root:before': {
            backgroundColor: '#e8f6f9 !important',
        },
    },
    LightBlue: {
        color: '#8ac8d5 !important'
    },

    dropDownWidth: {
        boxShadow: '0 1px 5px 0 #8ac8d5',
        borderRadius: '4px',
        //maxHeight: '25px',
        marginTop: '10px',
        '&$margint0': {
            marginTop: '0'
        },
        '& .MuiInput-input': {
            fontSize: '13px',
            padding: '0 0 3px 10px',
        },
        '&.MuiInput-root::after': {
            borderBottom: 'none',
        },
    },
    width125: { width: '125px' },
    dateFilterwidth: {
        width: '170px',
        '& .MuiFormControl-root': {
            width: '100%'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0',
        },
        '& .MuiSelect-select': {
            textAlign: 'left',
            padding: '1px 32px 1px 10px !important',
            fontSize: "13px",
        },
        '&$width200': {
            width: '200px'
        },
        '&$width250': {
            width: '250px'
        },
        '&$width125': {
            width: '125px'
        },
        '&$width130': {
            width: '130px'
        },
    },
    nativedropdownstyle: {
        backgroundColor: '#fff',
    },
    resizeLine: {
        position: "absolute",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)",
        height: "100%",
        width: 25,
        cursor: `url(${resizeIcon}), pointer`,
        opacity: 0,
        "&:after": {
            content: "''",
            backgroundColor: "#14A4C2",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            height: "100%",
            width: 2,
            position: "absolute"
        }
    },

    borderBottom: {
        borderBottom: '1px solid rgb(112 112 112 / 35%);',
        paddingBottom: '15px',
    },
    typographyHeader: {
        color: '#14A4C2',
        fontSize: '14px',
    },
    typographyHeaderAddress: {
        height: "12px"
    },
    typographyHeaderToolTip: {
        display: "flex",
        alignItems: "center",
        lineHeight: 1,
        "& .ant-image": {
            marginLeft: 5,
            width: 14,
            height: "auto"
        }
    },
    typographyHeaderToolTipCustom: {

        "& .ant-image": {
            marginLeft: 5,
            width: 14,
            height: "auto"
        }
    },
    textAlignCenter: {
        textAlign: "center !important",
    },
    containerBorder: {
        borderRadius: '10px',
        boxShadow: '0 3px 6px 0 rgba(20, 164, 194, 0.16), inset 0 3px 6px 0 rgba(20, 164, 194, 0.16)',
        border: 'solid 1px #14a4c2',
        backgroundColor: "#fff",
        padding: "25px 25px 0 25px",
        height: "calc(100vh - 168px)",
        overflow: "hidden",
        "& > .ant-row": {
            height: "100%",
            "& > .ant-col": {
                paddingBottom: "25px",
                height: "100%",
                "&:first-child": {
                    display: "flex",
                    flexDirection: "column"
                }
            }
        },
        '& $accordionHead': {
            '& $accordionBody': {
                '& .MuiTableContainer-root': {
                    //overflow: "hidden"
                }
            }
        }
    },
    notificationOverflow: {},
    containerBorderFlex: {
        display: "flex",
        flexDirection: "column",
        padding: "15px 15px 0 15px",
        '&$notificationOverflow': {
            overflow: "hidden"
        }
    },
    addressBookContainer: {
        padding: "25px",
        "& .MuiTable-root": {
            marginTop: "20px"
        },
        "& .MuiTableCell-head": {
            padding: "10px 0"
        },
        "& .MuiTableCell-body": {
            padding: "10px",
            verticalAlign: "top",
            "&:first-child": {
                paddingLeft: "0px"
            }
        }
    },
    subTitle: {
        color: "#8a8a8e"
    },
    addressPadding: {
    },
    quickLinksOpen: {},
    mainBody: {
        whiteSpace: "nowrap",
        "& > *": {
            display: "inline-block",
            verticalAlign: "top"
        }

    },
    mainContent: {
        position: "relative",
        width: "100%",
        whiteSpace: "normal",
        transition: "width .4s",
        overflow: "hidden",
        "&$quickLinksOpen": {
            width: "calc(100% - 200px)",
            "& $listTableMargin": {
                margin: '0px 20px 20px 40px',
            }
        }
    },
    quickBtn: {
        position: "fixed",
        top: "50%",
        right: "-35px",
        backgroundColor: "#ffc27a",
        padding: "8px 7px 15px 7px",
        color: "#fff",
        lineHeight: 1,
        borderRadius: 10,
        transform: "rotate(-90deg)",
        "&:hover": {
            color: "#fff",
        }
    },
    quickBtnIn: {
        position: "absolute",
        top: "50%",
        left: "-29px",
        backgroundColor: "#ffc27a",
        padding: "8px 7px 8px 7px",
        color: "#fff !important",
        lineHeight: 1,
        borderRadius: "0 0 10px 10px",
        transform: "rotate(-90deg)",
        "&:hover": {
            color: "#fff",
        }
    },
    toggle: {},
    factBoxTitle: {
    },
    quickLinks: {
        position: "fixed",
        // height: "100vh",
        height: "100dvh",
        width: 200,
        border: "solid 1px #14a4c2",
        padding: "20px 20px 20px 35px",
        boxShadow: "0 1px 5px 0 #8ac8d5",
        backgroundColor: "#fff",
        overflow: "auto",
        zIndex: 9,
        transition: "transform .4s",
        '& $generalTitle': {
            marginBottom: '10px',
        },
        '&$toggle': {
            transform: "translateX(0)",
        },
        '& $factBoxTitle': {
            color: '#14a4c2',
            fontSize: '14px',
        },
        '& .ant-menu': {
            border: 0,
        },
        '& .ant-menu-item': {
            padding: 0, height: "auto", lineHeight: 1,
            margin: "10px 0 0 0 !important",
            color: '#317787 !important',
            '&:first-child': {
                margin: "0 !important",
            }
        },
        '& .ant-menu-item-selected': {
            backgroundColor: 'transparent !important',
        },
        '& .ant-menu-item a': {
            color: '#317787 !important',
            display: "inline-block",
            fontWeight: '500',
            '&:hover': {
                color: '#01A4A6  !important',
            }
        },
    },

    toggledisnone: {
        display: 'inline-block',
    },
    toggledis: {
        display: 'none',
    },
    toggleOpen: {},
    accordionBody: {
        transition: '.4s ease'
    },
    toggleRow: {},
    opacity: {
        opacity: 1,
        transition: 'opacity 0.4s'
    },
    opacityNone: {
        opacity: 0,
        transition: 'opacity 0.4s',
    },
    font18: {
        fontSize: '18px',
    },
    switchAlignfont14: {},
    switchAlign: {
        marginLeft: 0,
        justifyContent: 'flex-end',
        '&$switchAlignfont14': {
            '& .MuiFormControlLabel-label': {
                fontSize: '14px',
                color: '#8a8a8e',
            }
        },
    },
    switchDeleteButton: {
        marginTop: '25px',
        paddingLeft: '20px'
    },
    accordionClear: {},
    accordionSelectList: {},
    accordionHead: {
        boxShadow: '0 3px 6px 0 #8ac8d5',
        border: 'solid 1px #8ac8d5',
        borderRadius: '10px',
        height: "100%",
        overflow: "hidden",
        "& $accordionBody": {
            padding: "0 20px",
            height: "calc(100% - 90px)",
            '& .MuiTableContainer-root': {
                height: "100%"
            },
            "&$accordionSelectList": {
                height: "calc(100% - 120px)",
            }
        },
        '& $toggleRow': {
            padding: '20px',
            backgroundColor: '#e8f6f9',
            marginLeft: 0,
            marginRight: 0,
            borderRadius: '10px',
            lineHeight: 1,
            transition: "background-color .4s",
            "& $cursor": {
                "&>*": {
                    display: "inline-block",
                    verticalAlign: "middle"
                }
            }
        },
        '& $accordionClear': {
            position: 'absolute',
            right: '20px',
            visibility: 'hidden',
        }
    },
    accDropDownButton: {
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: "translateX(-50%)"
    },
    parenAccordion: {
        position: 'relative',
        height: "56px",
        zIndex: 3,
        transition: "boxShadow .4s, border .4s, height .4s",
        "&$toggleOpen": {
            height: "calc(100% - 185px)",
            '&$accordionHead': {
                backgroundColor: '#fff',
                height: '100%',
                transition: "backgroundColor .4s, height .4s"
            },
            '& $opacity': {
                opacity: 0,
                visibility: 'hidden',
            },
            "& $notificationDelete": {
                opacity: 1,
                visibility: 'visible',
            },
            '& $opacityNone': {
                opacity: 1,
            },
            '& $accordionClear': {
                visibility: 'visible',
            },
            '& .ant-row': {
                backgroundColor: '#fff',
                border: 'solid 1px transparent',
                boxShadow: 'none',
                '&$borderBottom': {
                    borderBottom: "1px solid rgb(112 112 112 / 35%)",
                    paddingBottom: "10px"
                }
            },
            '& $accDropDownButton': {
                transform: "translateX(-50%) rotate(180deg)",
                bottom: '0',
            },
        },
    },
    none: {
        display: "none"
    },
    topBorder: {
        '& .MuiTableRow-root': {
            borderTop: '1px solid rgb(112 112 112 / 35%)',
        },
    },
    iconPadding: {
        '& .ant-image-img': {
            height: "15px !important",
            width: "auto !important",
        },
        '& a': {
            padding: '0 0 0 20px',
            display: 'inline-block',
        },
        '& .ant-space-item > .ant-image': {
            padding: '0 0 0 20px',
            display: 'inline-block',
            cursor: "pointer",
            '& .ant-image-img': {
                width: "auto !important"
            }
        },
    },
    flexOne: {
        flex: 1,
    },
    dashRow: {
        margin: '0 -15px',
        textAlign: 'center',
        flex: 1,
        paddingBottom: "100px",
        position: "absolute",
        width: "100%",
        height: "85%",
        left: "15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap"
    },
    col_20: {
        flex: 1,
        display: 'inline-block',
        padding: '0 15px',
        position: 'relative',
        "&:nth-child(2)": {
            top: '130px',
        },
        "&:nth-child(4)": {
            top: '130px',
        },
    },
    fontsize18: {
        fontSize: '18px',
    },
    fontsize14: {
        fontSize: '14px',
    },
    dashicontext: {
        display: 'block',
        fontSize: '18px',
    },
    margint100: {
        marginTop: '100px',
    },
    marginTop50: {
        marginTop: '50px',
    },
    statusButton: {
        borderRadius: '4px',
        display: 'inline-block',
        color: '#fff !important',
        textAlign: 'center',
        backgroundColor: '#ffc27a',
        padding: '6px 11px 6px 11px',
        minWidth: "90px",
        minHeight: 26,
        lineHeight: 1,
    },
    cancelledButton: {
        backgroundColor: '#FF0000',
    },
    reversedButton: {
        backgroundColor: '#D20B0B',
    },
    confirmedButton: {
        backgroundColor: '#16c88b',
    },
    submittedButton: {
        backgroundColor: '#c4f4c7',
        color: "#000 !important"
    },
    reSubmittedButton: {
        backgroundColor: '#b5e0b8',
        color: "#000 !important"
    },
    acceptedButton: {
        backgroundColor: '#70e878'
    },
    openButton: {
        backgroundColor: '#ff6b6b !important'
    },
    fullButton: {
        backgroundColor: '#16c88b'
    },
    PrimaryNavbarbgcolor: {
        backgroundColor: '#8AC8D5'
    },
    amountBorderCenterAlign: {},
    amountBorder: {
        border: 'solid 1px #14a4c2',
        borderRadius: '6px',
        padding: '5px',
        display: "inline-block",
        '& $amountBorderCenterAlign': {
            textAlign: "center",
            "&>*": {
                display: "inline-block",
                verticalAlign: "middle",
                margin: "0 15px",
            },
            "& $textFieldColor": {
                marginLeft: 5
            }
        },
    },
    colPadingLR0: {
        '& .ant-col:first-child': {
            paddingLeft: '0 !important'
        },
        '& .ant-col:last-child': {
            paddingRight: '0 !important'
        },
    },
    amountBorder2: {
        minWidth: '100px',
        borderRadius: '5px',
        height: 'auto',
        padding: '0 5px',
        border: 'solid 1px #14a4c2',
        marginRight: 15
    },
    justifyContentCenter: {
        justifyContent: 'center'
    },
    justifyContentSpaceAround: {
        justifyContent: 'space-around',
    },
    justifyContentSpaceBetween: {
        justifyContent: 'space-between',
    },
    tableAmount: {
        borderRadius: '5px',
        backgroundColor: '#e8f6f9',
        padding: '11px 10px 10px 12px'
    },
    settleAmount: {
        borderRadius: '5px',
        backgroundColor: '#e8f6f9',
        padding: '3px 10px',
        display: 'block',
        maxWidth: '90px',
        marginLeft: 'auto',
    },
    iconorangecolor: {
        '& .MuiButtonBase-root': {
            padding: '0',
            '& .MuiSvgIcon-root ': {
                color: '#ffa539',
                width: '20px',
                height: 'auto'
            },
        },
    },
    tabWrap: {},
    tabDesign: {
        position: 'relative',
        display: 'block',
        '& .MuiTab-root.Mui-selected': {
            borderTop: 'solid 1px rgb(151 151 151 / 65%)',
            borderLeft: 'solid 1px rgb(151 151 151 / 65%)',
            borderRight: 'solid 1px rgb(151 151 151 / 65%)',
            borderBottom: 'solid 1px #fff',
            borderRadius: '10px 10px 0 0',
            position: 'relative',
            overflow: "visible",
            '& .MuiTouchRipple-root': {
                "&::before": {
                    content: '""',
                    position: 'absolute',
                    height: '2px',
                    width: '83%',
                    backgroundColor: '#FCB364',
                    bottom: '0px',
                    left: "50%",
                    transform: "translateX(-50%)",
                    transition: 'width 0.4s',
                },
            },
            "&::after": {
                content: '""',
                position: 'absolute',
                height: '1%',
                width: '10000%',
                backgroundColor: 'rgb(151 151 151 / 65%)',
                bottom: '0px',
                left: "100%",
                transition: 'width 0.4s'
            },
            "&::before": {
                content: '""',
                position: 'absolute',
                height: '1%',
                width: '10000%',
                backgroundColor: 'rgb(151 151 151 / 65%)',
                bottom: '0px',
                right: "100%",
                transition: 'width 0.4s'
            },
        },
        '& .MuiButtonBase-root.MuiTab-root': {
            minHeight: 10,
            padding: "8px 16px",
            fontSize: 13
        },
        '& .MuiTab-textColorPrimary': {
            color: '#979797',
            textTransform: "none"
        },
        '& .MuiTab-textColorPrimary.Mui-selected': {
            color: '#000',
            position: 'relative',
            '& .MuiTabs-indicator ': {
                position: 'absolute',
                left: '31px  !important',
                width: '125px  !important'
            },
        },
        '& .MuiOutlinedInput-root.MuiInputBase-root': {
            marginTop: 0,
        },
        '& $tabWrap': {
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: "translateY(-50%)",
            paddingBottom: 8,
            '& MuiTypography-root': {
                verticalAlign: 'middle',
            },
            '& $dateAdjust': {
                verticalAlign: 'middle',
                '& .MuiFormControl-root': {
                    width: '120px',
                },
            },
            '& .MuiTypography-body1': {
                marginRight: '40px'
            },
        },
        '& .MuiTabs-indicator': {
            display: 'none',
        },
    },
    tabWrapSubmit: {
        position: 'absolute',
        right: 0,
        top: "-5px",
        zIndex: 999
    },
    posDefaultCheckbox: {
        padding: 0,
        "& svg": {
            fontSize: 18
        }
    },
    dotsDropDown: {

    },
    scrollParentIcons: {},
    settlementTable: {
        '& $scrollParent': {
            '& .MuiTableCell-root': {
                padding: '10px 10px 10px 5px !important',
                fontSize: '13px',
                '& .MuiCheckbox-root': {
                    '& .MuiSvgIcon-root': {
                        width: '20px',
                        height: 'auto',
                    },
                },
            },
        }
    },
    scrollParent: {
        position: 'relative',
        '& $scrollParentIcons': {
            // '& .MuiTableCell-root': {
            //     padding: '16px',
            //     fontSize: '14px',
            // },
            // '& .MuiTableCell-root:first-child': {
            //     paddingLeft: 0,
            // },
            '& .ant-image': {
                position: 'relative',
                right: 'auto',
                top: 'auto',
                zIndex: 1,
            },
        },
        '& .ant-image': {
            position: 'absolute',
            right: '-5px',
            top: '95px',
            zIndex: 1,
        },
    },
    "& .indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
        "& > span": {
            maxWidth: 40,
            width: "100%",
            backgroundColor: "white"
        },
    },
    uploadDesign: {
        '&.MuiButton-textPrimary ': {
            width: '50%',
            padding: 0,
            marginTop: 10,
        },
    },
    addWallet: {},
    border: {
        border: "solid 1px #14a4c2",
        borderRadius: "8px",
        boxShadow: "0 2px 5px 0 #8ac8d5",
        '&$addWallet': {
            height: "calc(100% - 30px)",
            boxShadow: "0 2px 5px 0  rgba(20, 164, 194, 0.16)",
            border: "solid 1px #d9d9d9",
            '& $walletHeader': {
                boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
            },
            '& $walletBody': {
                borderTop: "solid 2px #d9d9d9",

            }
        }
    },
    walletHeader: {
        padding: "15px 20px"
    },
    walletBody: {
        padding: "15px 20px",
        borderTop: "solid 2px #14a4c2"
    },
    fontWeight400: {
        fontWeight: 400,
    },
    invoiceHeader: {
    },
    padding30LR: {
        padding: '0 30px'
    },
    borderDesign: {},
    invoiceHeaderbgColor: {},
    divToPrint: {
        position: "relative",
        overflow: "hidden", width: "100%"
    },
    divToPrintCommand: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(-45deg)",
        WebkitTransform: "translate(-50%, -50%) rotate(-45deg)",
        fontSize: 30,
        textAlign: "center",
        fontWeight: 500,
        width: "75%",
        color: "rgb(140 180 205 / 20%)",
        zIndex: 9
    },
    totalsectionAbsolute: {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
    },
    invoiceDesign: {
        '& $modalBtn': {
            margin: 0
        },
        '&.ant-modal': {
            maxWidth: 'none !important'
        },
        '& .ant-modal-body': {
            //  padding: 0
        },
        '& > .ant-modal-content,.ant-modal-footer': {
            borderRadius: '15px',
        },
        '& $divToPrint': {
            //padding: "0 24px 24px 24px"
        },
        '& $invoiceHeader': {
            position: "relative",
            marginBottom: "24px",
            //  padding: "24px 24px 0 24px",
            '& $invoiceHeaderbgColor': {
                backgroundColor: '#ffc27a',
                padding: '12px 30px',
                borderTop: '9px solid #1c314c',
                position: 'relative',
                boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
                '&::before': {
                    content: '""',
                    width: '100%',
                    position: 'absolute',
                    height: '2px',
                    backgroundColor: '#fff',
                    top: '0',
                    left: '0',
                },
            },
        },
        '& $borderDesign': {
            borderLeft: '1px solid #ffa539',
            borderRight: '1px solid #ffa539',
            borderBottom: '1px solid #ffa539',
            paddingBottom: '20px',
        },
    },
    invoiceDesignPreview: {
        height: "100%",
        "& .ant-modal-content": {
            height: "100%",
            "& .ant-modal-body": {
                height: "100%",
                "& $divToPrint": {
                    height: "calc(100% - 55px)",
                    overflowX: "hidden",
                    overflowY: "auto"
                }
            }
        }
    },
    new: {
        position: "absolute",
        top: "50%",
        right: "0",
        minWidth: "auto",
        minHeight: "auto",
        transform: "translateY(-50%)",
        backgroundColor: "#fcb364",
        color: "#fff",
        borderRadius: "2px",
        fontSize: "13px",
        padding: "2px 10px 4px 10px",
        lineHeight: 1,
        fontWeight: "normal",
    },
    uploadimage: {},
    uploadImageText: {},
    imgErrormsg: {},
    uploadButton: {
        display: "inline-block",
        verticalAlign: 'middle',
        '& .MuiButton-root': {
            textTransform: 'capitalize',
            color: '#000000',
            border: '1px solid #d9d9d9',
            borderRadius: '10px',
            fontWeight: 'normal',
            fontSize: '14px',
            backgroundColor: '#8ac8d5',
            boxShadow: '0 5px 6px 0 rgb(0 0 0 / 16%)',
            '&:hover': {
                backgroundColor: '#E8F6F9',
            },
        },
        '& .MuiBox-root': {
            display: "inline-block",
            verticalAlign: 'middle',
            marginLeft: '10px',
        },
        '& $uploadimage': {
            width: '25px',
            height: '25px',
        },
        '& $uploadImageText': {
            marginLeft: '10px',
            display: "inline-block",
            width: '200px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            verticalAlign: 'middle',
        },
        '& .ant-upload-list.ant-upload-list-picture': {
            width: '260px',
            verticalAlign: 'middle',
            marginTop: '10px',
            '& .ant-upload-list-item.ant-upload-list-item-done': {
                marginTop: 0,
                padding: 0,
                border: 'none',
            },
            '& .ant-upload-span': {
                '& .ant-upload-list-item-thumbnail': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                },
                '& .ant-upload-list-item-image': {
                    width: '25px',
                    height: '25px',
                },
            },
            '& .ant-upload-list-item.ant-upload-list-item-error': {
                border: 'none',
                padding: '0',
            }
        },
        '& $imgErrormsg': {
            color: 'rgb(255 0 0);',
            marginTop: '10px',
            width: '370px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    passwordIcon: {
        '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
            width: '20px',
            height: 'auto',
        }
    },
    dataCostAmount: {
        "& .MuiOutlinedInput-root": {
            border: "none",
            backgroundColor: "#e8f6f9",
            pointerEvents: "none",
            maxWidth: "150px",
            marginLeft: "auto"
        },
        "& .MuiInputAdornment-root": {
            "& .MuiTypography-root": {
                lineHeight: 1,
                fontSize: 15
            }
        },
        '& $textFieldColor': {
            padding: 0,
            textAlign: "right"
        }
    },
    dataCostAmountText: {
        "&$dataCostAmount": {
            "& .MuiOutlinedInput-root": {
                pointerEvents: "auto",
            }
        },
        "&$settledAmount": {
            "& .MuiOutlinedInput-root": {
                pointerEvents: "auto",
            }
        }
    },

    billingRow: {
        position: "relative",
        "&::before": {
            content: "''",
            backgroundColor: "#e8f6f9",
            width: "calc(100% - 60px)",
            position: "absolute",
            top: 60,
            left: 65,
            bottom: "-20px",
            borderRadius: 15,
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
        },
        "& .ant-row": {
            paddingRight: 70
        }
    },
    billingColsSub: {
        marginTop: 20,
        "& >*": {
            margin: 0
        }
    },
    planHeader: {
        display: "flex",
        justifyContent: "space-between",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        "& + .ant-row": {
            display: "flex",
            flexWrap: "nowrap",
            overflow: "auto",
            overflowY: "hidden",
            paddingTop: 40,
            paddingBottom: 10,
            minHeight: 360,
            "& .ant-col": {
                height: "100%"
            }
        }
    },
    billingDetails: {
        height: "100%",
        overflow: "hidden",
        overflowY: "auto",
        paddingRight: 10,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: 425
    },
    billingPlanDetails: {
        position: "relative",
        "&$loadingA": {
            backgroundColor: "#fff",
            "&::before": {
                content: "''",
                width: "100%",
                height: "100%",
                backgroundColor: "rgb(0 0 0 / 50%)",
                top: 0,
                left: 0,
                position: "absolute",
                zIndex: 9,
            },
            "&::after": {
                zIndex: 99,
            },
        },
    },
    billingCols: {
        borderRadius: 15,
        boxShadow: "0 2px 5px 0 #8ac8d5",
        border: "solid 1px #14a4c2",
        backgroundColor: "#ffffff",
        padding: 20,
        "& >*": {
            margin: "10px 0 0 0"
        }
    },
    billingFirstCols: {
        padding: "20px 20px 135px 20px",
        position: "relative"
    },

    planDetails: {
        "& $tableRoot": {
            "& .ant-card-body": {
                overflow: "auto",
                margin: "24px 10px 10px 10px",
                height: "calc(100% - 80px)",
                paddingTop: 0
            }
        }
    },
    planButton: {
        padding: "12px 30px 12px 29px",
        borderRadius: 9,
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#8ac8d5",
        position: "absolute",
        left: "50%",
        bottom: 0,
        transform: "translate(-50%, 50%)",
        color: "#000",
        minWidth: 150,
        transition: "box-shadow .4s",
        lineHeight: 1
    },
    billingTitle: {
        color: "#1c314c",
        fontSize: 20,
    },
    billingText: {
        color: "#8a8a8e",
        "&$margin40t": {
            marginTop: 40
        }
    },
    billingTextFlex: {
        display: "flex",
        justifyContent: "space-between"
    },
    billingAmount: {
        color: "#1c314c",
        fontSize: 27,
        "& $billingAmount": {
            position: "relative",
            display: "inline-block",
            paddingBottom: 15,
            "& span": {
                position: "absolute",
                right: 0,
                bottom: 0,
                fontSize: 13,
                color: "#000",
                fontWeight: "normal"
            }
        }
    },
    planColsButton: {
        left: "50%",
        top: 0,
        transform: "translate(-50%, -50%)",
        color: "#000",
        minWidth: 140,
        bottom: "auto",
        fontSize: 20,
        margin: "0 !important"
    },
    planCols: {
        position: "relative",
        borderRadius: 15,
        boxShadow: "0 2px 5px 0 #8ac8d5",
        border: "solid 1px #14a4c2",
        height: "100%",
        "& >*": {
            margin: "10px 0 0 0"
        }
    },
    planFirstCols: {
        backgroundColor: "#e8f6f9",
    },
    subscriptionExpired: {
        width: 'auto',
        height: 39,
        padding: "4px 4px 7px 10px",
        // boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        // backgroundColor: "#fff2e4",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        right: 40,
        zIndex: 9,
        borderRadius: 60,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& span": {
            color: "#d20b0b",
            marginRight: 10,
            fontSize: 14,
        },
        "& $modalBtn": {
            fontSize: "13px !important",
            padding: "3px 18px 5px 18px"
        }
    },
    customBusinessName: {
        position: "absolute",
        top: "-3px",
        right: 40,
        backgroundColor: "#fff",
        color: "#1c314c",
        fontSize: 13,
        boxShadow: "-3px -3px 6px 0 rgba(0, 0, 0, 0.16)",
        padding: "2px 35px",
        borderRadius: "0px 0px 17px 17px"
    },
    planList: {
        maxWidth: 300,
        margin: "auto",
        "& ul": {
            padding: 0
        },
        "& li": {
            listStyle: "none"
        },
        "& li:before": {
            content: "'·'",
            fontSize: 70,
            verticalAlign: "middle",
            lineHeight: 0,
            color: "#ffa539",
            marginRight: 5
        }
    },
    planContain: {
        width: "72%",
        maxWidth: 225,
        margin: "10px auto 30px auto",
        boxShadow: " 0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#fff",
        borderRadius: "0 0 25px 25px",
        paddingBottom: 40,
        display: "inline-block",
        "& >*": {
            margin: 0
        }
    },
    billingAmountCols: {
        color: "#1c314c",
        fontSize: 27,
    },
    settledAmount: {
        '& .MuiOutlinedInput-root': {
            border: 'none',
            padding: '3px 10px',
            maxWidth: 110,
            pointerEvents: "none",
            marginLeft: 'auto',
            borderRadius: '5px',
            backgroundColor: '#e8f6f9',
            '& .MuiOutlinedInput-input.MuiInputBase-input': {
                textAlign: 'right',
                padding: 0
            },
        },
    },
    tablealign: {
        '&.checkbox': {
            width: '0 !important',
        }
    },
    wordBreak: {
        wordBreak: 'break-word',
    },
    pointerEventsNone: {
        pointerEvents: 'none',
    },
    actionWidth: {
        width: '130px',
        marginRight: "2px",
        justifyContent: "right"
    },
    posSticky: {
        position: 'sticky',
        top: 0
    },
    scrollHeader: {},
    mainHeader: {
        backgroundColor: "#F5F5F5",
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        paddingBottom: "17px",
        transition: "box-shadow .4s",
        "&$scrollHeader": {
            boxShadow: "0 3px 6px 0 rgb(0 0 0 / 16%)",
            "&+$listTableMargin": {
                '& $tableRoot': {
                    '& .MuiAccordionSummary-root.Mui-expanded': {
                        // borderRadius: "0"
                    }
                }
            }
        }
    },
    disInlineCursor: {
        display: 'inline-block',
        cursor: 'pointer',
    },
    // ellipsis: {
    //     overflow: "hidden",
    //     height: "100px",
    //     display: "block",
    //     position: "relative",
    //     "&:after": {
    //         content: '"..."',
    //         position: "absolute",
    //         bottom: 0,
    //         right: 0,
    //         padding: "0 5px"
    //     }
    // }
    modelCloseIcon: {

    },
    actionColumn: {
        width: "95px",
        display: "inline-block",
        textAlign: "left"
    },
    linesActionColumn: {
        width: "110px",
        display: "inline-block",
        textAlign: "left",
        paddingLeft: "20px"
    },
    descEllipsis: {
        overflow: 'hidden',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
    },
    menuPaper: {
        maxHeight: '260px',
        boxShadow: ' 0 3px 6px 0 rgb(0 0 0 / 16%)',
    },
    dateFilter: {
        lineHeight: 1,
        padding: 6,
        display: "block",
        color: "rgba(0, 0, 0, 0.87) !important",
        fontSize: "13px",
        position: "relative",
        "& .ant-image": {
            position: "absolute",
            right: "5px",
            top: "50%",
            transform: "translateY(-50%)"
        }
    },
    customAutocompleteBorder: {},
    customSortIcon: {},
    sortIconUp: {},
    rightAlignAmount: {
        textAlign: 'right',
        // paddingRight: '35px !important',
        whiteSpace: "nowrap",
        "& >span": {
            marginLeft: "auto"
        }
    },
    amountRightAlign: {
        '&.MuiTableCell-root.MuiTableCell-head': {
            width: '170px !important',
        },
    },
    calenderStyles: {

    },
    headerGT: {},
    maxWidth750: {
        '& .MuiDrawer-paper.MuiDrawer-paperAnchorRight': {
            width: '750px',
        }
    },
    calenderCustomize: {
        '&.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
            backgroundColor: '#14a4c2',
            '& .Mui-selected': {
                backgroundColor: '#8ac8d5',
            },
        },
        '&.css-eq83gn-MuiDateRangePickerDay-root': {
            backgroundColor: "transparent"
        },
        '&.css-1abyxak-MuiDateRangePickerDay-root': {
            backgroundColor: "transparent"
        },
    },
    noBorder: {
        border: "none !important"
    },
    customCurreny: {
        minWidth: "80px",
        display: "block"
    },
    younoteAdminTable: {
        height: 'calc(100vh - 218px)', minHeight: "493px"
    },
    listTableTeamManagement: {
        "& $tablecontain": {
            "&.MuiTableContainer-root": {
                height: "calc(100% - 90px)",
            }
        },
    },
    tablecontain: {
        "&$tableRoot": {
            borderRadius: "0px !important"
        },
        "& .MuiCheckbox-root": {
            padding: 0,
            overflow: "visible !important",
            "& .MuiSvgIcon-root": {
                fontSize: "1.2rem"
            }
        },
        "&.MuiTableContainer-root": {
            height: "calc(100% - 56px)",
            overflow: "auto",
            paddingRight: "15px",
            overflowY: "scroll"
        },
        '& .MuiTableCell-root': {
            fontWeight: "normal",
            lineHeight: 1.15,
            padding: "16px 10px 16px 10px",
            "& span.MuiCheckbox-root": {
                display: "inline-block",
            },
            "& > span": {
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            },
            "& a": {
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            },
        },
        '& th.MuiTableCell-root.MuiTableCell-head': {
            padding: "5px 10px 5px 10px",
            backgroundColor: "#fafafa",
            borderBottom: "6px solid #fff",
            lineHeight: 1,
            "&$headActive": {
                backgroundColor: "#e8f6f9",
            }
        },
        '& p': {
            marginTop: 0, marginBottom: 0,
        },
        '& .infinite-scroll-component__outerdiv': {
            height: "100%",
        },
        '& .infinite-scroll-component ': {
            height: "100% !important",
        },
        "& .MuiTableCell-root:first-child": {
            padding: "16px 10px 16px 10px"
        },
        "& .MuiTable-root tr td:last-child": {
            padding: "16px 0 16px 16px",
            textAlign: "right"
        }
    },
    tablecontainBatch: {
        marginTop: 20,
        "&$tablecontain": {
            '& .MuiTableCell-root': {
                padding: "10px"
            },
            "& .MuiTableCell-root:first-child": {
                padding: "10px"
            },
            "& .MuiTable-root tr td:last-child": {
                padding: "10px 0 10px 10px",
                textAlign: "right"
            }
        }
    },
    tablecontainBatchSales: {
        "& $tablecontainBatch": {
            marginTop: 0,
            "&.MuiTableContainer-root": {
                height: "100%"
            }
        },
        marginTop: 20,
        height: 200,
        padding: 15,
        borderRadius: 10,
        border: "1px solid #14A4C2"
    },
    paginationTablecontain: {
        "& .MuiTableCell-footer": {
            position: "sticky",
            bottom: 0,
            left: 0,
            padding: "2px 10px !important",
            backgroundColor: "#fff",
        },
        "& .MuiTablePagination-displayedRows": {
            fontSize: 12,
            color: "#8a8a8e"
        },
        "& .MuiSvgIcon-root": {
            width: 22,
            height: 18
        },
        "& .MuiToolbar-gutters": {
            padding: 0,
            minHeight: "auto",
            "& .MuiBox-root": {
                margin: 0,
                "& .MuiButtonBase-root": {
                    padding: 0,
                    "&:first-child": {
                        display: "none"
                    },
                    "&:last-child": {
                        display: "none"
                    }
                }
            }
        }
    },
    availableClients: {
        '& .MuiFormControlLabel-label': {
            color: "#000 !important",
            marginLeft: "10px"
        }
    },
    feautureCheckboxes: {
        padding: "7px 8px 9px 14px",
        borderRadius: "6px",
        border: "solid 1px #14a4c2",
    },
    feautureCheckboxesRow: {
        borderTop: "1px solid #14a4c2",
        marginTop: "7px",
        paddingTop: "7px",
        '& .MuiCheckbox-root': {
            padding: "0"
        }
    },
    productImageUpload: {
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: "#ececec",
        borderRadius: "18px",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
    },
    productForm: {
        '& $customAccrodinHeader': {
            '&:first-child + $customAccrodinContent': {
                '& $customAccrodinContentInner': {
                    display: "flex",
                    justifyContent: "center",
                    '& form': {
                        display: "flex",
                        flexDirection: "column"
                    }
                },
            }
        }
    },
    productImageUploadInnerView: {
        "& $imageContainer": {
            boxShadow: "none",
            height: "calc(100% - 20px)",
        }
    },
    productImageUploadInner: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        padding: "10px",
        fontSize: 13,
        flexDirection: "column",
        "& p": {
            margin: 0
        },
        "& $addLink": {
            fontSize: 13
        }
    },
    productSchedulingImageUpload: {
        "& $productImageUploadInner": {
            fontSize: 11,
            "& $addLink": {
                fontSize: 11
            }
        }
    },
    frequencyEvery: {
        position: "relative",
        border: "1px solid #14a4c2",
        backgroundColor: "#fff",
        padding: "14px 5px 5px 5px",
        borderRadius: 5,
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
    },
    frequencyEveryText: {
        position: "absolute", top: "-9px",
        left: "9px",
        padding: "0 10px", backgroundColor: "#fff",
    },
    fVisible: {},
    everyDis: {
        position: "relative",
        paddingLeft: 6,
        lineHeight: 2,
        "&:before": {
            content: '"|"',
            position: "absolute",
            top: "50%",
            left: 0,
            lineHeight: 1,
            transform: "translateY(-50%)"
        },
        "&:first-child": {
            paddingLeft: 0,
            "&:before": {
                content: "none",
            },
        }
    },
    customPlaceofSupply: {
        display: "flex",
        justifyContent: "space-between"
    },
    frequencyEveryPos: {
        position: "absolute",
        top: "100%",
        marginTop: 1,
        left: 0,
        width: "100%",
        backgroundColor: "#fff",
        border: "1px solid #14a4c2",
        borderRadius: 5,
        padding: "8px 10px",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        "& $dropDownPointer": {
            "& .MuiFormGroup-root": {
                whiteSpace: "wrap"
            }
        },
        "& .MuiButtonBase-root": {
            padding: 5
        },
        "& .MuiCheckbox-root": {
            "& .MuiSvgIcon-root": {
                fontSize: "1.2rem"
            }
        }
    },
    importImage: {
        "& >*": {
            display: "inline-block",
            verticalAlign: "middle",
            lineHeight: 1
        }
    },
    customGroupCheckBok: {
        "& .MuiTypography-root": {
            fontSize: 14,
            color: "#8a8a8e"
        },
        "& .MuiCheckbox-root": {
            color: "#c6c6c6",
            "&.Mui-checked": {
                color: "#FCB364",
            }
        }
    },
    imageContainer: {
        position: "absolute",
        borderRadius: 4,
        overflow: "hidden",
        width: "calc(100% - 20px)",
        height: "55%",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    imageContainerText: {
        position: "absolute",
        bottom: 10,
        left: 0,
        width: "100%",
        textAlign: "center",
        padding: "0 10px"
    },
    closeImg: {
        width: 12,
        height: "auto",
        position: "absolute",
        right: 5,
        top: 5,
        zIndex: 99,
        cursor: "pointer"
    },
    imageBg: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundColor: "transparent",
    },

    previewImg: {
        width: "100%",
        height: '100%',
        objectFit: "contain"
    },
    bottomPosition: {},
    autoCustomLabel: {},
    customerLabelNone: {
        "& $autoCustomLabel": {
            display: "none"
        },
        "& $textFieldColor": {
            "&::placeholder": {
                color: "rgb(0, 0, 0, 0.87) !important"
            }
        }
    },
    squareBox: {
        width: 14,
        height: 14,
        border: "1px solid #d9d9d9",
        borderRadius: 2
    },
    customAutoComplete: {
        position: "relative",
        '& $autoCustomLabel': {
            color: "#8a8a8e !important",
            marginBottom: 12
        },
        '& .MuiInput-input': {
            fontSize: 14,
            lineHeight: 1,
            position: "relative",
            backgroundColor: "transparent",
            zIndex: 99,
        }, "& .MuiOutlinedInput-root": {
            paddingRight: 0
        },
        "& .MuiInputBase-input": {
            fontSize: 14,
            lineHeight: 1,
            position: "relative",
            backgroundColor: "transparent",
            zIndex: 99,
        },
        '& .MuiInputLabel-outlined': {
            transform: "translate(14px, 16px) scale(1)",

        },
        "& .Mui-error": {
            '& .MuiOutlinedInput-notchedOutline': {
                border: "solid 1px #d32f2f !important",
                boxShadow: "0 1px 5px 0 rgb(211 47 47 / 50%)",
            },
        },
        "& .MuiFormHelperText-root": {
            margin: "3px 0 0 0 !important"
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: "solid 1px #14a4c2 !important",
            boxShadow: "0 1px 5px 0 #8ac8d5",
            borderRadius: 4,

        },
        '& .MuiOutlinedInput-input': {
            padding: 5,
            lineHeight: 1,
            height: "auto",
            "& + svg": {
                right: "5px !important"
            }
        },
        "&$bottomPosition": {
            "& .MuiInput-root.Mui-focused": {
                "&:before": {
                    content: "none"
                },
                "&:after": {
                    content: "none"
                }
            }
        }
    },
    rightPosition: {},
    fixHeightDropDown: {
    },
    selectedRowHover: {},
    paginationTableRow: {},
    customAutoCompleteCardTop: {},
    customeDivlength: {},
    customAutoCompleteCard: {
        minWidth: "100%",
        height: "auto",
        overflow: "auto",
        backgroundColor: "transparent",
        // transform: "translateY(100%)",
        zIndex: 3,
        boxShadow: "0 3px 6px 0 rgb(0 0 0 / 16%)",
        "&$customAutoCompleteCardTop": {
            bottom: "100%",
            transform: "translateY(0%)",
        },
        '&$tableRoot': {
            border: "1px solid #14A4C2",
            borderRadius: "4px !important",
            overflow: "hidden",
            boxShadow: "0 3px 10px 0 rgba(20, 164, 194, 0.16)",
            padding: 8,
            '& $margin30t': {
                '&.MuiTableContainer-root': {
                    height: 'calc(100% - 30px)'
                },
            },
            '& .MuiTableContainer-root': {
                height: '100%', paddingRight: 4
            },
            '& .MuiTable-root tbody tr': {
                cursor: "pointer"
            },
            '& .MuiTable-root tr th': {
                padding: "10px 28px 10px 28px",
            },
            '& .MuiTable-root tr': {
                "&:last-child": {
                    '& td': {
                        //paddingBottom: "0"
                    }
                }
            },
            '& .MuiTable-root tr td': {
                padding: "7px 28px",
                whiteSpace: "nowrap",
                minWidth: 150,
                overflow: "hidden",
                textOverflow: "ellipsis",
                "& $customeDivlength": {
                    whiteSpace: "nowrap",
                    maxWidth: 250,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }
            },
            '& .MuiTableBody-root': {
                '& .MuiTableRow-root': {
                    '&$selectedRow': {
                        "& td": {
                            color: "#14A4C2"
                        }
                    },
                    '&:hover': {
                        backgroundColor: "#e8f6f9"
                    },
                    '&$selectedRowHover': {
                        "& td": {
                            color: "#14A4C2",
                            backgroundColor: "#e8f6f9"
                        }
                    },
                },
            },
            '& .MuiTable-root tr th:first-child': {
                paddingLeft: '10px',
            },
            '& .MuiTable-root tr td:first-child': {
                paddingLeft: '10px',
            },
            '& .MuiTable-root tr th:last-child': {
                textAlign: 'left',
            },
            '& .MuiTable-root tr td:last-child': {
                textAlign: 'left',
            },
            '& .MuiTable-root tr td.MuiTablePagination-root': {
                border: "none",
                padding: "0 !important"
            },
        },
        '& .ant-card-body': {
            height: "100%",
            padding: "0px"
        },
        '& $tablecontain': {
            '& th': {
                padding: "10px"
            }
        },
        '&$rightPosition': {
            right: "0",
            left: "auto"
        },
        "&$fixHeightDropDown": {
            height: "220px",
            padding: "8px 8px 8px 8px",
            "&$fixHeightDropDownPagination": {
                height: "250px"
            },
            '& .ant-card-body': {
                //padding: "15px 0 15px 15px"
            }
        },
    },
    fixHeightDropDownPagination: {},
    unSelectedIcon: {},
    selectedRow: {},
    selectedIcon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        marginLeft: 3,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: "#f5f8fa",
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: "rgba(206,217,224,.5)",
        },
        '&$unSelectedIcon': {
            backgroundColor: '#ffa539',
            backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
            boxShadow: "none",
            '&:before': {
                display: 'block',
                width: 16,
                height: 16,
                backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
                content: '""',
            },
        }
    },
    deliveryDetails: {
        "& $tablecontain": {
            "&.MuiTableContainer-root": {
                height: "calc(100% - 95px)"
            }
        }
    },
    customQueryRadioButton: {},
    customRadioButtonMonthly: {
        '& .MuiFormControlLabel-root': {
            width: 60,
        },
    },
    customRadioButton: {
        '& .MuiFormControlLabel-root': {
            marginRight: "20px"
        },
        '& .MuiFormControlLabel-root:last-child': {
            marginRight: "0px",
        },
        '& .MuiRadio-root': {
            padding: "0 9px",
        },
        '& .MuiTypography-root': {
            fontSize: "14px",
        },
        "&$customQueryRadioButton": {
            '& .MuiFormControlLabel-root': {
                marginTop: "10px",
                marginRight: 0,
                "&:first-child": {
                    marginTop: 0
                }
            },
        }
    },
    customRadioButtonLeftSales: {
        "&$customRadioButton": {
            '& .MuiRadio-root': {
                padding: "0 5px",
            },
            '& .MuiTypography-root': {
                fontSize: 12,
            },
        }
    },
    customIdentityRadioButton: {
        "& .MuiTypography-root": {
            fontSize: 12
        },
        "&$dropDownPointer": {
            '& .MuiFormGroup-root': {
                flexWrap: "wrap",
                WebkitBoxFlexWrap: "wrap",
                WebkitFlexWrap: "wrap",
                MsFlexWrap: "wrap"
            },
        },
        "& $selectedIcon": {
            width: 10,
            height: 10,
            "&$unSelectedIcon": {
                "&:before": {
                    width: 10,
                    height: 10,
                }
            }
        },
        "& .MuiRadio-root": {
            padding: "0 5px"
        },
        "& .MuiFormControlLabel-root": {
            marginRight: 10
        }
    },
    catalogueDelete: {

    },
    paddingZero: {
        '& .ant-card-body': {
            padding: "0px",
            // height: "calc(100% - 40px)",
            '& > .ant-row': {
                '& > .ant-col': {
                    height: "100%"
                },
                "& > $catalogueDelete": {
                    '&.ant-col': {
                        height: "calc(100% - 47px)"
                    },
                    '& $notificationButtons': {
                        margin: "0 -20px"
                    }
                }
            }
        },
    },
    fullHeight: {
        height: "100%",
        '& .ant-col-4': {
            borderRight: "1px solid #14a4c2",
        },
        '& .ant-col-12': {
            padding: "0 25px 25px 25px",
        },
    },
    clientPadding5: {
        padding: "5px",
    },
    padding10: {
        padding: "10px",
    },
    padding20: {
        padding: "20px",
    },
    catalogueTitle: {
        fontWeight: "500",
        textAlign: 'center',
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: 75
    },
    catalogueDesign: {
        width: "100%",
        height: "65px",
        margin: 'auto',
        borderRadius: "10px",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16),  inset 0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#e8f6f9",
        marginTop: "10px",
        position: "relative",
    },
    catalogueDesign2: {
        width: "80%",
        height: "80%",
        borderRadius: "8px",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#ffffff",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50% , -50%)",
    },
    marginBottom10: {
        marginBottom: '10px',
    },
    catalogue: {
        width: '100%',
        height: "100%",
        overflow: "hidden",
        overflowY: "auto",
        '& $noResultsText': {
            color: "#000"
        },
    },
    row: {
        // margin: '0 -50px',
    },
    universalCatalogue: {
        "& $row": {
            margin: '-20px -20px 0',
        },
    },
    colInline: {
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: "0 20px",
        width: "12.5%",
    },
    colInlineCat: {
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: "0 20px",
        width: "12.5%",
    },
    colInlineProduct: {
        // padding: '0 50px',
    },
    catelogueProducts: {

    },
    sideBarMenu: {
        '& .MuiCollapse-wrapper': {
            boxShadow: "none !important",
        },
        '& .MuiTypography-root': {
            display: 'inline-block',
            fontWeight: '500',
            color: '#317787',
            fontSize: '14px',
        }
    },
    noData: {
        display: "flex",
        alignItems: "center",
        height: "100%",
        justifyContent: "center",
        padding: "40px",
        textAlign: "center",
        color: "#8A8A8E"
    },
    addressTable: {
        '&$tableRoot': {
            height: "100vh !important",
            border: "none",
            margin: 0,
            '& .ant-card-body': {
                height: '100%',
                padding: "24px 0 24px 24px"
            },
            '& td': {
                verticalAlign: "top"
            }
        },
        '& $actionColumn': {
            width: "auto",
        }
    },
    customSwitch: {
        marginLeft: -3,
        "&$marginLeft10": {
            marginLeft: 10,
            marginTop: 0,
        },
        "& .Mui-disabled": {
            "& + .MuiSwitch-track": {
                backgroundColor: "#D9D9D9",
                opacity: 1
            },
            "& .MuiSwitch-thumb": {
                border: "0.5px solid #D9D9D9"
            }
        },
        "& .MuiSwitch-track": {
            backgroundColor: "#BEBEBE",
            opacity: 1
        },
        '& .Mui-checked': {
            color: "#FFA539",
            "& + .MuiSwitch-track": {
                backgroundColor: "#F7E0C8",
                opacity: 1
            },
            '& .MuiSwitch-thumb': {
                border: 'none'
            },
            "&.Mui-disabled": {
                color: "#FCE5CB",
                "& + .MuiSwitch-track": {
                    backgroundColor: "#FAECDD",
                    opacity: 1
                },
                '& .MuiSwitch-thumb': {
                    border: 'none'
                },
            }
        },
        '& + span': {
            padding: 0
        },
        '& .MuiSwitch-thumb': {
            border: '0.5px solid #979797'
        }
    },
    tooltip: {
        padding: 0,
        fontSize: 0,
        "& .ant-image": {
            fontSize: 0
        }
    },
    tooltipWidth: {
        width: '1000px',
        "& .ant-image": {
            fontSize: 0
        }
    },
    iconAnimation: {},
    searchAnimation: {
        display: "inline-block",
        position: "relative",
        width: "100%",
        border: '1px solid #14A4C2',
        borderRadius: '20px',
        padding: "0 15px 0 30px",
        boxShadow: "0 3px 6px 0 rgb(20 164 194 / 16%), inset 0 3px 6px 0 rgb(20 164 194 / 16%)",
        transition: "padding .4s",
        "& .MuiInput-root::before": {
            border: "none !important"
        },
        "& .ant-image": {
            position: "absolute",
            top: "50%",
            left: "10px",
            transform: "translateY(-50%)",
            width: "13px",
            height: "auto",
            transition: "left .4s",
            fontSize: 0
        },
        '&$iconAnimation': {
            padding: "0 30px 0 15px",
            "& .ant-image": {
                left: "calc(100% - 30px)"
            }
        }
    },
    searchClear: {
        position: "absolute",
        right: 0,
        top: 0,
        height: "100%",
        width: 40,
        borderLeft: "1px solid #14A4C2",
        backgroundColor: "#fff",
        borderRadius: "0 20px 20px 0",
        fontSize: 0,
        cursor: "pointer",

        "&:hover": {
            "& .ant-image": {
                transform: "translate(-50%, -50%) rotate(90deg)",
            }
        },
        "& .ant-image": {
            position: "absolute",
            top: "50%",
            left: "50% !important",
            transform: "translate(-50%, -50%)",
            transition: "transform .4s"
        }
    },
    searchClearImg: {
        position: "absolute",
        top: "50%",
        left: "50% !important",
        transform: "translate(-50%, -50%)",
        width: 15,
        height: "auto",
        transition: "transform .4s"
    },
    dropClear: {
        padding: "0 5px",
        position: "absolute",
        top: 0,
        right: 0,
        zIndex: 9,
        backgroundColor: "#fff",
        "& img": {
            width: 14
        },
        "& >*": {
            display: "inline-block",
            verticalAlign: "middle",
        }
    },
    searchAnimationText: {

    },
    leftStoreSales: {
        padding: "20px",
        height: "100%",
        overflow: "auto",
        "& $searchAnimation": {
            width: "100%",
        }
    },
    storeSales: {
        "&$listTableMargin": {
            margin: 10,
            "& .ant-card-head-title": {
                position: "relative",
                "& .ant-image": {
                    position: "absolute",
                    top: "50%",
                    right: 0,
                    transform: "translateY(-50%)",
                    "& $logoImg": {
                        height: 30
                    }
                }
            },
            "& $tableRoot": {
                height: "calc(100dvh - 20px) !important",
            }
        },
        "& .ant-card-body": {
            padding: 0
        },
        "& .ant-card-head": {
            padding: '0 0 0 24px',
        },
        "& .ant-card-head-wrapper": {
            "& .ant-image": {
                right: '50px !important',
            },
            "& $storesalesclose": {
                "& .ant-image": {
                    right: '8px !important',
                    transition: "transform .3s ease",
                    "&:hover": {
                        transform: "translateY(-50%) scale(1.3)"
                    }
                },
            },
        },
    },
    rightStoreSales: {
        padding: "",
        borderLeft: "1px solid #14a4c2"
    },
    rightStoreSalesTopBar: {
        padding: 20,
        borderBottom: "1px solid #14a4c2",
        marginBottom: 45,
        "& $customerLabelNone": {
            borderRight: "1px solid #14a4c2"
        }
    },
    rightStoreSalesBottomBar: {
        padding: 20,
        borderTop: "1px solid #14a4c2",
    },
    rightStoreSalesTable: {
        padding: "0 20px 0 0",
        "& $selectedLineView": {
            "& .MuiTableCell-root": {
                borderTop: "12px solid #f0f0f0 !important",
                padding: "0 10px 0 10px !important",
                borderBottom: "12px solid #f0f0f0 !important",
            }
        },
        "& > $tablecontain": {
            padding: 0,
            "& $selectedLineView": {
                "& .MuiTableCell-root": {
                    borderTop: "12px solid #f0f0f0 !important",
                    padding: "0 10px 0 10px !important",
                    borderBottom: "12px solid #f0f0f0 !important",
                }
            },
        },
        "& $tablecontain": {
            "& .MuiTableBody-root": {
                "& .MuiTableCell-root": {
                    padding: "10px !important"
                },
            },
            "&.MuiTableContainer-root": {
                "& .MuiTableHead-root": {
                    position: "relative",
                    zIndex: 999,
                    "& .MuiTableCell-root:first-child": {
                        paddingLeft: 35
                    }
                },
                height: "calc(100% - 15px)",
                "& th": {
                    whiteSpace: "nowrap"
                },
                "& td": {
                    whiteSpace: "nowrap"
                }
            }
        }
    },
    sideBarMenuTitle: {
        position: "relative",
        "&::before": {
            width: "6px",
            height: "2px",
            backgroundColor: "#317787",
            position: "absolute",
            top: "50%",
            left: "-15px",
            transform: "translateY(-50%)",
            content: "''",
        }
    },
    sideBarMenuDropDown: {
        position: "absolute",
        top: "50%",
        right: "-25px",
        transform: "translateY(-50%)",
    },
    singleSideBarMenuTitle: {
        position: "relative",
        "&::before": {
            width: "5px",
            height: "5px",
            backgroundColor: "#317787",
            borderRadius: "50px",
            position: "absolute",
            top: "50%",
            left: "-15px",
            transform: "translateY(-50%)",
            content: "''",
        },
    },
    catalogueMenuActive: {},
    singleLevelMenu: {
        padding: "10px 10px 10px 40px",
        cursor: "pointer",
        '& .MuiListItemText-root': {
            margin: "0",
        },
        '&:hover': {
            backgroundColor: "#e8f6f9",
        },
        '&$catalogueMenuActive': {
            backgroundColor: "#e8f6f9",
        }
    },
    multiLevelMenu: {
        cursor: "pointer",
        '& .MuiListItem-root': {
            padding: "10px 10px 10px 40px",
            '&:hover': {
                backgroundColor: "#e8f6f9",
            },
            '&$catalogueMenuActive': {
                backgroundColor: "#e8f6f9",
            }
        },
        '& .MuiListItemText-root': {
            margin: "0",
        },
        '& $multiLevelMenu': {
            '& .MuiListItem-root': {
                padding: "10px 10px 10px 60px",
            }
        },
        '& $singleLevelMenu': {
            padding: "10px 10px 10px 75px !important",
        }
    },
    borderTop: {
        borderTop: "1px solid #14a4c2",
    },
    borderRight: {
        borderRight: "1px solid #14a4c2",
    },
    borderLeft: {
        borderLeft: "1px solid #14a4c2",
    },
    paddingBottom50: {
        paddingBottom: "50px",
    },
    paddingTop70: {
        paddingTop: "70px",
    },
    paddingTop80: {
        paddingTop: "80px",
    },
    paddingTop5: {
        paddingTop: "5px",
    },
    paddingTop7: {
        paddingTop: "7px",
    },
    paddingTop10: {
        paddingTop: "10px",
    },
    paddingTop15: {
        paddingTop: "15px",
    },
    colorGray: {
        color: "#979797",
    },
    CalypsoborderTop: {
        borderTop: "1px solid #317787",
    },
    CalypsoborderRight: {
        borderRight: "1px solid #317787",
    },
    CalypsoborderLeft: {
        borderLeft: "1px solid #317787",
    },
    CalypsoborderBottom: {
        borderBottom: "1px solid #317787",
    },
    loadMoreCircle: {
        position: "relative",
        height: "75px",
        '&::before': {
            content: "''",
            position: "absolute",
            backgroundImage: `url(${loading})`,
            //animation: "spin 2s linear infinite",
            top: "0",
            left: "50%",
            width: 125,
            height: 70,
            transform: "translateX(-50%)"
            // marginRight: "-17px",
            // marginLeft: "-17px"
        }
    },
    loadMoreCircleAll: {
        position: "fixed",
        width: "100%",
        height: "100%",
        backgroundColor: "#fff",
        left: 0,
        top: 0,
        '&::before': {
            content: "''",
            position: "absolute",
            backgroundImage: `url(${loading})`,
            top: "50%",
            left: "50%",
            width: 125,
            height: 70,
            transform: "translate(-50%)"
        }
    },
    "@keyframes spin": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
    },
    stickyHeader: {
        zIndex: "2",
        width: "100%",
        backgroundColor: " #f5f5f5",
        padding: "15px 0 0 0",
        borderTop: '2px solid #14A4C2',
        '&:first-child': {
            padding: "0",
            borderTop: 'none'
        },
        '& span': {
            backgroundColor: " #8ac8d5",
            display: "block",
            padding: "12px 16px",
            boxShadow: " 0 3px 6px 0 rgb(0 0 0 / 16%)",
            transition: "background-color .4s",
            borderRadius: "10px 10px 0 0",
            fontSize: "16px",
            fontWeight: "500"
        }
    },
    stickyList: {
        padding: "24px",
        boxShadow: "0 2px 5px 0 #8ac8d5",
        border: '2px solid #14A4C2',
        borderTop: "none",
        borderBottom: "none",
        backgroundColor: "#fff"
    },
    List: {
        boxSizing: "border-box",
        height: "inherit",
        listStylePosition: "inside",
        margin: 0,
        overflowX: "hidden",
        overflowY: "scroll",
        padding: 0
    },
    ListHeader: {
        position: "relative"
    },
    Wrapper: {
        height: "inherit",
        overflowX: "hidden",
        position: "relative"
    },
    listTableSticky: {
        overflowX: "hidden",
    },
    scrollBorder: {
        position: "relative",
        paddingBottom: 5,
        borderRadius: "0 0 10px",
        overflow: "hidden",
        // borderBottom: "1px solid #14A4C2",
        // borderRadius: "10px",
        // boxShadow: "0 4px 2px 0 rgb(20 164 194 / 16%)",
        "&:before": {
            width: "calc(100% - 17px)",
            height: 16,
            content: "''",
            backgroundImage: `url(${scrollBar})`,
            backgroundRepeat: "no-repeat",
            position: "absolute",
            top: "calc(100% - 15px)",
            left: -1,
            zIndex: 999,
            backgroundSize: "cover",
            // transform: "translateY(-50%)"
        }
    },
    storeSalesLineQuantityInput: {},
    listTableStickyInner: {

    },
    marginRight10: {
        marginRight: 10
    },
    stickyContainer: {
        //  height: "calc(100vh - 168px)",
        height: "calc(100dvh - 168px)",
        overflowY: "auto",
        overflowX: "hidden",
        paddingBottom: "3px",
        paddingRight: 15,
    },
    receipt: {},
    storeSalesTotal: {
        display: "flex",
        justifyContent: "space-between",
        "& $receipt": {
            color: "#000"
        }
    },
    headerCollapse: {},
    headerCollapseLast: {},
    customAccrodinHeaderSingle: {},
    deletedIcon: {
        "& > *": {
            display: "inline-block",
            verticalAlign: "middle"
        }
    },
    customAccrodinHeader: {
        position: "sticky",
        top: "142px",
        left: 0,
        backgroundColor: "#f5f5f5",
        paddingTop: "15px",
        cursor: "pointer",
        zIndex: "2",
        "&:first-child": {
            paddingTop: "0px",
            "&:before": {
                content: "none"
            }
        },
        "&:before": {
            content: "''",
            position: "absolute",
            width: "101%",
            height: "15px",
            top: "0",
            left: "50%",
            backgroundColor: "#f5f5f5",
            transform: "translateX(-50%)"
        },
        "& span": {
            backgroundColor: "#8ac8d5",
            borderRadius: "10px 10px 0 0",
            padding: "16px 24px",
            fontSize: "16px",
            boxShadow: "0 3px 6px 0 rgb(0 0 0 / 16%)",
            fontWeight: "500",
            lineHeight: 1,
            display: "block",
            position: "relative",
            border: "1px solid transparent",
            transition: "background-color .4s",
            '&:before': {
                content: `url(${AccordionIcon})`,
                position: "absolute",
                top: "50%",
                right: "24px",
                transform: "translateY(-50%)"
            },
        },
        '&$headerCollapse': {
            "& span": {
                border: "1px solid #14A4C2",
                backgroundColor: "#E8F6F9",
                '&:before': {
                    transform: "translateY(-50%) rotate(180deg)"
                }
            }
        },
        '&$headerCollapseLast': {
            "& span": {
                '&:before': {
                    content: "''",
                    width: 10,
                    height: 2,
                    backgroundColor: "#000"
                }
            }
        },
        "&$customAccrodinHeaderSingle": {
            "& span": {
                '&:before': {
                    content: "none"
                }
            }
        }
    },
    collapse: {},
    customAccrodinContent: {
        transition: "height .3s",
        position: "relative",
        "&$collapse": {
            height: "0px !important",
            overflow: "hidden",
            border: "none"
        },
    },
    globalAddressTable: {
        '& $customAccrodinContent:nth-child(4)': {
            height: "calc(100vh - 460px) !important"
        },
        '& $customAccrodinContentInner': {
            height: "100%",
            '& $tablecontain': {
                height: "calc(100% - 50px)",
                overflow: "auto",
                paddingRight: "15px",
                overflowY: "auto",
            }
        }
    },
    storeSalesTotals: {
        "& .ant-col": {
            position: "relative",
            "&:before": {
                content: "''",
                position: "absolute",
                top: "50%",
                right: 10,
                width: 1,
                height: "100%",
                backgroundColor: "#14a4c2",
                transform: "translateY(-50%)"
            },
            "&:last-child": {
                "&:before": {
                    content: "none"
                }
            }
        }
    },
    tableRootProduct: {
        border: "none",
        boxShadow: "none"
    },
    gridColoumError: {
    },
    customAccrodinContentInner: {
        height: "100%",
        padding: "24px",
        backgroundColor: "#fff",
        border: "1px solid #14A4C2",
        boxShadow: "0 3px 6px 0 rgb(20 164 194 / 16%), inset 0 3px 6px 0 rgb(20 164 194 / 16%)",
        borderTop: "none",
        borderRadius: "0 0 10px 10px",
        overflow: "hidden",
        overflowY: "auto",
        '& $customForm': {
            padding: "0 20px 0 20px"
        },
        '& $tableRoot': {
            border: "none",
            boxShadow: "none",
            height: "100%",
        },
        '& $tablecontain': {
            height: "calc(100% - 50px)",
            overflow: "auto",
            paddingRight: "15px",
            overflowY: "scroll",
        },
        '& $tabDesign': {
            '& .MuiTabPanel-root': {
                padding: "15px 0 0 0",
            },
            '& $tableRoot': {
                border: "none",
                boxShadow: "none"
            }
        },
        "& $tableRootProduct": {
            border: "none",
            boxShadow: "none"
        },
        "&::-webkit-scrollbar": {
            width: 0,
            height: 0,
            borderRadius: "none"
        }
    },
    productRadionButton: {
        "&:hover": {
            "& $customAutocomplete": {
                transform: "scaleY(1)",
                transformOrigin: "left top",
                transition: "all .3s ease",
            },
        },
        '& .MuiFormGroup-root': {
            borderRadius: "4px",
            boxShadow: "0 1px 3px 0 #8ac8d5",
            border: "solid 0.5px #14a4c2",
            padding: "0px 3px 0px 11px",
        },
        '& .MuiFormControlLabel-label': {
            fontSize: "13px"
        },
        '& .MuiRadio-colorPrimary': {
            padding: "5px"
        },
        '& $selectedIcon': {
            width: 13,
            height: 13,
            '&$unSelectedIcon': {
                '&:before': {
                    width: 13,
                    height: 13,
                },
            }
        },
        "& $customAutocomplete": {
            transform: "scaleY(0)",
        },
    },
    heightOveflow: {
        maxHeight: "75vh",
        overflow: "hidden",
        overflowY: "auto"
    },
    AlignTop: {
        alignItems: 'flex-start !important',
    },
    heights: {
        height: "calc(100vh - 310px)",
        minHeight: "150px",
        width: "auto",
        padding: "25px",
    },
    productListTable: {
        "& .MuiTable-root tr th": {
            "&:last-child": {
                textAlign: 'left',
            },
        },
        "& .MuiTable-root tr td": {
            "&:last-child": {
                textAlign: 'left',
            },
        },
    },
    addCatalogue: {
        width: '190px',
        height: '210px',
        minHeight: '210px',
        margin: 'auto',
        marginTop: '40px',
    },
    noResults: {
        padding: "0 10px",
        "& $modalBtn": {
            marginTop: "35px"
        },
        "&$colInline": {
            padding: "0 55px",
            marginTop: 30
        }
    },
    subBreadcrumb: {
        color: "#14a4c2",
        fontWeight: 500,
        "& a": {
            color: "#317787",
            "&:last-child": {
                color: "rgba(0,0,0,.85)"
            },
            "&:hover": {
                color: "#01A4A6",
            }
        }
    },
    noResultsText: {
        color: "#8A8A8E !important",
        fontSize: 14,
        "& a": {
            display: "inline-block !important",
            overflow: "visible !important"
        }
    },
    autoMark: {},
    categoryRow: {
        margin: " 0 -50px"
    },
    Width100Per: {
        width: "100%",
    },
    browseFile: {
        '& .MuiInput-root': {
            '&::before': {
                borderBottom: "1px solid #fff !important"
            },
        },
    },
    formControlLabel: { display: "block" },
    boxBorderTitle: {
        position: "sticky",
        top: "-20px",
        backgroundColor: "#fff",
        borderRadius: 10,
        padding: "10px 20px 10px",
        margin: "-20px -20px 0",
        zIndex: 3
    },
    leftScroll: {
        overflow: "hidden",
        borderRight: "1px solid #8ac8d5",
        height: "100% !important",
        paddingBottom: 20,
        "& $sideBarMenu": {
            height: "calc(100% - 65px) !important",
            overflow: "auto"
        }
    },
    customStickyTop: {
        position: "sticky",
        left: 0,
        top: 0,
        zIndex: 8,
        "& .ant-space": {
            width: "100%"
        },
        "& .ant-space-item": {
            width: "50%"
        },
        "& $customLink": {
            display: "flex",
            alignItems: "center",
            justifyContent: "end"
        },
        "& .ant-image": {
            width: 20
        },
        "& $addLink": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: 80
        }
    },
    bgWhite: {
        backgroundColor: "#fff"
    },
    unSelectedButton: {
        padding: "5px 20px",
        boxShadow: "0 5px 6px 0 rgba(0, 0, 0, 0.16)",
        borderRadius: 25,
        backgroundColor: "#fff",
        color: "#000",
        textTransform: 'none',
        border: '2px solid #fcb364',
        lineHeight: 1,
        position: "absolute",
        top: "50%",
        right: "20px",
        transform: "translateY(-50%)",
        '&:hover': {
            backgroundColor: "#FCB364",
            color: "#000",
            boxShadow: "none",
        },
    },
    linesTableRoot: {

    },
    unitNote: {
        border: "1px solid #14a4c2",
        borderRadius: "9px",
        textAlign: "center",
        padding: "10px",
        fontSize: "16px"
    },
    noItems: {
        padding: "80px 0"
    },
    businessProfileDetails: {
        "& $tableRoot": {
            "& .ant-card-body": {
                overflowY: "auto",
                overflowX: "hidden"
            }
        }
    },
    gstTransationForm: {
        "& $textFieldColor": {
            padding: 0
        },
        "& $textFieldLableColorCustom": {
            '&+.MuiInputBase-root': {
                marginTop: "0"
            },
        }
    },
    tableScrollIcon: {
        "& .ant-image": {
            position: "absolute",
            top: '75px',
            zIndex: 9
        }
    },
    tableScrollIconRight: {
        "& .ant-image": {
            right: 0,
        }
    },
    tableScrollIconLeft: {
        "& .ant-image": {
            left: 0,
            transform: "rotate(180deg)"
        }
    },
    tableCellSticky: {
        position: 'sticky',
        left: 0,
        zIndex: 4,
        backgroundColor: 'white',
        "& .MuiTableHead-root": {
            "& tr th:first-child": {
                position: "sticky",
                left: 0,
                backgroundColor: "#fff",
                zIndex: 9
            }
        },
        "& .MuiTableBody-root": {
            "& tr td:first-child": {
                position: "sticky",
                left: 0,
                backgroundColor: "#fff"
            }
        }
    },
    erroruploadFile: {
        wordBreak: "break-word",
        marginTop: "10px"
    },
    downloadbars: {
        position: "relative",
    },
    downloadimages: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "70px",
        height: "100%",
        "& $productImageUpload": {
            borderRadius: "0",
        },
        "& $productImageUploadInner": {
            padding: "5px",
            height: "100%",
        },
    },
    fonSize8: {
        fontSize: "8px",
        lineHeight: "1.67",
    },
    fonSize10: {
        fontSize: "10px",
        lineHeight: "1.67",
    },
    downloadtopbar: {
        width: "100%",
        padding: '10px',
        backgroundColor: "#1c314c"
    },
    downloadsecondbar: {
        fontFamily: "Roboto",
        fontSize: 20,
        fontWeight: "500",
        padding: "10px 0",
        backgroundColor: "#ffc27a",
        textAlign: "center",
        marginTop: "5px",
        position: "relative",
        "& span": {
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
        },
        "& h1": {
            lineHeight: "1.22",
            marginBottom: "15px",
        },
        "& p": {
            fontSize: 14,
            fontWeight: "400",
            color: "#000000",
            lineHeight: "1.5715",
        },
    },
    letterHead: {
        "&$downloaddetails": {
            borderColor: "#000",
            "& $borderRight": {
                borderColor: "#000"
            },
            "& $borderLeft": {
                borderColor: "#000"
            }
        },
        "& $downloadsHeading": {
            color: "#000"
        },
        "& $downloadsRectangle": {
            borderColor: "#000",
            backgroundColor: "#f5f5f5"
        },
        "& $totalsectiondetails": {
            borderColor: "#000",
            backgroundColor: "#f5f5f5"
        },
        "& $blueHeader": {
            color: "#000",
            fontWeight: 500
        },
        "& $totalsectionamount": {
            borderColor: "#000",
            backgroundColor: "#f5f5f5"
        },
        "& $downloadsecondbar": {
            backgroundColor: "#f5f5f5",
            margin: 0,
            borderTop: "1px solid #000"
        },
        "& $yellowBorderTop": {
            borderColor: "#000"
        },
        "& $bill": {
            "& h6": {
                color: "#000",
                fontWeight: 500
            }
        }
    },
    downloaddetails: {
        border: "1px solid #ffc27a",
        borderTop: "none",
        "& $borderRight": {
            borderRight: "1px solid #ffc27a",
        },
        "& $borderLeft": {
            borderLeft: "1px solid #ffc27a",
        },
        "& h1": {
            lineHeight: "1.22",
            marginBottom: 10,
        },
        "& $productImageUpload": {
            backgroundColor: "transparent",
            boxShadow: "none"
        },
        "& $previewImg": {
            height: "auto"
        }
    },
    billtoppadding: {
        padding: "12px",

    },
    billbottompadding: {
        padding: "12px"
    },
    bill: {
        "& h1": {
            fontSize: 22,
            fontWeight: "500",
            lineHeight: "1.22",
            color: "#000",
            marginBottom: 0,
        },
        "& h6": {
            fontSize: 16,
            fontWeight: "400",
            color: "#8a8a8e",
            marginBottom: "7px",
            lineHeight: "1.15",
        },
        "& p": {
            fontSize: 18,
            fontWeight: "400",
            color: "#000000",
            marginBottom: "7px",
            lineHeight: "1.15",
        },
    },

    textareaAutosize: {
        width: "100%",
        borderRadius: "5px",
        border: "1px solid #979797",
        padding: "10px",
        "&:focus-visible": {
            outline: "none"
        }
    },
    yellowBorderTop: {
        borderTop: "1px solid #ffc27a",
    },
    yellowBorderBottom: {
        borderBottom: "1px solid #ffc27a",
    },
    billReportHead: {

    },
    billReportHeadCustom: {},
    thirdSectionReport: {
        "&$thirdSection": {
            "& $bill": {
                "&$billReportHead": {
                    position: "relative",
                    borderBottom: "none",
                    "&:after": {
                        content: "''",
                        position: "absolute",
                        top: 0,
                        left: "100%",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#e8f6f9"
                    },
                    "&:before": {
                        content: "''",
                        position: "absolute",
                        top: 0,
                        right: "100%",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#e8f6f9"
                    },
                    "&$billReportHeadCustom": {
                        "&:after": {
                            backgroundColor: "#f5f5f5"
                        },
                        "&:before": {
                            backgroundColor: "#f5f5f5"
                        },
                        "& h6": {
                            backgroundColor: "#f5f5f5 !important"
                        }
                    }
                },
                "& h6": {
                    margin: 0,
                    padding: "10px 0",
                    backgroundColor: "#e8f6f9"
                }
            }
        }
    },
    billLoop: {
        "&:last-of-type": {
            border: "none !important"
        }
    },
    blackBorderTop: {
        borderTop: "solid 1px rgb(151 151 151 / 35%)",
    },
    secondSection: {
        "& .ant-col-12": {
            padding: 12,
        },
    },
    prevButton: {
        marginRight: 5,
        display: "inline-block",
        // "&::after": {
        //     content: "''",
        //     borderTop: "7px solid transparent",
        //     borderBottom: "7px solid transparent",
        //     borderRight: "13px solid #FCB364",
        //     visibility: "visible",
        //     display: "inline-block",
        //     position: "static",
        //     opacity: 1,
        //     animation: "none"
        // }
    },
    nextButton: {
        marginLeft: 5,
        display: "inline-block",
        // "&::after": {
        //     content: "''",
        //     borderTop: "7px solid transparent",
        //     borderBottom: "7px solid transparent",
        //     borderLeft: "13px solid #FCB364",
        //     visibility: "visible",
        //     display: "inline-block",
        //     position: "static",
        //     opacity: 1,
        //     animation: "none"
        // }
    },
    downloadsHeading: {
        fontSize: 16,
        fontWeight: "500",
        lineHeight: "1.15",
        color: "#14a4c2",
    },
    downloadsRectangle: {
        padding: "15px 5px",
        borderRadius: "12px",
        border: "solid 1px #14a4c2",
        backgroundColor: "#e8f6f9",
        marginTop: 15,
        "& .ant-row": {
            justifyContent: "space-between"
        },
        "& p": {
            margin: 0
        }
    },
    thirdSection: {
        padding: "10px 12px 12px 12px",
        overflow: "hidden",
        "& $bill": {
            "& h6": {
                marginBottom: "15px",
            },
            "& p": {
                margin: "10px 0",
            },
        },
        "& .ant-row": {
            wordBreak: "break-word",
            borderBottom: "solid 1px rgb(151 151 151 / 35%)",
        },
    },

    thirdSectionCustom: {
        padding: "15px 15px 0 15px",
        overflow: "hidden",
        "& $bill": {
            "& h6": {
                marginBottom: "15px",
            },
            "& p": {
                margin: "10px 0",
            },
        },
        "& .ant-row": {
            wordBreak: "break-word",
        },
    },
    downloadgstDetails: {
        "& .ant-row:last-child": {
            borderBottom: "none",
        },
    },
    totalsection: {
        "& .ant-row": {
            borderBottom: "none",
        },
        "&.ant-row-bottom": {
            alignItems: "flex-end !important"
        }
    },
    downloadDesign: {
        width: "100%"
    },
    totalsectiondetails: {
        borderRadius: "12px",
        border: "1px solid #14a4c2",
        backgroundColor: "#e8f6f9",
        padding: "5px 10px 40px 10px",
        position: "relative",
        width: "100%",
        minHeight: "188px",
        "& p": {
            fontSize: 14,
            fontWeight: "400",
            lineHeight: "1.3",
            textAlign: "left",
            color: "#000",
            marginBottom: "0",
            "& b": {
                fontWeight: 500
            }
        },
        "& $margin5b": {
            marginBottom: '5px !important',
        },
        "& $marginBottom10": {
            marginBottom: '10px !important',
        },
    },
    authorizedSign: {
        position: "absolute",
        bottom: "10px",
        right: "10px",
    },
    totalsectionamount: {
        borderRadius: "12px",
        border: "solid 1px #14a4c2",
        backgroundColor: "#e8f6f9",
        "& p": {
            marginBottom: "0",
            fontSize: 19,
            color: "#000"
        },
    },
    col_28: {
        width: "28%",
    },
    col_24: {
        width: "24%",
    },
    col_2: {
        width: "50%",
    },
    invoiceRow: {
        marginTop: 20,
        "&:first-child": {
            marginTop: 0
        }
    },
    lineRowHead: {
        backgroundColor: "#f5f5f5",
        color: "#8a8a8e",
        padding: 10
    },
    lineRowBody: {
        color: "#000",
        padding: 10,
        lineHeight: 1
    },
    totalsectiontaxamount: {
        fontSize: 20,
        color: "#000000",
        "& $totalsectionamount": {
            padding: "12px 15px",
        },
    },
    blueHeader: {
        color: "#14a4c2",
    },
    textclblack: {
        color: "#000000",
    },
    pad1520: {
        padding: "12px 15px 12px 20px",
    },
    alginitemNormal: {
        alignItems: "normal !important",
    },
    alginitemEnd: {
        alignItems: "end !important",
    },
    dispalyIF: {
        display: "inline-flex",
    },

    downloadtopbarHeading: {
        fontSize: "29px",
        fontWeight: "500",
        lineHeight: "0.93",
        color: "#ffc27a",
        "& span": {
            fontSize: "18px !important",
        }
    },
    ddfsection: {
        padding: "7px 25px 3px 25px",
        backgroundColor: "#d6d8e8",
        "& h1": {
            fontSize: 20,
            fontWeight: "500",
            textAlign: "left",
            color: "#010101",
            lineHeight: "normal",
        },
        "& p": {
            fontSize: 16,
            fontWeight: "400",
            textAlign: "left",
            color: "#010101",
            lineHeight: "normal",
            marginBottom: "10px",
        },
        "& $downloadimages": {
            position: "absolute",
            right: "0",
            top: "0",
            left: "auto",
            width: "155px",
            height: "100%",
        },
        "& $productImageUploadInner": {
            padding: "10px",
            height: "auto",
            "& p": {
                color: "#8a8a8e",
                textAlign: "center",
                marginTop: "10px",
            },
        },
    },
    processbar: {
        padding: "8px",
        borderRadius: "25px",
        backgroundColor: "#1c314c",
    },
    ddssection: {
        border: "1px solid #1c314c",
        "& h1": {
            fontSize: 20,
            fontWeight: "500",
            lineHeight: "normal",
            color: "#000000",
        },
        "& h6": {
            fontSize: 16,
            fontWeight: "400",
            color: "#8a8a8e",
            marginBottom: "7px",
            lineHeight: "normal",
        },
        "& p": {
            fontSize: 16,
            fontWeight: "400",
            color: "#000000",
            marginBottom: "7px",
            lineHeight: "normal",
        },
        "& $downloadsHeading": {
            color: "#1c314c",
        },
        "& $totalsectiondetails": {
            border: "1px solid #1c314c",
            backgroundColor: "#d6d8e8",
            "& p": {
                color: "#000",
                fontSize: 14,
                textAlign: "left",
                fontWeight: "400",
                lineHeight: "normal",
                marginBottom: "0",
            },
        },
        "& $totalsectionamount": {
            border: "1px solid #1c314c",
            backgroundColor: "#d6d8e8",
        },
        "& $blueHeader": {
            color: "#1c314c",
        },
    },
    customDDssection: {
        borderBottom: "1px solid #1c314c",
        paddingBottom: '15px',
        paddingTop: '20px',
        paddingLeft: '15px'
    },
    customForm9: {
        paddingBottom: '15px',
        paddingTop: '20px',
        paddingLeft: '15px'
    },
    customForm5: {
        paddingBottom: 15,
        paddingTop: 15
    },
    ddssectionpadding: {
        padding: 15,
        borderRight: "1px solid #1c314c",
    },
    ddssectionpadding2: {
        padding: 15,
        backgroundColor: "#d6d8e8",
        "& $fontWeight500": {
            fontWeight: "500 !important",
        },
    },
    Bordertab_1: {
        textTransform: "none"
    },
    lefttopTriangle: {

    },
    righttopTriangle: {
        position: 'absolute',
        top: '0',
        right: '0',
        height: '70px',
        width: '80px',
        "& $downloadimages": {
            left: 'auto',
            right: '0',
            width: '80px',
        },
    },
    formatSecond: {
        "& $termsandcondition": {
            "& $span": {
                color: "#1c314c",
                fontWeight: "500",
            },
        },
    },
    formatFive: {
        overflow: "hidden",
        "& $downloadsecondbar": {
            padding: "0",
            backgroundColor: "transparent",
            textAlign: "left",
            marginTop: "15px",
            lineHeight: "0.94",
        },
        "& $downloadsRectangle": {
            marginTop: "15px",
            borderRadius: "0",
            border: "solid 1px #317787",
        },
        "& $blueHeader": {
            color: "#317787",
        },
        "& $downloadsHeading": {
            color: "#317787",
        },
        "& $thirdSection": {
            border: "solid 1px #317787",
        },
        "& $totalsectiondetails": {
            border: "solid 1px #317787",
            borderRadius: "0",
        },
        "& $totalsectionamount": {
            border: "solid 1px #317787",
            borderRadius: "0",
        },
        "& $termsandcondition": {
            "& $span": {
                color: "#317787",
                fontWeight: "500",
            },
        },
    },
    topBar: {
        backgroundColor: "#f5f5f5",
        borderTop: "5px solid #317787",
        borderBottom: "5px solid #317787",
        margin: "0px -5px 25px",
        "& h1": {
            fontSize: "69px",
            fontWeight: "normal",
            lineHeight: "0.94",
            color: "#ffa539",
            padding: "15px 24px",
            margin: "0",
        },
    },
    paddingTop55: {
        paddingTop: "55px",
    },
    formatSix: {
        "&$paddingTop55": {
            paddingTop: "55px",
        },
        "& $billtoppadding": {
            padding: "12px",
        },
        "& $billtoppadding:last-child": {
            padding: "12px",
        },
        "& $billbottompadding": {
            padding: "12px",
        },
        "& $billbottompadding:last-child": {
            padding: "12px",
        },
        "& $borderRight": {
            borderRight: "2px solid #317787",
        },
        "& $downloadimages": {
            top: "50%",
            left: "auto",
            right: "24px",
            width: "180px",
            height: "170px",
            transform: "translateY(-50%)",
            border: "5px solid #317787",
        },
        "& $productImageUploadInner": {
            padding: "12px",
        },
        "& $downloadsecondbar": {
            padding: "0",
            backgroundColor: "transparent",
            textAlign: "left",
            marginTop: "0",
            lineHeight: "0.94",
        },
        "& $downloadsRectangle": {
            padding: 15,
            marginTop: "15px",
            borderRadius: "0",
            border: "solid 1px #317787",
            backgroundColor: "#f5f5f5",
        },
        "& $blueHeader": {
            color: "#317787",
        },
        "& $downloadsHeading": {
            color: "#317787",
        },
        "& $thirdSection": {
            // border: "solid 1px #317787",
            padding: 0
        },
        "& $totalsectiondetails": {
            border: "solid 1px #317787",
            borderRadius: "0",
            backgroundColor: "#f5f5f5",
        },
        "& $totalsectionamount": {
            border: "solid 1px #317787",
            borderRadius: "0",
            backgroundColor: "#f5f5f5",
        },
        "& $termsandcondition": {
            "& $span": {
                color: "#317787",
                fontWeight: "500",
            },
        },
    },
    formatseven: {
        "& $downloadtopbar": {
            padding: "40px",
            margin: "0 0 25px 0",
            backgroundColor: "#bee0eb",
            position: "relative",
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        },
        "& $downloadimages": {
            width: "95px",
            left: "-24px",
            zIndex: "1",
        },
        "& $billtoppadding": {
            padding: "13px 0 50px 0",
        },
        "& $billbottompadding": {
            padding: "0",
        },
        "& $downloadsecondbar": {
            padding: "0",
            backgroundColor: "transparent",
            textAlign: "left",
            marginTop: "0",
            lineHeight: "0.94",
        },
        "& $downloadsRectangle": {
            padding: "20px 15px",
            marginTop: "0",
            borderRadius: "0",
            border: "none",
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            backgroundColor: "#bee0eb",
        },
        "& $blueHeader": {
            color: "#317787",
        },
        "& $downloadsHeading": {
            color: "#317787",
        },
        "& $thirdSection": {
            border: "none",
            backgroundColor: "#fff",
            boxShadow: "0 3px 6px 0 #bee0eb",
            "& .ant-row": {
                borderBottom: "solid 1px #317787",
            },
            "& $totalsection": {
                "& .ant-row": {
                    borderBottom: "none",
                }
            },
        },
        "& $totalsectiondetails": {
            border: "none",
            borderRadius: "0",
            backgroundColor: "#bee0eb",
        },
        "& $totalsectionamount": {
            border: "none",
            borderRadius: "0",
            backgroundColor: "#bee0eb",
        },
        "& $bill": {
            "& h6": {
                color: "#14a4c2",
            },
        },
        "& $downloadgstDetails": {
            "& .ant-row:last-child": {
                borderBottom: "none",
            },
        },
        "& $termsandcondition": {
            "& $span": {
                color: "#317787",
                fontWeight: "500",
            },
        },
    },
    formatsevenbillrow: {
        margin: "0",
    },
    formatsevenbillcol: {
        padding: "0",
    },
    paleblueborder: {
        border: "solid 2px #bee0eb",
    },
    bigBorder: {
        border: "10px solid #FFFFFF",
        position: "absolute",
        width: "100%",
        bottom: "10px",
        left: "0",
        boxShadow: "0 -3px 6px 0 rgba(0, 0, 0, 0.16)",
    },
    invoicehead: {
        fontSize: "45px",
        fontWeight: "500",
        lineHeight: "0.93",
        color: "#1c314c",
        position: "absolute",
        bottom: "30px",
        right: "24px",
        padding: "9px 50px 0 17px",
        backgroundColor: "#FFFFFF",
        zIndex: "1",
        boxShadow: "0 -3px 6px 0 rgba(0, 0, 0, 0.16)",
    },
    termsandcondition: {
        fontSize: 16,
        "& $span": {
            color: "#14a4c2",
        },
    },
    unitFor: {
        position: "absolute",
        bottom: 0,
        left: 10,
        backgroundColor: "#ccc",
        borderRadius: "5px",
        padding: "2px 5px",
        fontSize: "13px",
    },
    unitForText: {
        paddingLeft: "45px"
    },
    uploadErrorBreak: {

    },
    uploadError: {
        width: "100%",
        "&$uploadErrorBreak": {
            "& .MuiPaper-root": {
                wordBreak: "break-word",
            }
        },
        "& .MuiPaper-root": {
            borderRadius: "10px",
            wordBreak: "break-all",
            marginBottom: 10
        },
        "& :nth-child(2)": {
            maxHeight: "150px",
            overflow: "auto",
            width: "100%"
        }
    },
    emailText: {
        wordBreak: "break-word",
    },
    greyBg: {
        backgroundColor: "#ececec",
        display: "inline-block",
        height: "16px",
        position: "relative !important",
        transform: "none !important",
        right: "auto !important",
        top: "auto !important"
    },
    smallWidth: {
        width: "100px",
    },
    mediumWidth: {
        width: "150px",
    },
    largeWidth: {
        width: "300px",
    },
    tablecontainInner: {
        height: "calc(100% - 45px)",
        overflow: "auto",
        paddingRight: "15px"
    },
    pageBreak: {
        pageBreakInside: "avoid",
        display: "block",
        // pageBreakBefore: "auto",
        // pageBreakAfter: "auto",
        breakInside: "avoid"
    },
    pageBreakRow: {
        pageBreakInside: "avoid",
        display: "block",
        pageBreakBefore: "auto",
        pageBreakAfter: "auto",
        WebkitColumnBreakInside: "avoid"
    },
    selfBillItemsSecondHeader: {
        display: "none"
    },
    addMarginTop: {
        marginTop: 350
    },
    downloadPdf: {
        "& $selfBillItemsSecondHeader": {
            display: "flex",
            marginTop: "20px",
            pageBreakInside: "avoid",
            pageBreakBefore: "auto",
            pageBreakAfter: "auto"
        },
    },
    boxBorderInnerConstruction: {
        overflow: "hidden",
        borderRadius: 10,
        "& .ant-image": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            "& .ant-image-img": {
                width: "100%",
                height: "100%",
            }
        },

        // "&:after": {
        //     content: "''",
        //     position: "absolute",
        //     width: "100%",
        //     height: "100%",
        //     left: 0,
        //     top: 0,
        //     backgroundColor: "color(srgb 0 0 0 / 0.8)",
        //     zIndex: 99,
        // },
    },
    productSummary: {
        "& $lineRowBody": {
            borderBottom: '1px solid rgba(224, 224, 224, 1)'
        }
    },
    printFullPage: {
        display: "block",

    },

    notificationBar: {
        color: "#fff",
        fontSize: "14px",
        fontWeight: 500,
        textAlign: "center",
        backgroundColor: "#ffc27a",
        position: "absolute",
        bottom: "-6px",
        maxWidth: "574px",
        width: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        borderRadius: "5px",
        boxShadow: "0 3px 6px 0 rgb(0 0 0 / 16%)",
        '& a': {
            color: "#fff",
        }
    },
    multiples: {},
    notificationButtons: {
        padding: "8px 20px",
        boxShadow: "3px 0 6px 0 rgb(0 0 0 / 16%) !important",
        "& $secBtn": {
            padding: "5px 20px",
        },
        "& $AddMoreBtn": {
            padding: "5px 20px",
        },
        '& $deleteBtn': {
            padding: "5px 20px",
            margin: 0,
            "& >*": {
                display: "inline-block"
            },
            "& .ant-image": {
                width: 9
            }
        },
        "& $textAlignLeft": {
            "& div": {
                marginLeft: 10
            },
            "&>*": {
                display: "inline-block",
                verticalAlign: "middle"
            }
        }
    },
    notificationTable: {
        '&$accordionHead': {
            '& $accordionBody': {
                '& .MuiTableContainer-root': {
                    height: "calc(100% - 10px)",
                    paddingRight: "15px"
                }
            },
            "& $searchAnimation": {
                maxWidth: 250
            }
        },
        '& .checkbox': {
            display: "none"
        },
        "&$multiples": {
            '& .checkbox': {
                display: "table-cell",
                padding: "0px 10px",
                "& .MuiCheckbox-root .MuiSvgIcon-root": {
                    fontSize: 17
                }
            },
        },
        '& $deleteBtn': {
            padding: "5px 20px",
            margin: 0,
            "& >*": {
                display: "inline-block"
            },
            "& .ant-image": {
                width: 9
            }
        },
        "& $tableRoot": {
            borderRadius: "0px !important",
            "& th.MuiTableCell-root.MuiTableCell-head": {
                padding: "4px 10px 4px 10px",
                '&.checkbox': {
                    padding: "0px 10px",
                },
            },
            "& .MuiTableCell-root": {
                padding: "12px 10px"
            },
            "& .MuiTable-root tr td:last-child": {
                padding: "4px 0 4px 10px"
            }
        }
    },
    notificationText: {
        color: "#317787",
        fontWeight: "normal",
        '& > span': {
            position: "relative",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "block",
            width: 500
        }
    },
    notificationClose: {
        width: 15,
        height: 15,
    },
    notificationCount: {
        position: "absolute",
        right: 5,
        top: "46%",
        transform: "translateY(-50%)",
        backgroundColor: "#FF0000",
        color: "#fff",
        borderRadius: "5px",
        // width: "14px",
        // height: "14px",
        zIndex: 1,
        padding: "2px",
        '& span': {
            // position: "absolute",
            // top: "50%",
            // left: "50%",
            fontSize: "10px",
            lineHeight: 1,
            // transform: "translate(-50%, -50%)"
        }
    },
    notificationMenu: {
        height: "500px"
    },
    deleteNotificationPopup: {
        "& $textFieldLableColorCustom": {
            paddingRight: 0,
            "& .ant-image": {
                fontSize: 0
            },
            "& >*": {
                display: "inline-block",
                verticalAlign: "middle",
                lineHeight: 1
            }
        }
    },
    Col5: { width: "50%" },
    dashboardInnerRow: {},
    dashboardRow: {
        margin: "0 -15px",
        '& $dashboardInnerRow': {
            margin: "0 -15px",
        },
        '& $Col': {
            padding: "0 15px"
        }
    },
    monthlyDivClients: {
        "& .apexcharts-legend": {
            top: "50% !important",
            transform: "translateY(-50%)",
            height: 162,
            width: 150
        }
    },
    monthlyDivTitleNext: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column"
    },
    monthlyDiv: {
        padding: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "& $searchAnimation": {
            width: "100%"
        },
        "& $tableRoot": {
            border: "none",
            boxShadow: "none",
            height: "calc(100% - 88px)",
            "& .MuiTableContainer-root": {
                height: "100%"
            },
            "& $tablecontain": {
                "& $textFieldLableColorCustom": {
                    paddingRight: 0
                },
            },
            "& $textFieldLableColorCustom": {
                paddingRight: 7
            },
            "& $loadMoreCircle": {
                height: 75
            }
        }
    },
    monthlySalesDecreases: {
        "& $currentMonth": {
            marginTop: 0,
            alignItems: "start"
        },
        "& $currentMonthPer": {
            marginTop: 20
        },
        "& $lastMonth": {
            alignItems: "end",
            marginTop: 20,
        },
    },
    salesTrendsChart: {
        "& $tooltipTrends": {
            left: 100
        },
    },
    tooltipTrends: {
        position: "absolute",
        zIndex: 999,
        top: 23,
        left: 120
    },
    monthlyDivTitle: {
        color: "#14a4c2",
        position: "relative",

    },
    productTitle: {
        color: "#14a4c2",
        position: "relative",
        fontSize: '12px',
        paddingLeft: '10px'
    },
    hamburgerMenu: {
        position: "absolute",
        top: "50%",
        right: 0,
        transform: "translateY(-50%)",
        zIndex: 99,
        fontSize: 0,
        cursor: "pointer",
        "& .ant-image": {
            width: 17
        },
    },

    chartDivDownload: {
        top: 32,
        right: 32,
    },
    mobileDevice: {
        "& $chartDivDownload": {
            top: "15px !important",
            right: 15,
        },
        "&$topProductSupply": {
            "& $hamburgerMenu": {
                top: 0,
                bottom: "auto",
                transform: "none",
            },
        },
        "& $hamburgerMenu": {
            top: 0,
            transform: "none",
        },
        "& $lastDaysRadio": {
            top: 0,
            transform: "none",
        }
    },
    hamburgeGroupMenu: {

    },
    currentMonth: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "end",
        marginTop: 20,
        "& >*": {
            display: "inline-block",
            verticalAlign: "bottom",
            width: "100%"
        },
        "& $triAngleContentImage": {
            width: "85%",
            paddingTop: "80%",
            marginTop: 0
        }
    },
    lastMonth: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "start",
        "& >*": {
            display: "inline-block",
            verticalAlign: "bottom"
        }
    },
    lastMonthBorder: {
        position: "relative",
        "&:after": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            width: 0,
            height: 1,
            backgroundColor: "#1c314c",
            transition: "width .6s .5s"
        }
    },
    inCurrentTriAngleContentImage: {
        opacity: 0,
        transform: "translateY(20px)",
        transition: "opacity .4s .9s, transform .4s 1s"
    },
    deLastTriAngleContentImage: {
        opacity: 0,
        transform: "translateY(20px)",
        transition: "opacity .4s .9s, transform .4s 1s"
    },
    inLastTriAngleContentImage: {
        opacity: 0,
        transform: "translateY(-20px)",
        transition: "opacity .4s .9s, transform .4s 1s"
    },
    deCurrentTriAngleContentImage: {
        opacity: 0,
        transform: "translateY(-20px)",
        transition: "opacity .4s .9s, transform .4s 1s"
    },
    percentageAnimation: {
        opacity: 0,
        transform: "translateX(-20px)",
        transition: "opacity .4s .9s, transform .4s 1s"
    },
    triAngleContentAnimation: {
        opacity: 0,
        display: "inline-block",
        transform: "translateX(-50px)",
        transition: "opacity .4s .6s, transform .4s .7s"
    },
    activeSlider: {
        display: "none"
    },
    monthlySalesLoading: {
        "& $lastMonthBorder": {
            "&:after": {
                width: "100%"
            }
        },
        "& $triAngleContentAnimation": {
            opacity: 1,
            transform: "translateX(0)"
        },
        "& $percentageAnimation": {
            opacity: 1,
            transform: "translateX(0)"
        },
        "& $inCurrentTriAngleContentImage": {
            opacity: 1,
            transform: "translateY(0)"
        },
        "& $inLastTriAngleContentImage": {
            opacity: 1,
            transform: "translateY(0)"
        },
        "& $deCurrentTriAngleContentImage": {
            opacity: 1,
            transform: "translateY(0)"
        },
        "& $deLastTriAngleContentImage": {
            opacity: 1,
            transform: "translateY(0)"
        },
        "& $colorCircle": {
            opacity: 1,
            transform: "translateX(-50%) scale(1)"
        },
        "& $bgColorBlock": {
            opacity: 1,
            transform: "translateX(-50%) scale(1)"
        },
        "& $cBlock1": {
            transform: "rotate(0)",
            opacity: 1,
            "& $textWrap": {
                transform: "translate(0, 0)",
                opacity: 1
            }
        },
        "& $cBlock2": {
            transform: "rotate(0)",
            opacity: 1,
            "& $textWrap": {
                transform: "translate(0, 0)",
                opacity: 1
            }
        },
    },
    triAngleContent: {
        position: "relative",
        textAlign: "right",
        "& img": {
            width: "165px",
            height: "auto"
        }
    },
    currentMonthIncreases: {
        textAlign: "center"
    },
    currentMonthPer: {
        fontSize: 22,
        lineHeight: 1,
        whiteSpace: "nowrap"
    },
    currentMonthText: {
        fontSize: 18,
        lineHeight: 1,
        color: "#16c88b",
        marginBottom: 15,
        "&.Decreases": {
            color: "#FF0000",
        }
    },
    triAngleContentText: {
        fontSize: 14,
        color: "#14a4c2"
    },
    triAngleContentAmount: {
        fontSize: 24,
        color: "#1c314c"
    },
    triAngleContentImage: {
        paddingTop: "23%",
        width: "25%"
    },
    paddingTopCustom: {
        position: "relative",
        "&::before": {
            content: "''",
            display: "block", paddingTop: "35%"
        }
    },
    bgFull: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "url() no-repeat 50% 50%",
        overflow: "hidden",
        backgroundSize: "contain",
        transition: "top .5s"
    },
    lastDays: {},
    topTenTitle: {},
    lastDaysRadio: {
        position: "absolute",
        top: "50%",
        right: 22,
        transform: "translateY(-50%)"
    },

    totalSalesProduct: {
        position: "absolute",
        top: "50%",
        right: 22,
        transform: "translateY(-50%)"
    },
    lastDaysRadioSupply: {
        maxWidth: 210,
        marginLeft: "auto"
    },
    salesProduct: {
        "& .MuiFormControlLabel-root": {
            marginLeft: 0,
            marginRight: 5,
            "& .MuiTypography-root": {
                fontSize: 12,
                color: "#d9d9d9"
            },
            "& .MuiRadio-root": {
                padding: "0 5px 0 0",
                "&.Mui-checked + .MuiTypography-root": {
                    color: "#1c314c",
                    fontWeight: "500"
                },
                "& $selectedIcon": {
                    width: 10,
                    height: 10,
                    backgroundColor: "#d9d9d9",
                    "&$unSelectedIcon": {
                        width: 10,
                        height: 10,
                        backgroundColor: "#14a4c2",
                        "&::before": {
                            content: "none"
                        }
                    }

                }
            }
        }
    },
    topProductSupply: {
        "& $monthlyDivTitle": {
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 10,
            borderBottom: "solid 0.5px #FCB364",
            marginBottom: 10,
            alignItems: "center",
            "& span:first-child": {
                whiteSpace: "nowrap",
                paddingRight: 5
            }
        },
        "& $hamburgerMenu": {
            position: "relative",
            top: "auto",
            bottom: "100%",
            transform: "none",
        },
        "& $lastDaysRadioSupply": {
            "& >*": {
                display: "inline-block",
                verticalAlign: "middle",
                borderLeft: "1px solid #fcb364",
                paddingLeft: 5,
                lineHeight: 1,
            }
        }
    },
    monthlyDivTitleRadio: {},

    totalChartDiv: {
        padding: "20px",
        height: "100%",
        "&$topProductSupply": {
            "& $monthlyDivTitle": {
                "& .MuiFormControlLabel-root": {
                    "& .MuiTypography-root": {
                        fontSize: 11,
                    },
                }
            }
        },
        "&$mobileDevice": {
            "& $monthlyDivTitle": {
                "& $lastDays": {
                    padding: 0,
                    margin: 0,
                    borderLeft: "none"
                },
            }
        },
        "& $monthlyDivTitle": {
            "& >*": {
                display: "inline-block",
                verticalAlign: "middle",
                lineHeight: 1,
            },
            "& $lastDays": {
                padding: " 0 6px",
                margin: "0 6px",
                borderLeft: "1px solid #ffa539"
            },
            "& $monthlyDivTitleRadio": {
                "& .MuiFormControlLabel-root": {
                    "& .MuiTypography-root": {
                        letterSpacing: "0.12em"
                    },
                }
            },
            "& .MuiFormControlLabel-root": {
                marginLeft: 0,
                marginRight: 5,
                "& .MuiTypography-root": {
                    fontSize: 12,
                    color: "#d9d9d9"
                },
                "& .MuiRadio-root": {
                    padding: "0 5px 0 0",
                    "&.Mui-checked + .MuiTypography-root": {
                        color: "#1c314c",
                        fontWeight: "500"
                    },
                    "& $selectedIcon": {
                        width: 10,
                        height: 10,
                        backgroundColor: "#d9d9d9",
                        "&$unSelectedIcon": {
                            width: 10,
                            height: 10,
                            backgroundColor: "#14a4c2",
                            "&::before": {
                                content: "none"
                            }
                        }

                    }
                }
            }
        },
        "& $topTenTitle": {
            marginTop: 2,
            lineHeight: 1, borderTop: "0.5px solid #ffa539",
            "& >*": {
                display: "inline-block"
            },
            "& $lastDays": {
                padding: " 0 6px",
                margin: "0 6px",
                borderLeft: "1px solid #ffa539",
                borderRight: "1px solid #ffa539"
            },
            "& .MuiFormControlLabel-root": {
                marginLeft: 0,
                marginRight: 35,
                "& .MuiTypography-root": {
                    fontSize: 14,
                    color: "#d9d9d9"
                },
                "& .MuiRadio-root": {
                    padding: "0 15px 0 0",
                    "&.Mui-checked + .MuiTypography-root": {
                        color: "#14a4c2"
                    },
                    "& $selectedIcon": {
                        width: 14,
                        height: 14,
                        backgroundColor: "#d9d9d9",
                        "&$unSelectedIcon": {
                            width: 14,
                            height: 14,
                            backgroundColor: "#14a4c2",
                            "&::before": {
                                content: "none"
                            }
                        }

                    }
                }
            }
        }
    },
    groupChart: {
        paddingTop: 5,
        borderTop: "1px solid #ffa539"
    },
    groupChartRow: {

        marginTop: 10,
    },
    groupChartSeperate: {
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#f5f5f5",
        height: "100%",
        "& >div": {
            minHeight: "70px !important"
        }
    },
    daysRow: {
        marginTop: 5
    },
    daysRowContent: {
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "#f5f5f5",
        padding: "5px 10px",
        marginTop: 5,
        marginRight: 70,
    },
    daysRowTitle: {
        fontSize: 14,
        color: "#317787",
        marginTop: 20,
        textTransform: "capitalize",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        display: "block"
    },
    daysRowCircle: {
        position: "absolute",
        left: "95%",
        top: "50%",
        transform: "translateY(-62%)",
        width: 110,
        height: 60
    },
    daysRowContentTitle: {
        fontSize: 12,
        color: "#8a8a8e"
    },
    daysRowContentInner: {
        fontSize: 14,
    },
    daysRowText: {
        fontSize: 14,
        lineHeight: 1,
        marginTop: 5,
        color: "#000",
        whiteSpace: "nowrap"
    },
    bg_green: {
        backgroundColor: "#E4F8F1",
    },
    bg_blue: {
        backgroundColor: "#aed4dc",
    },
    bg_yellow: {
        backgroundColor: "#FDD9B2",
    },
    sales15Days: {
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        padding: 10,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "& > div:first-child": {
            color: "#1c314c",
            fontSize: 11
        },
        "& > div:nth-child(2)": {
            color: "#1c314c",
            fontSize: 11,
        },
        "& > div:nth-child(3)": {
            color: "#1c314c",
            fontSize: 20,
        }
    },
    sales30Days: {
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        padding: 10,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    sales90Days: {
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        padding: 10,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    chartOverDue: {
        marginTop: 10,
        paddingTop: 10,
        paddingBottom: 10,
        borderTop: "1px solid #ffa539",
        borderBottom: "1px solid #ffa539",
        marginBottom: 10,
    },
    totalInvoiceDue: {
        fontSize: 12,
        padding: 8,
        lineHeight: 1.2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        color: "#1c314c",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.5)",
        alignItems: "start",
        "& $daysRowTitle": {
            color: "#1c314c",
        },
        "&:hover": {
            color: "#1c314c",
            "& $daysRowTitle": {
                color: "#317787"
            }
        }
    },
    dueDate: {
        fontSize: 12,
        color: "#14a4c2",
    },
    chartOverDueContent: {
        position: "relative",
        paddingTop: 15,
        paddingBottom: 15,
        borderBottom: "1px solid #ffa539",
        "&:first-child": {
            paddingTop: 0,
        },
        "&:last-child": {
            borderBottom: "none"
        },
        "& $daysRowContent": {
            marginRight: 0
        },
        "& .swiper-button-prev": {
            right: 0,
        },
        "& .swiper-button-next": {
            right: 0,
        }
    },
    bg_due_yellow: {
        backgroundColor: "#fef1e3"
    },
    bg_due_blue: {
        backgroundColor: "#f5fdfa"
    },
    dueDays: {
        fontSize: 12,
        color: "#14a4c2",
        marginLeft: 15,
        position: "relative",
        paddingLeft: 8,
        "&:before": {
            content: "''",
            width: 6,
            height: 6,
            backgroundColor: "#14a4c2",
            borderRadius: "50%",
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            left: 0
        }
    },
    overDuedaysRowTitle: {
        "&>*": {
            display: "inline-block",
            verticalAlign: "middle"
        },
        "& > span:first-child": {
            borderRadius: "50%",
            color: "#000",
            padding: 2,
            fontSize: 12,
            lineHeight: 1,
            width: 20,
            height: 20,
            verticalAlign: "middle",
            marginRight: 5,
            position: "relative",
            "& span": {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            }
        },
        "& $bg_blue_light": {
            border: "1px solid #14a4c2"
        },
        "& $bg_yellow_light": {
            border: "1px solid #ffa539"
        },
        "& $bg_green_light": {
            border: "1px solid #317787"
        },
        "& $bg_gray_light": {
            border: "1px solid #979797"
        }
    },
    totalInvoicesAmount: {
        fontSize: 25,
        marginTop: 5,
        whiteSpace: "nowrap",
        position: "relative",
        width: "100%",
        "& span": {
            position: "absolute",
            right: 0,
            top: 0,
            paddingLeft: 10,
            lineHeight: 1,
            "&:before": {
                content: "''",
                position: "absolute",
                left: 0,
                top: 0,
                height: "100%",
                width: 2,
                backgroundColor: "#ffa539"
            }
        }
    },
    primaryMenu: {
        "& .ant-row": {
            height: "100%",
            "& > .ant-col": {
                height: "100%",
            }
        }
    },
    subMenuLinkTitle: {
        color: "rgba(0,0,0,.45)",
        fontWeight: 400,
        fontSize: 14,
        wordBreak: "break-word",
        marginBottom: 10
    },
    subMenuLinks: {
        height: "calc(100% - 30px)",
        overflow: "auto",
        paddingRight: 5,
        visibility: "hidden",
        "& > div": {
            height: "100%",
            visibility: "visible",
            "& $margin10t:first-child": {
                marginTop: 0
            }
        },
        "&:hover": {
            visibility: "visible",
        }
    },
    lastDaysContent: {
        marginTop: 15
    },
    bestSellingProducts: {
        "& $daysRowContent": {
            padding: "12px 6px",
            marginRight: 75,
            "& $daysRowContentTitle": {
                fontSize: 12,
                color: "#000",
            }
        },
        "& $daysRowCircle": {
            left: "105%",
            top: "auto",
            bottom: 0,
            transform: "none"
        }
    },
    salesByLocPara: {},
    salesByLoc: {
        alignItems: "center",
        "& p": {
            color: "#14a4c2",
            margin: "0px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "12px",
        },
        "& $salesByLocPara": {
            color: "#1c314c",
            marginTop: 6
        },
        "& h3": {
            fontFamily: "Roboto",
            fontSize: "19px",
            fontWeight: "500",
            color: "#1c314c"
        }
    },
    salesByLocradiabtn: {
        marginTop: 5,
        "& $totalChartDiv": {
            backgroundColor: "#42a4bb",
            borderRadius: "10px",
            padding: "5px 10px",
            "& $monthlyDivTitle": {
                marginLeft: "0px !important",
                marginTop: "0px",
                lineHeight: "1",
                "& >*": {
                    display: "block"
                },
                "& .MuiFormControlLabel-root": {
                    margin: "0",
                    width: "33.33%",
                    display: "inline-block",
                    "& .MuiTypography-root": {
                        fontSize: 12,
                        color: "#ffffff"
                    },
                    "& .MuiRadio-root": {
                        padding: "0 5px 0 0",
                        "&.Mui-checked + .MuiTypography-root": {
                            color: "#ffffff"
                        },
                        "& $selectedIcon": {
                            width: 10,
                            height: 10,
                            backgroundColor: "#d9d9d9",
                            "&$unSelectedIcon": {
                                width: 10,
                                height: 10,
                                backgroundColor: "#ffa539",
                                "&::before": {
                                    content: "none"
                                }
                            }

                        }
                    }
                },
                "& .MuiFormControlLabel-root:nth-child(2)": {
                    textAlign: "center",
                },
                "& .MuiFormControlLabel-root:last-child": {
                    textAlign: "right",
                },
            }
        },
    },

    salesByLochead: {
        padding: "10px 0",
        "& p": {
            color: "#8a8a8e",
            margin: "0px",
            fontFamily: "Roboto",
            fontSize: "12px",
        },
    },
    salesByLocdetails: {
        fontFamily: "Roboto",
        color: "#000000",
        marginTop: 5,
        "& p": {
            margin: "0px",
            fontFamily: "Roboto",
            fontSize: "12px",
        },
        "& h3": {
            margin: "0px",
            fontSize: "16px",
        },
    },
    greenbox: {
        border: "solid 1px #16c88b",
        backgroundColor: "#f5fdfa",
        borderTop: "none"
    },
    topgreenBorder: {
        "&:first-child": {
            borderTop: "solid 1px #16c88b"
        }
    },
    bottomgreenBorder: {
        borderBottom: "solid 1px #16c88b"
    },
    orangebox: {
        border: "solid 1px #ffa539",
        backgroundColor: "#fef1e3",
        borderTop: "none"
    },
    toporangeBorder: {
        "&:first-child": {
            borderTop: "solid 1px #ffa539"
        }
    },
    bottomorangeBorder: {
        borderBottom: "solid 1px #ffa539"
    },
    bluebox: {
        border: "solid 1px #14a4c2",
        backgroundColor: "#e8f6f9",
        borderTop: "none"
    },
    topblueBorder: {
        "&:first-child": {
            borderTop: "solid 1px #14a4c2"
        }
    },
    bottomblueBorder: {
        borderBottom: "solid 1px #14a4c2"
    },
    noMinHeight: {
        minHeight: "0 !important",
    },
    viewBatchLines: {
        "&.MuiTabPanel-root": {
            padding: 0,
            height: "100%"
        }
    },
    leftbox: {
        height: "100%",
        minHeight: 85,
        display: "flex",
        padding: "8px 20px 8px 5px",
        flexDirection: "column",
        justifyContent: "center",
        "& h6": {
            margin: "0px",
            fontFamily: "Roboto",
            fontSize: "12px",
        },
        "& p": {
            margin: "0px",
            fontFamily: "Roboto",
            fontSize: "10px",
            color: "#14a4c2",
        },
        "& h3": {
            margin: "0px",
            whiteSpace: "nowrap",
            fontSize: "17px",
            color: "#1c314c"
        },
    },
    righttbox: {
        "& div": {
            height: "100%"
        },
        "& div.ant-row": {
            "& div": {
                display: "flex",
                justifyContent: "center",
                flexDirection: "column"
            }
        },
        "& h6": {
            margin: "0px",
            fontFamily: "Roboto",
            fontSize: "12px",
        },
        "& p": {
            margin: "0px",
            fontFamily: "Roboto",
            fontSize: "11px",
            color: "#1c314c",
        },
        "& h3": {
            margin: "0px",
            fontFamily: "Roboto",
            fontSize: "20px",
        },
        "& .ant-row": {
            alignItems: "center",
        }
    },
    ellipse: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    whiteBox: {
        padding: "5px",
        backgroundColor: "#f9f9f9",
    },
    greenBorder: {
        border: "solid 1px #16c88b",
        borderTop: "none",
        "&:first-child": {
            borderTop: "solid 1px #16c88b",
        },
    },
    rightgreenBorder: {
        borderRight: "solid 1px #16c88b",
    },
    backgroundColorGreen: {
        backgroundColor: "#f5fdfa",
    },
    orangeBorder: {
        border: "solid 1px #ffa539",
        "& .ant-row": {
            borderTop: "solid 1px #ffa539",
        },
        "& .ant-row:first-child": {
            borderTop: "none",
        },
    },
    rightorangeBorder: {
        borderRight: "solid 1px #ffa539",
    },
    backgroundColorOrange: {
        backgroundColor: "#fef1e3",
    },
    blueBorder: {
        border: "solid 1px #14a4c2",
        "& .ant-row": {
            borderTop: "solid 1px #14a4c2",
        },
        "& .ant-row:first-child": {
            borderTop: "none",
        },
    },
    rightblueBorder: {
        borderRight: "solid 1px #14a4c2",
    },
    backgroundColorBlue: {
        backgroundColor: "#e8f6f9",
    },
    totalSupDetails: {
        "& h6": {
            margin: 0,
            whiteSpace: "nowrap",
            fontSize: 14,
        },
        "& p": {
            margin: 0,
            fontSize: "12px",
            color: "#14a4c2",
        },
    },
    supName: {
        textTransform: "capitalize",
        backgroundColor: "#d9d9d9",
        boxShadow: "0px 3px 2px #c5c5c5",
        padding: "4px 5px 1px 5px",
        lineHeight: 1,
        fontSize: "14px",
        fontWeight: "500",
    },
    supNum: {
        backgroundColor: "#938e8e",
        boxShadow: "0px 5px 8px #6c6a6a",
        color: "#ffffff",
        fontSize: "20px",
        fontWeight: "500",
        borderRadius: "50%",
        position: "absolute",
        bottom: "100%",
        left: "50%",
        width: "50px",
        height: "50px",
        transform: "translateX(-50%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    supNumsimicir: {
        height: "35px",
        width: "100px",
        borderRadius: "150px 150px 0 0",
        position: "absolute",
        bottom: "0",
        left: "0",
    },
    supNumsStar: {
        position: "absolute",
        width: 75,
        bottom: "88%",
        left: "50%",
        zIndex: -1,
        transform: "translateX(-50%)",
        "& +$supNum": {
            width: 35,
            height: 35,
            fontSize: 17
        }
    },
    topGreen: {
        "& $supNumsimicir": {
            backgroundColor: "#b3edd9",
        },
    },
    topBlue: {
        "& $supNumsimicir": {
            backgroundColor: "#8ac8d5",
        },
    },
    topOrange: {
        "& $supNumsimicir": {
            backgroundColor: "#ffc27a",
        },
    },
    withOutGst: {
        '& .MuiTableCell-root': {
            border: "none"
        }
    },
    chartTopSuppliers: {
        borderTop: "1px solid #ffa539",
        // borderBottom: "1px solid #ffa539",
        padding: "5px 0",
        margin: "5px 0",
        "& $chartDiv": {
            padding: "0px 0 0 25px",
            "& > div:first-child": {
                minHeight: "150px !important"
            },
            "& .arrow_box": {
                width: "auto"
            }
        },
        "& $invoiceAmount": {
            top: 72,
            width: "28%",
            left: "-10%",
            transform: "rotate(-90deg)"
        }
    },
    totalSalesCustom: {
        "& $hamburgerMenu": {
            top: 17
        }
    },
    netGstSlider: {
        backgroundColor: "rgb(232 232 232 / 50%)",
        textAlign: "center",
        padding: "3px",
        color: "#1c314c",
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.5)"
    },
    netGstTitle: {
        fontSize: 14,

    },
    bg_blue_light: {
        backgroundColor: "#e8f6f9"
    },
    bg_yellow_light: {
        backgroundColor: "#fef1e3"
    },
    bg_green_light: {
        backgroundColor: "#f5fdfa"
    },
    bg_gray_light: {
        backgroundColor: "#efefef"
    },
    netGstSliderContent: {
        overflow: "hidden"
    },
    netGstSliderContentRow: {
        "&$bg_green >div:after": {
            backgroundColor: "#16C88B",
        },
        "&$bg_blue >div:after": {
            backgroundColor: "#14A4C2",
        },
        "&$bg_yellow >div:after": {
            backgroundColor: "#FFA539",
        },
        "& > div": {
            // borderLeft: "1px solid #14a4c2",
            padding: "5px 10px 5px 5px !important",
            "&:after": {
                content: "''",
                width: 1,
                height: "60%",
                backgroundColor: "#14a4c2",
                position: "absolute",
                left: "100%",
                top: "50%",
                transform: "translateY(-50%)"
            },

            "& p": {
                fontSize: 12,
                lineHeight: 1,
            },
            "&:first-child": {
                "& p": {
                    fontSize: 14,
                    lineHeight: 1,
                },
                border: "none",
                boxShadow: "0 3px 6px 0 rgb(0 0 0 / 16%)"
            },
            "&:nth-child(2)": {
                border: "none"
            },
        },
        "& h3": {
            fontSize: 10,
            fontWeight: "normal",
            margin: "0 0 5px 0",
        },
        "& p": {
            margin: 0,
        }
    },
    colorBoxSha: {
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.5)"
    },
    netGstSliderSecond: {
        "& p": {
            margin: 0
        }
    },
    largestOverdueName: {
        fontSize: 12,
        display: "inline-block",
        position: "relative",
        fontWeight: 500,
    },
    netGstSliderText: {
        padding: "10px 15px",
        textAlign: "right",
        "& h2": {
            fontSize: 15,
            color: "#1c314c",
            margin: 0,
            fontWeight: "normal"
        },
        "& h3": {
            fontSize: 10,
            color: "#1c314c",
            margin: 0,
            fontWeight: "normal"
        },
        "& h4": {
            fontSize: 20,
            color: "#1c314c",
            margin: 0,
        },
        "& p": {
            fontSize: 12,
            fontWeight: 500,
            color: "#1c314c",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }
    },
    netGstChart: {
        "& $chartDiv": {
            padding: "0px 0 20px 20px",
            "& > :first-child": {
                minHeight: "230px !important"
            },
            "& $invoiceAmount": {
                left: "-17%",
                width: "39%",
                backgroundColor: "#e8e8e8",
                fontWeight: 500
            },
            "& $invoiceMonths": {
                left: "53%",
                width: "87%",
                bottom: 0,
                backgroundColor: "#e8e8e8",
                fontWeight: 500
            }
        }
    },
    starSupplier: {
        fontSize: 12,
        color: "#1c314c",
        padding: "2.8px 2.9px 2.9px 2.9px",
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.5)",
        border: "solid 1px #1c314c",
        backgroundColor: "#e8f6f9",
        marginTop: "-10px"
    },
    chartImage: {
        alignItems: "center",
    },
    rowLocationCalc: {
        width: "100%",
        fontSize: 0,
        "& >div": {
            height: "10px",
            display: "inline-block"
        },
        "& >div:nth-child(2)": {
            backgroundColor: "#D9D9D9"
        }
    },
    customStateH: {
        height: "100%",
        "& div": {
            height: "100%",
            "& >div": {
                height: "100%",
                display: "flex"
            }
        }
    },
    dashboardIcon: {
        "&:hover": {
            "& $dashicontext": {
                color: "#01A4A6 !important"
            }
        }
    },
    lottieAnimationHover: {
        position: "relative",
        width: 150,
        height: 150,
        borderRadius: "50%",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16), inset 0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#e8f6f9"
    },
    lottieAnimationHoverInner: {
        width: "85%",
        height: "85%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        borderRadius: "50%"
    },
    mainDashIcon: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        position: "relative",
        transition: '.4s ',
        '& .ant-image-img': {
            width: '180px',
            height: 'auto',
            transition: 'width .4s'
        },
        "&$toggleOpen": {
            padding: '30px 0 10px',
            transition: 'padding .4s',
            '& .ant-image-img': {
                width: '100px',
                transition: 'width .4s'
            },
            '& $lottieAnimationHover': {
                width: '100px',
                height: "100px",
                transition: 'width .4s, height .4s'
            },
            "& $dashRow": {
                textAlign: 'center',
                paddingBottom: "15px"
            },
            "& $col_20": {
                "&:nth-child(2)": {
                    top: 0,
                    transition: 'top 0.4s'
                },
                "&:nth-child(4)": {
                    top: 0,
                    transition: 'top 0.4s'
                },
            },
        },
    },
    nodeLinkChilds: {},
    parentNodeUl: {
        listStyle: "none",
        overflow: "hidden",
        margin: 0,
        maxHeight: 0,
        transition: "max-height .4s",
        "& >$parentNode": {
            "& $parentNodeUl": {
                paddingLeft: 15
            },
            "& $nodeLink": {
                "& $nodeCustomName": {
                    marginLeft: 0
                }
            }
        }
    },
    pdfViewer: {},
    tranactionData: {
        fontSize: 11,
        position: "absolute",
        bottom: 1,
        left: 18,
        backgroundColor: "#fff",
        padding: 5,
        lineHeight: 1,
        "& > *": {
            display: "inline-block",
            verticalAlign: "middle"
        }
    },
    customShortCutKeysVideo: {},
    customShortCutKeys: {
        top: 0,
        width: "1200px !important",
        height: "100%",
        padding: "50px 15px 20px 15px",
        maxWidth: "none",
        "& .ant-modal-close-x": {
            width: "auto",
            height: "auto",
            lineHeight: 1
        },
        "&$customShortCutKeysVideo": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& .ant-modal-content": {
                width: "80%",
                height: "auto"
            },
            "& .ant-modal-close": {
                backgroundColor: "#fff",
                padding: 5,
                opacity: 0,
                top: 0,
                right: 0,
                borderRadius: 5,
                transition: "opacity .4s",
                transform: "none"
            },
            "& .ant-modal-content:hover": {
                "& .ant-modal-close": {
                    opacity: 1,
                },
            }
        },
        "&$pdfViewer": {
            width: "1150px !important",
            "& .ant-modal-close": {
                top: 29,
                right: 30,
                zIndex: 9999
            },
            "& .ant-modal-body": {
                padding: "10px"
            }
        },
        "& .ant-modal-close": {
            top: 30,
            right: 20
        },
        "& .ant-modal-content": {
            height: "100%"
        },
        "& .ant-modal-body": {
            height: "100%"
        }
    },
    customShortCutKeysContent: {
        overflow: "auto",
        height: "calc(100% - 35px)",
        width: "100%",
        maxWidth: 1400,
        margin: "10px auto 0 auto",
        "& img": {
            width: "100%",
            height: "auto"
        }
    },
    customShortCutKeysTitle: {
        position: "relative",
        fontSize: 22,
        color: "#1c314c",
        textAlign: "center",
        marginRight: 60,
        "& img": {
            width: "100%", height: "auto"
        },
        "& $hamburgerMenu": {
            right: "auto",
            left: "100%",
            marginLeft: "1.5%",
            cursor: "pointer"
        },
        "& span": {
            display: "inline-block",
            backgroundColor: "#fff",
            position: "relative"
        },
        "&::before": {
            content: "''",
            position: "absolute",
            top: "50%",
            left: 0,
            transform: "translateY(-50%)",
            width: "100%",
            height: 2,
            backgroundColor: "#ffa539"
        }
    },
    customShortCutKeyhamburgerMenu: {
        zIndex: 99999,
    },
    nodeLinkActive: {},
    parentNode: {},
    nodeOpen: {
        "& > $parentNodeUl": {
            overflow: "visible",
            maxHeight: 1500,
        },
    },
    nodeCustomName: {
        position: "relative",
        display: "block",
        paddingRight: 30,
        marginLeft: 15,
        paddingLeft: 17,
        "&:after": {
            content: "''",
            position: "absolute",
            top: "50%",
            left: 0,
            transform: "translateY(-50%)",
            width: 5,
            height: 5,
            borderRadius: "50%",
            backgroundColor: "#317787"
        },
    },
    categoryPrefix: {
        height: 12,
        lineHeight: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    nodeCustomArrow: {
        position: "absolute",
        top: "50%",
        right: 15,
        transform: "translateY(-50%)"
    },
    nodeLink: {
        padding: "5px 10px",
        color: "#317787",
        display: "block",
        position: "relative",
        "&$nodeLinkActive": {
            backgroundColor: "#e8f6f9",
            "&:after": {
                content: "''",
                top: 0,
                right: "100%",
                backgroundColor: "#e8f6f9",
                width: "100%",
                height: "100%",
                position: "absolute"
            }
        },
        "&$nodeLinkChilds": {
            "& $nodeCustomName": {
                "&:after": {
                    content: "''",
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    transform: "translateY(-50%)",
                    width: 6,
                    height: 2,
                    backgroundColor: "#317787"
                }
            }
        },
    },
    registerFormFields: {
        height: "calc(100% - 103px)",
        overflow: "auto",

    },
    businessNameBorder: {},
    businessGreenNameBorder: {},
    businessName: {
        color: "#317787",
        fontSize: 14,
        borderBottom: "4px solid #8AC8D5",
        "&$businessNameBorder": {
            borderBottom: "4px solid #fdd9b2",
        },
        "&$businessGreenNameBorder": {
            borderBottom: "4px solid #b4ecd9",
        }
    },
    topProductSupplyContentSupply: {},
    topProductSupplyContent: {
        height: "calc(100% - 70px)",
        overflow: "hidden",
        overflowY: "auto",
        paddingRight: 5,
        "&$topProductSupplyContentSupply": {
            height: "calc(100% - 40px)",
        },
        "& $textFieldLableColorCustom": {
            padding: 0
        },
        "& > .ant-row": {
            marginTop: 15,
            "&:first-child": {
                marginTop: 0
            }
        }
    },
    clientList: {
        "& $tableRoot": {
            marginTop: 20,
            height: "calc(100% - 80px)"
        },
        "& $fonSize13": {
            fontSize: 12
        },
        "& $fonSize14": {
            fontSize: 13
        },
        "& $comInput": {
            "& input": {
                padding: "3px 0"
            }
        }
    },
    importListFields: {
        height: 415,
        overflow: "auto",
        "& .MuiFormControlLabel-label": {
            fontSize: 14
        },
        "& .MuiSvgIcon-root": {
            fontSize: "1.2rem"
        },
        "& .MuiCheckbox-root": {
        },
        "&>*": {
            fontSize: 0,
            "&>*": {
                display: "inline-block",
                verticalAlign: "middle"
            },
        }
    },
    notificationDelete: {
        position: "absolute",
        top: "50%",
        right: 0,
        transform: "translateY(-50%)",
        opacity: 0,
        visibility: "hidden"
    },
    product_bg_blue: {
        backgroundColor: "#bbe1e9"
    },
    product_bg_yellow: {
        backgroundColor: "#fdd9b2"
    },
    product_bg_green: {
        backgroundColor: "#e4f8f1"
    },
    containerDivFront: {
        position: "relative",
        zIndex: 99999
    },
    clientType: {
        position: "relative",
        "& > *": {
            display: "inline-block",
            backgroundColor: "#fff",
            padding: "0 10px 0 20px",
            position: "relative"
        },
        "&:before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: 1,
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "#14a4c2"
        },
        "& .MuiFormControlLabel-label": {
            fontSize: 11
        },
        "& .MuiFormControlLabel-root": {
            marginRight: 20,
            "&:nth-child(2)": {
                marginRight: 0,
            }
        },
        "& .MuiButtonBase-root": {
            padding: "0 5px 0 0",
            "& $selectedIcon": {
                width: 12,
                height: 12,
                "&$unSelectedIcon": {
                    backgroundColor: "#14a4c2",
                    "&:before": {
                        backgroundImage: "none"
                    }
                }
            }
        }
    },
    templateView: {
        display: "flex",
        alignItems: "center",
        "& span": {
            margin: "0 5px"
        },
        "&>*": {
            display: "inline-block",
            verticalAlign: "middle"
        },
        "& $textFieldColor": {
            width: 75,
            height: 25,
            padding: "0px 10px 0px 0px",
            "&.Mui-disabled": {
                width: 95,
                color: "#000 !important",
                WebkitTextFillColor: "#000 !important",
            }
        },
        "&  .MuiInput-root::before": {
            content: "none !important"
        },
        "&  .MuiInput-root::after": {
            content: "none !important"
        }
    },
    topTenChart: {
        "& $overFolwBigContent": {
            "& > .ant-row": {
                margin: "0 -5px !important",
                "& > .ant-col": {
                    padding: "0 5px !important"
                }
            }
        }
    },
    paymentDetails: {
        height: "100%",
        paddingRight: 10,
        overflow: "auto",
        overflowX: "hidden"
    },
    paymentAntImage: {
        fontSize: 16,
    },
    tabInsideTable: {
        "& $tableRoot": {
            "& .MuiTableContainer-root": {
                height: "calc(100% - 110px)",
            }
        },
        "& $tablecontain": {
            "&.MuiTableContainer-root": {
                height: "calc(100% - 110px)",
            }
        }
    },
    clientTypeTitle: {
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#e8f6f9",
        padding: "7px 4px",
        color: "#1c314c",
        lineHeight: 1
    },
    clientTypeContent: {
        height: "calc(100% - 200px)",
        overflow: "auto",
        paddingRight: 5
    },
    clientTypeRow: {
        marginTop: 5,
        overflow: "hidden",
        "& > div": {
            borderTop: "1px solid #14a4c2",
            "&:first-child": {
                borderTop: "none"
            },
        },
        "& span": {
            padding: "4px 6px",
            display: "inline-block"
        }
    },
    productNameView: {
        "& span": {
            marginLeft: 5,
            paddingLeft: 10,
            position: "relative",
            "&:after": {
                content: "''",
                position: "absolute",
                top: '50%',
                left: 0,
                transform: "translateY(-50%)",
                width: 2,
                height: "90%",
                backgroundColor: "#ffa539"
            }
        }
    },
    scrollParentSettleMent: {
        borderRight: "1px solid #14A4C2"
    },
    categoryDropDownScroll: {
        height: "calc(100% - 150px)",
        overflow: "auto",
        paddingRight: 15
    },
    customToolTipPadding: {
        paddingLeft: '3px !important'
    },
    paymentTooltip: {},
    paymentReasonTooltip: {},
    nextTooltip: {},
    customToolTip: {
        "& > *": {
            display: "inline-block",
            verticalAlign: "middle"
        },
        "& .MuiTooltip-tooltip": {
            border: "solid 0.5px #16c88b",
            backgroundColor: "#fff",
            color: "#000",
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            fontSize: 13,
            fontWeight: 400,
            width: 300
        },
        "& .MuiTooltip-arrow": {
            //transform: "translate(145px, -2px) rotate(-48deg) !important",
            // borderTop: "none",
            // borderRight: "none",
            // border: "solid 0.5px #16c88b",
            // backgroundColor: "#fff",
            color: "transparent",
            width: "0.85em",
            bottom: "-3px !important",
            height: "0.85em", overflow: "visible",
            "&:before": {
                borderTop: "none",
                borderLeft: "none",
                border: "solid 0.5px #16c88b",
                backgroundColor: "#fff",
            }
        },
        "&$paymentTooltip": {
            marginLeft: "20px !important",
            "& .MuiTooltip-arrow": {
                transform: "translate(58px, -2px) rotate(-48deg) !important",
            }
        },
        "&$paymentReasonTooltip": {
            marginLeft: "20px !important",
            "& .MuiTooltip-arrow": {
                transform: "translate(125px, -2px) rotate(-48deg) !important",
            }
        },
        "&$nextTooltip": {
            marginLeft: "-20px !important",
            "& .MuiTooltip-arrow": {
                transform: "translate(275px, -2px) rotate(-48deg) !important",
            }
        },
    },
    customToolTipWidth: {
        "& .MuiTooltip-tooltip": {
            width: 150
        },
    },
    customToolTipWidthSales: {
        "& .MuiTooltip-tooltip": {
            width: 200
        },
    },

    gridRow: {
        margin: "-38px -15px 0 -15px",
        display: "flex",
        flexWrap: "wrap",
        paddingRight: 12,
    },
    gridColoum: {
        display: "inline-block",
        padding: "0 15px",
        marginTop: 30,
        textAlign: "center",
        width: "25%"
    },
    gridColoumSelected: {
        "& $gridColoumInnerClick": {
            backgroundColor: "#a1e8d0"
        }
    },
    gridColoumInner: {
        position: "relative"
    },
    gridColoumProductName: {

    },
    gridColoumInnerHover: {
        "&:before": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(0 0 0 / 40%)",
            opacity: 0,
            zIndex: 9,
            visibility: "hidden",
            transition: "opacity .4s, visibility .4s"
        },
        "&:after": {
            content: "attr(data-productname)",
            position: "absolute",
            top: '50%',
            left: 0,
            transform: "translateY(-50%)",
            color: "#fff",
            zIndex: 99,
            width: "100%",
            fontSize: 12,
            fontWeight: 500,
            overflow: "hidden",
            lineHeight: 1.2,
            WebkitLineClamp: 5,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
            opacity: 0,
            visibility: "hidden",
            padding: "0 3px",
            transition: "opacity .5s, visibility .5s"
        },
        "&:hover": {
            "&:before": {
                opacity: 1,
                visibility: "visible",
            },
            "&:after": {
                opacity: 1,
                visibility: "visible",
            }
        }
    },
    gridColoumInnerPadd: {
        display: "block",
        paddingTop: "100%"
    },
    gridColoumInnerClick: {
        width: "100%",
        display: "block",
        borderRadius: "8px 8px 0 0",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.25)",
        backgroundColor: "#e8f6f9",
        position: "relative",
        cursor: "pointer",
        "&$gridColoumSelected": {
            backgroundColor: "#a1e8d0"
        },
        "&$gridColoumError": {
            backgroundColor: "#eeb3b3"
        },
    },
    gridRowTop: {
        overflow: "hidden", overflowY: "auto",
        paddingRight: 5,
        marginTop: 30,
    },
    gridColoumInnerBox: {
        borderRadius: 8,
        backgroundColor: "#fff",
        padding: "3px 3px 5px",
        position: "absolute",
        top: "50%",
        width: "calc(100% - 15px)",
        height: "calc(100% - 15px)",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& > div": {
            fontSize: 12,
            color: "#317787",
            fontWeight: 500,
            overflow: "hidden",
            lineHeight: "1.2",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box"
        }
    },
    gridColoumCheckBox: {
        width: 13,
        height: 13,
        position: "absolute",
        top: 0,
        left: 0,
        lineHeight: 1
    },
    storeSalesLineCell: {
        "& >*": {
            display: "inline-block",
            verticalAlign: "middle"
        },
        "& .ant-image": {
            margin: "0 3px",
            cursor: "pointer"
        }
    },
    storeSalesLinePrice: {},
    storeSalesLineQuantity: {
        width: "calc(100% - 32px)",
        maxWidth: 60,
        "& .MuiInputBase-input": {
            padding: "3px 5px",
            textAlign: "center",
            "&::before": {
                content: "none"
            }
        },
        "& .MuiInputBase-root": {
            backgroundColor: "#e8f6f9"
        },
        "& fieldset": {
            border: "none"
        },
        "&$storeSalesLinePrice": {
            width: "100%",
            maxWidth: 150,
            "& .MuiInputBase-input": {
                textAlign: "right"
            }
        }
    },
    batchTextField: {
        width: "100%",
        "& .MuiInputBase-input": {
            padding: "3px 5px",
            "&::before": {
                content: "none"
            }
        },
        "& .MuiInputBase-root": {
            backgroundColor: "#e8f6f9"
        },
        "& fieldset": {
            border: "none"
        },
        "&$storeSalesLinePrice": {
            width: "100%",
            maxWidth: 150,
            "& .MuiInputBase-input": {
                textAlign: "right"
            }
        }
    },
    storeSalesLineProduct: {

    },
    adjustStockLineUnit: {
        '&$storeSalesLineProduct': {
            "& $customAutoComplete": {
                width: 'auto',
                border: "1px solid #FF0000"
            }
        },
        "& $customAutoComplete": {
            width: "100%",
            margin: "auto",
            borderRadius: 7,
            backgroundColor: "#e8f6f9",
            "& input": {
                zIndex: 99
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none !important",
                boxShadow: "none"
            },
            "& .MuiInputBase-root": {
                padding: 0
            }
        }
    },
    storeSalesLineUnit: {
        '&$storeSalesLineProduct': {
            "& $customAutoComplete": {
                width: 'auto',
                border: "1px solid #FF0000"
            }
        },
        "& $customAutoComplete": {
            width: 100,
            margin: "auto",
            borderRadius: 7,
            backgroundColor: "#e8f6f9",
            "& input": {
                textAlign: "center", zIndex: 99
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none !important",
                boxShadow: "none"
            },
            "& .MuiInputBase-root": {
                padding: 0
            }
        }
    },
    fillterDropdown: {
        position: "relative",
        "& $dropDownPointer": {
            padding: "2px 6px",
            border: "solid 1px #14a4c2",
            boxShadow: "0 1px 5px 0 #8ac8d5",
            borderRadius: 4,
            "& $selectedIcon": {
                width: 13,
                height: 13,
                "&$unSelectedIcon": {
                    "&:before": {
                        width: 13,
                        height: 13,
                    }
                }
            }
        },
        "& $customAutoComplete": {
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 9,
            width: '100%'
        }
    },
    fillterDropdownPrimary: {
        position: "relative",
        "& $dropDownPointer": {
            padding: "2px 6px",
            border: "solid 1px #14a4c2",
            boxShadow: "0 1px 5px 0 #8ac8d5",
            borderRadius: 4,
            "& $selectedIcon": {
                width: 13,
                height: 13,
                "&$unSelectedIcon": {
                    "&:before": {
                        width: 13,
                        height: 13,
                    }
                }
            }
        },
        "& $customAutoComplete": {
            position: "relative",
            top: "129%",
            left: 0,
            zIndex: 9,
            width: '100%'
        }
    },
    marginTop2: {
        " & .MuiInputLabel-outlined": {
            marginTop: '2px !important'
        }
    },
    netIncomeWrapOuter: {
        padding: 20,
        position: "relative",
        flex: 1,
    },
    netIncomeWrap: {
        position: "relative",
        flex: 1,
        height: "100%"
    },
    colorBlocks: {
        position: 'absolute',
        left: '0',
        top: '15px',
        width: '100%',
        bottom: '0',
        display: 'flex',
        flexWrap: 'wrap',
        "&::before": {
            content: "''",
            backgroundColor: "#fff",
            position: "absolute",
            top: 0,
            left: 0,
            width: '100%',
            height: '50%'
        }
    },

    bgColorBlock: {
        position: 'absolute',
        left: '50%',
        bottom: 0,
        width: '36%',
        transform: 'translate(-50%) scale(0)',
        backgroundColor: '#ffc27a',
        borderRadius: "50%",
        zIndex: '-1',
        boxShadow: ' 0 3px 6px 0 rgba(0, 0, 0, 0.16), inset 0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        opacity: 0,
        transition: "opacity .4s .9s, transform .4s 1s",
        '&::before': {
            content: "''",
            display: 'block',
            paddingTop: '100%'
        }
    },
    cBlock: {
        width: '50%',
        height: '65%',
        position: "relative",
        display: "flex",
        alignItems: "center",
        '&::before': {
            top: "0",
            left: "0",
            width: "100%",
            bottom: "-12px",
            content: "''",
            position: " absolute",
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            backgroundColor: "#fff",
            borderRadius: "0 60px 0 60px",
        },
        '&::after': {
            top: "0",
            left: "0",
            width: "100%",
            bottom: "0",
            content: "''",
            position: " absolute",
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            backgroundColor: "#afe3d0",
            borderRadius: "0 60px 0 60px",
        }
    },
    cBlock1: {
        backgroundColor: '#afe3d0',
        borderRadius: '0 60px 0 60px',
        transform: "rotate(45deg)",
        opacity: 0,
        transition: "opacity .4s .7s, transform .4s .8s",
        '& $textWrap': {
            transform: 'translate(25%, 0)',
        }
    },
    cBlock2: {
        borderRadius: '60px 0 60px 0',
        transform: "rotate(-45deg)",
        opacity: 0,
        transition: "opacity .4s .7s, transform .4s .8s",
        '&::before': {
            left: "auto",
            right: "0",
            borderRadius: "60px 0 60px 0",
        },
        '&::after': {
            backgroundColor: '#c1c8e3',
            borderRadius: "60px 0 60px 0",
        },
        '& $textWrap': {
            textAlign: 'right',
            transform: 'translate(-25%, 0)',
        }
    },
    colorCircle: {
        left: '50%',
        width: '30%',
        position: 'absolute',
        borderRadius: '50%',
        backgroundColor: '#fff',
        bottom: 15,
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16), inset 0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        transform: 'translateX(-50%) scale(0)',
        opacity: 0,
        transition: "opacity .4s .5s, transform .4s .6s",
        '&::before': {
            content: "''",
            display: 'block',
            paddingTop: '100%'
        },
        '& img': {
            position: 'absolute',
            left: '50%',
            top: '50%',
            width: '80%',
            height: '80%',
            transform: 'translate(-50%, -50%)'
        }
    },
    productNoneOpen: {
        display: 'block'
    },
    textInfo: {
        fontSize: '16px',
        color: '#1c314c',
        width: '100%',
    },
    textPrice: {
        fontSize: 28,
        color: '#1c314c',
        fontWeight: '500',
        width: '100%',
    },
    textWrap: {
        display: 'flex',
        padding: 20,
        alignItems: 'center',
        position: 'relative',
        width: '100%',
        flexWrap: 'wrap',
        opacity: 0,
        transition: "opacity .4s 1s, transform .4s 1.1s",
        zIndex: 2
    },
    divToPrintReport: {
        "& $downloaddetails": {
            minHeight: 1400
        },
    },
    paymentReceipt: {
        "& $downloaddetails": {
            border: "1px solid #ffc27a",
            height: 1100
        },
        "& $bill": {
            "& h6": {
                margin: 0
            }
        }
    },
    receiptHeader: {
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "#f5f5f5",
        padding: 20,
        alignItems: "center"
    },
    receiptHeaderCenter: {
        fontSize: 27,
        color: "#1c314c"
    },
    receiptHeaderRight: {
        color: "#1c314c",
        fontWeight: 500,
        fontSize: 18,
        "& span": {
            color: "#8a8a8e",
            fontSize: 14,
        }
    },
    receiptSecondSection: {
        padding: 20,
        backgroundColor: "#f5f5f5",
    },
    receiptSecondSectionTitle: {
        color: "#14a4c2 !important"
    },
    receiptThirdSection: {
        backgroundColor: "#fff",
    },
    receiptThirdSectionRow: {
        padding: "10px 20px",
        alignItems: "center"
    },
    yellowBorderLeft: {
        borderLeft: "1px solid #ffc27a"
    },
    receiptLastSectionRow: {
        padding: "10px 15px 5px 15px"
    },
    mobilePortrait: {
        display: "none",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#000",
        zIndex: 999
    },
    mobilePortraitContent: {
        position: "absolute",
        color: "#fff",
        fontSize: 25,
        top: "50%",
        left: "50%",
        width: "100%",
        transform: "translate(-50%, -50%)",
        padding: 20,
        textAlign: "center",
        "& h3": {
            color: "#fff",
        }
    },
    mobilePortraitPhone: {
        height: 100,
        width: 50,
        border: "3px solid #fff",
        borderRadius: 10,
        margin: "auto",
        animation: "rotate 1.5s ease-in-out infinite alternate",
    },
    mobileDisplay: {
    },
    mobileDisplayRegister: {
        display: "inline-block"
    },
    mobileBurgerIcon: {
        display: "none",
        padding: 15,
        "& .ant-image-img": {
            width: "20px !important"
        }
    },
    mobileMenuVisible: {},
    mobileMenuContainer: {
        position: "fixed",
        right: 0,
        top: 0,
        height: "100%",
        overflow: "auto",
        width: "300px",
        transform: "translateX(100%)",
        backgroundColor: "#fff",
        boxShadow: "0 3px 6px 0 rgb(0 0 0 / 16%)",
        zIndex: 9999,
        transition: 'transform .4s',
        "&$mobileMenuVisible": {
            transform: "translateX(0)",
        },
        "& $CloseIcon": {
            right: 15,
            top: 15,
            bottom: "auto"
        }
    },
    downIconCustom: {},
    mobileMenuGroup: {
        position: "relative",
    },
    mobileMenuSub: {
        paddingLeft: 10
    },
    mobileMenu: {
        padding: "60px 0 0 0",
        "& li": {
            position: "relative",
            "& a": {
                display: "block",
                fontSize: 14,
                padding: "10px 25px",
                "&$menuActive": {
                    backgroundColor: '#ffc27a',
                    color: "#fff",
                    "&:before": {
                        content: "none"
                    },
                    "& + $downIconCustom": {
                        "& svg path": {
                            stroke: "#fff",
                        }
                    }
                },
            },
            "& $downIconCustom": {
                position: "absolute",
                top: "50%",
                right: 0,
                padding: "10px 25px",
                transform: "translateY(-50%)",
                "& svg": {
                    top: "auto !important",
                    position: "static !important",
                    right: "auto !important",
                    transform: "none !important"
                }
            }
        }
    },
    verifyTitle: {
        color: "#8a8a8e",
        display: "flex",
        justifyContent: "space-between",
        marginTop: 10,
        "& span": {
            color: "#000"
        }
    },
    splitBar: {
        height: 22,
        width: 2,
        backgroundColor: "#ffa539"
    },
    exist: {},
    verifyFirstCol: {
        width: '100%',
        position: "relative",
        "& $new": {
            top: 5,
            "&$exist": {
                backgroundColor: "#16c88b"
            }
        }
    },
    disPlaySpaceEven: {
        display: "flex",
        justifyContent: "space-between"
    },
    scrollParentVerify: {
        height: 'calc(100% - 86px)',
        "& $tablecontain": {
            "&.MuiTableContainer-root": {
                height: "calc(100% - 25px)",
            }
        },
        "& .ant-col": {
            height: "100%"
        },
        "& .MuiTableHead-root": {
            height: 37,
        }
    },

    overlFlowResponsiveDesign: {
        whiteSpace: 'nowrap',
    },
    textFieldLableAutoMark: {
        marginTop: 3
    },
    PlaceofSupply: {
        color: '#8a8a8e',
        fontSize: '16px',
        "&$customForm9": {
            color: "#14a4c2"
        }
    },
    PlaceofSupplyText: {
        color: '#000000',
        marginLeft: '20px'
    },
    customFilter: {
        display: 'none !important'
    },
    ProductFilter: {
        '& .ant-space-item': {
            display: 'flex'
        },
        ProductMobileFilter: {
            display: 'none',
        }
    },
    vertiCalScrollOverFlow: {
        "& .ant-image-img": {
            width: "auto",
            height: "auto"
        },
        "& $customLink": {
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
        }
    },
    vertiCalScrollOverFlowParent: {
        display: "flex",
        justifyContent: "end",
    },

    hamburgerMenuSales: {},
    topProductSupplySales: {
        "& $monthlyDivTitle": {
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 10,
            borderBottom: "solid 0.5px #14a4c2",
            marginBottom: 10,
            alignItems: "center",
            "& span:first-child": {
                whiteSpace: "nowrap",
                paddingRight: 5
            }
        },
        "& $hamburgerMenuSales": {
            position: "relative",
            top: "auto",
            bottom: "100%",
            transform: "none",
        },
        '& .apexcharts-title-text': {
            "&:after": {
                content: "'Percentage'",
            }
        },
        "& .apexcharts-legend": {
            width: "56%",
            paddingRight: "10px !important",
            "&::-webkit-scrollbar": {
                width: "4px",
                height: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#8AC8D5",
                borderRadius: "10px",
            },
            "& .apexcharts-legend-series": {
                position: "relative",
                backgroundColor: "#f5f5f5",
                padding: "5px 0",
                color: "#1c314c",
                borderRadius: "12px 0 0 12px",
                "&:last-child": {
                    display: "none"
                },
                "& .apexcharts-legend-marker": {
                    position: "absolute",
                    top: "50% !important",
                    left: "0 !important",
                    transform: "translateY(-50%)",
                    height: "25px !important",
                    width: "25px !important"
                },
                "& .apexcharts-legend-text": {
                    padding: "0 37px 0 30px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    margin: 0,
                    width: "100%",
                    display: "block",
                    "& .custom-marker": {
                        position: "absolute",
                        top: "50%",
                        right: 5,
                        fontWeight: 500,
                        transform: "translateY(-50%)"
                    }
                }
            }
        },
        "& foreignObject": {
            height: "100%"
        }
    },
    customSalesCount: {
        position: "absolute",
        bottom: 0,
        right: 0,
        borderTop: '0.5px solid #14a4c2',
        borderBottom: '0.5px solid #14a4c2',
        display: "flex",
        padding: "5px 0",
        width: '40%'
    },
    customSalesTotalText: {
        color: "#8a8a8e",
        fontSize: "12px",
        paddingBottom: '2px',
        margin: 0,
        textOverflow: "ellipsis"
    },
    payDeleteIcon: {
        position: "absolute",
        right: 0,
        top: 0,
    },
    customSalesTotalFontBig: {},
    customSalesTotalFont: {
        color: "#1c314c",
        fontWeight: "500",
        fontSize: "12px",
        margin: 0,
        '&$customSalesTotalFontBig': {
            fontSize: "14px",
            paddingTop: '4px',
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
    },
    customFilterSalesTopBar: {

    },
    boxBorderInnerProduct: {
        height: "calc(100% - 35px)",
        position: "relative",
    },
    customSalesTotalRight: {
        paddingLeft: 5,
        marginLeft: 5,
        borderLeft: "solid 0.5px #ffa539",
        width: '50%',
        '& $customSalesTotalText': {
            display: 'flex',
            justifyContent: 'space-between'
        }
    },
    customSalesTotalLeft: {
        width: '50%'
    },
    customSalesTotalRightTop: {
        borderTop: "solid 0.5px #14a4c2",
        paddingTop: '4px',
    },
    monthlyDivTitleFilter: {
        borderLeft: '2px solid #FCB364',
        paddingLeft: '10px',
    },
    dateFilterdateAdjustMobile: {
        position: "absolute",
        top: "100%",
        left: 0,
        zIndex: 999,
        '& .MuiOutlinedInput-root ': {
            borderRadius: '6px',
            border: '1px solid #8AC8D5 ',
            padding: 0,
            '& .MuiOutlinedInput-notchedOutline': {
                border: '0',
                padding: 0
            },
            '& .MuiInputBase-input': {
                padding: '4px 0 4px 6px',
                fontSize: '13px'
            },
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
            color: '#8a8a8e',
            transform: "translate(0, 20px) scale(1)",
            '&.MuiFormLabel-filled': {
                transform: "translate(0, -1.5px) scale(0.85)"
            },
            '&.Mui-focused': {
                transform: "translate(0, -1.5px) scale(0.85)",
                color: '#FCB364 !important',
            },
        },
        '& .MuiInputAdornment-root ': {
            '& .MuiButtonBase-root': {
                padding: '0 5px 0 10px',
                margin: 0,
                '& .cls-1': {
                    fill: '#fff',
                    stroke: '#14a4c2',
                },
                '& .cls-2, .cls-4 ': {
                    fill: 'none',
                },
                '& .cls-2': {
                    stroke: '#ffa539',
                    strokeLinecap: 'round',
                },
                '& .cls-3': {
                    stroke: ' none'
                },
            },
        },
    },
    SalesPriceProduct: {
        '& .MuiInputLabel-root.MuiInputLabel-shrink': {
            display: 'none !important',
        },
    },
    margin30Top: {
        marginTop: '30px !important'
    },
    margin30TopTrans: {
        marginTop: '30px !important'
    },
    salesBillMarginTop40: {
        marginTop: '40px !important'
    },
    salesBillMarginTop50: {
        marginTop: '50px !important'
    },
    margin74t: {
        marginTop: "74px  !important",

    },
    productImageUploadView: {},
    BusinessRelative: {
        position: 'relative !important',
        "& $productImageUpload": {
            height: 175,
            marginTop: 20
        },
        "& $productImageUploadView": {
            width: 175,
            height: 175,
            "& $imageContainer": {
                width: "calc(100% - 10px)"
            }
        },
        "& $productImageUploadInner": {

        },
        "& $imageContainer": {
            width: 175,
            left: 5,
            height: "calc(100% - 10px)"
        },
        "& $imageContainerText": {
            left: 190,
            bottom: "50%",
            transform: "translateY(50%)",
            width: "auto"
        }
    },
    BusinessAbsolute: {
        position: 'absolute !important',
        top: 0,
        right: 0,
        // right: '25px'
    },
    margin00t: {},

    marginTop10: {
        marginTop: '-10px'
    },

    marginTopDash10: {
    },
    margin000t: {

    },
    margin32t: {
        marginTop: '32px'
    },
    monthlyDivTitleSpan: {},
    totalChartDivCustomers: {
        "& $monthlyDivTitle": {
            "& $monthlyDivTitleSpan": {
                borderRight: "2px solid #ffa539",
                paddingRight: 4,
                marginRight: 4,
            }
        }
    },
    lastDaysTopSupply: {
        display: "block"
    },
    customesRow: {
        paddingTop: 40,
        position: "relative",
    },
    customesRowTitle: {
        paddingRight: 110,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    customesRowContent: {
        position: "relative",
        marginTop: 5,
        backgroundColor: "#e8f6f9",
        fontSize: 14,
        borderRadius: "5px 0 0 0",
        "& > *": {
            display: "inline-block",
            verticalAlign: "middle"
        },
        "&:after": {
            content: "''",
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: 3,
            backgroundColor: "#f7959d"
        },
        "&.customesRowContent_2": {
            "& $customesRowContentCount": {
                backgroundColor: "#8ac8d5",
            },
            "&:after": {
                backgroundColor: "#8ac8d5"
            }
        },
        "&.customesRowContent_3": {
            "& $customesRowContentCount": {
                backgroundColor: "#f7d3bb",
            },
            "&:after": {
                backgroundColor: "#f7d3bb"
            }
        },
        "&.customesRowContent_4": {
            "& $customesRowContentCount": {
                backgroundColor: "#dbe8c5",
            },
            "&:after": {
                backgroundColor: "#dbe8c5"
            }
        },
        "&.customesRowContent_5": {
            "& $customesRowContentCount": {
                backgroundColor: "#afe3d0",
            },
            "&:after": {
                backgroundColor: "#afe3d0"
            }
        },
        "&.customesRowContent_6": {
            "& $customesRowContentCount": {
                backgroundColor: "#c1c8e3",
            },
            "&:after": {
                backgroundColor: "#c1c8e3"
            }
        }
    },
    customPre: {
        whiteSpace: "pre-line",
        padding: "0 15px"
    },
    customesRowContentCount: {
        padding: "5px 10px 5px 10px",
        borderRadius: "5px 5px 0 0",
        backgroundColor: "#f7959d",
        display: "inline-block",
        lineHeight: 1,
    },
    customesRowContentAmount: {
        marginLeft: 10
    },
    customesRowContentPercentage: {
        position: "absolute",
        top: "50%",
        right: "25px",
        transform: "translateY(-50%)"
    },
    totalSales: {
        position: "absolute",
        top: "50%",
        right: 30,
        color: "#1c314c",
        transform: "translateY(-50%)",
        fontSize: 12,
        borderLeft: "2px solid #ffa539",
        paddingLeft: 4,
        marginLeft: 4,
        "& span": {
            fontSize: 15,
            fontWeight: 500,
            marginLeft: 5
        }
    },
    gaugeChartDiv: {
        position: "absolute",
        top: "-5px",
        right: "-25px",
        width: "160px",
        height: "100%"
    },
    marginTop10AppTransactions: {
        marginTop: -'10px',
    },
    marginTop10ProductView: {
        marginTop: -'10px',
    },
    overFlowScroll: {
        overflow: 'scroll',
    },
    customerRowMain: {
        overflow: "hidden",
        overflowY: 'auto',
        height: 'calc(100% - 24px)',
        marginTop: 5
    },
    businessProfile: {
        display: 'none'
    },
    customerRowCol: {},
    GlobalAddressBook: {
        marginTop: "20px",
        marginLeft: '10px',
        display: "flex",
        justifyContent: "end",

    },
    actualPlanAmount: {
        marginTop: "20px",
    },
    planAmount: {
        marginTop: "20px",
    },
    planDescription: {
        marginTop: "20px  !important",
    },
    globalMobileView: {
        marginTop: '30px'
    },
    monthlyDivTitleCustomer: {
        position: "relative",
        paddingRight: 160
    },
    salesQuoteText: {
        height: "70px !important"
    },
    purchaseQuoteText: {
        height: "132px !important"
    },
    prfont14: {
        fontSize: "14px",
        color: "#000"
    },
    prfont8: {
        fontSize: 9,
        color: "#000"
    },
    prfont11: {
        fontSize: 11,
        color: "#000"
    },
    mrbt8: {
        marginBottom: "8px",
    },
    mrbt3: {
        marginBottom: "3px",
    },
    Pt3: {
        paddingTop: "3px",
    },
    Pt11: {
        paddingTop: "11px",
    },
    Pt8: {
        paddingTop: "8px",
    },
    Pr13: {
        paddingRight: "5px",
    },
    Pb10: {
        paddingBottom: "10px",
    },
    thprintdetails: {
        // maxWidth: "384px !important",
        // margin: "0 !important",
        // padding: "0 !important",
        // transform: "none !important",
        // background: "#ffffff !important",
        padding: 5,
        maxWidth: "300px",
        margin: "auto",
        "& $productImageUpload": {
            boxShadow: "none",
            borderRadius: 0,
            backgroundColor: "transparent",
            "& $productImageUploadInner": {
                padding: 0,
                "& $imageContainer": {
                    width: "100%"
                }
            }
        }
    },
    recepitbill: {
        "& $prfont14": {
            fontSize: '17px',
        },
        "& $prfont8": {
            fontSize: '11px',
        },
        "& $prfont11": {
            fontSize: '14px',
        },
    },
    customError: {
        color: "#d32f2f",
        fontSize: "0.75rem"
    },
    dashedborderTop: {
        borderTop: "1px dashed #000",
    },
    dashedborderbottom: {
        borderBottom: "0.5px dashed #000",
    },
    mxwidth150: {
        maxWidth: "155px",
        margin: "auto",
    },
    justify_space_around: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "nowrap",
        flexDirection: "row",
        gap: 10,
    },
    paddingZeroLine: {
        padding: '0px !important'
    },
    listprod: {
        width: "100%",
        fontSize: 13,
        display: "block",
        // fontWeight: "500",
        lineHeight: "1.7",
        color: "#8a8a8e",
        padding: "13px 7px",
        boxShadow: "3px 3px 6px 0 rgba(0, 0, 0, 0.16)",
        textAlign: "center",
        borderRadius: "30px 0 0",
        marginTop: "10px",
        border: "1px solid #9dd6c2",
        transition: "background-color .5s, color .5s",
        cursor: 'pointer',
        '&:first-child': {
            marginTop: 0,
        },
        '&:hover': {
            color: "#000",
            backgroundColor: "#d4f3e8",
        },
    },
    listprodactive: {
        backgroundColor: "#d4f3e8",
        color: "#000",
    },
    keyboard: {
        margin: '0 -10px',
        "& .ant-col": {
            padding: '0 10px',
        },
    },
    keyboardbox: {
        padding: '15px',
        border: 'solid 1px #14a4c2',
        borderRadius: '15px',
        "& .ant-row": {
            margin: '0 -16px',
        },
        "& .ant-col-12": {
            padding: '0 16px',
        },
        "& .ant-col-24": {
            padding: '10px 16px 0',
        },
    },
    keyboardboxlabel: {
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontWeight: 'normal',
        lineHeight: '1.15',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#979797',
    },
    inputField: {
        margin: '8px 0 0',
        borderRadius: '7px',
        border: 'solid 1px #14a4c2',
    },
    keywordOuter: {
        padding: '5px 7px',
        borderRadius: '8px',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.25)',
        width: '100%',
        backgroundColor: '#e8f6f9',
        cursor: "pointer"
    },
    keywordInner: {
        padding: '8px',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        color: '#317787',
        fontSize: '15px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    roundOffDiv: {
        position: "absolute",
        top: 5,
        right: 0,
    },
    noPageBreak: {
        pageBreakInside: "avoid",
        breakInside: "avoid"
    },
    arrowLeft: {
        display: 'block',
        borderColor: 'transparent',
        borderStyle: 'solid',
        width: '10px',
        height: '15px',
        position: 'relative',
        lineHeight: '0',
        borderWidth: '7px 10px 7px 0 ',
        borderTopColor: 'transparent',
        borderRightColor: '#317787',
    },
    arrowRight: {
        display: 'block',
        borderColor: 'transparent',
        borderStyle: 'solid',
        width: '10px',
        height: '15px',
        position: 'relative',
        lineHeight: '0',
        borderWidth: '7px 0 7px 10px',
        borderTopColor: 'transparent',
        borderLeftColor: '#317787',
    },
    width5: {
        width: '5%',
    },
    width10: {
        width: '10%',
    },
    width15: {
        width: '15%',
    },
    width12: {
        width: '12%',
    },
    width20: {
        width: '20%',
    },
    width18: {
        width: '18%',
    },
    width40: {
        width: '40%',
    },
    width50: {
        width: '50%',
    },
    width70: {
        width: '70%',
    },
    keyletters: {
        "& $width5": {
            padding: '0 2px',
            marginTop: '10px',
            display: 'flex',
        },
        "& $width10": {
            padding: '0 2px',
            marginTop: '10px',
            display: 'flex',
        },
        "& $width20": {
            padding: '0 2px',
            marginTop: '10px',
            display: 'flex',
        },
        "& $width25": {
            padding: '0 2px',
            marginTop: '10px',
            display: 'flex',
        },
        "& $width50": {
            padding: '0 2px',
            marginTop: '10px',
            display: 'flex',
        },
        "& $width40": {
            padding: '0 2px',
            marginTop: '10px',
            display: 'flex',
        },
        "& $width70": {
            padding: '0 2px',
            marginTop: '10px',
            display: 'flex',
        },
        "& $keywordInner": {
            fontSize: 30,
            lineHeight: '1',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            "& $span": {
                color: '#ffa539',
                paddingTop: '5px', fontSize: 10
            },
        },
    },
    keyfs15: {
        fontSize: '15px !important',
    },
    flexcol: {
        flexDirection: 'column',
    },
    keywordnum: {
        padding: '30px 10px',
    },
    storesalesclose: {
        position: 'absolute',
        width: '32px',
        height: '50px',
        top: '1px',
        right: '1px',
        background: '#fff',
        borderRadius: '0 10px 0 0',
    },
    top_right_ab: {
        position: 'absolute',
        top: '0',
        right: '0',
        zIndex: 99
    },
    resetLink: {
        position: "relative",
        marginLeft: 5,
        paddingLeft: 5,
        "&::before": {
            content: "''",
            position: "absolute",
            height: 17,
            width: 2,
            left: 0,
            backgroundColor: "#317787",
            top: "50%",
            transform: "translateY(-50%)"
        },
        "& span": {
            margin: "0 10px 0 0",
            whiteSpace: "nowrap",
            maxWidth: 160,
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    },
    storeInvoiceAmountPayment: {
        "& $storeInvoiceAmount": {
            borderRadius: "10px",
            padding: "8px 15px",
            fontSize: "23px",
            lineHeight: "1.3",
            "& h4": {
                fontSize: 12,
                fontWeight: "400",
            },
        },
        "& $textFieldLableColorCustom": {
            '&+.MuiInputBase-root': {
                marginTop: "0"
            },
        },
    },
    priceDesignExact: {
        "&$priceDesign": {
            width: "100%",
            marginTop: "13px",
            marginRight: "0",
        }
    },
    shortKey: {
        color: "#ffa539"
    },
    priceDesignPayment: {
        marginTop: "-18px",
        columnCount: 2,
        "& $priceDesign": {
            width: "100%",
            marginTop: 20,
            marginRight: 0,
        },
        "& .ant-col": {
            padding: "0 7px",
        },
        "& .ant-col-12": {
            "& $priceDesign": {
                '&:first-child': {
                    marginTop: 0,
                },
            },
        },
    },
    partyDetails: {
        margin: "0 -30px",
        "& .ant-col-12": {
            padding: "0 30px",
        },
    },
    rightStoreSalesSecondBar: {
        padding: "6px 20px",
        borderBottom: "1px solid #14a4c2",
        marginBottom: "18px",
        "& .ant-row": {
            margin: "0 -20px",
            alignItems: "center",
        },
        "& .ant-col": {
            borderRight: "1px solid #14a4c2",
            padding: "0 15px",
            "&:last-child": {
                borderRight: "none",
            }
        },
    },
    prod_grp_tit: {
        width: "50%",
        marginTop: "40px",
        "& $gridColoumInner": {
            padding: "3px 3px 0 3px",
            boxShadow: "0 1px 6px 0 rgba(0, 0, 0, 0.16)",
            borderRadius: "8px 8px 0 0"
        },
        "& $gridColoumInnerPadd": {
            paddingTop: 77,
        },
        "& $gridColoumInnerClick": {
            backgroundColor: "#e8f6f9",
            boxShadow: "none",
            "&$gridColoumSelected": {
                backgroundColor: "#e8f6f9"
            },
            "&$gridColoumError": {
                backgroundColor: "#e8f6f9"
            },
        },
        "& $gridColoumCheckBox": {
            width: 20,
            height: 20,
        },
        "& $gridColoumQuantity": {
            height: 22, overflow: "hidden",
            "& .MuiInputBase-root input": {
                padding: "3px 22px",
                fontSize: 14, fontWeight: 500
            }
        },
        "& $gridColoumInnerHover": {
            "&:hover": {
                "&:before": {
                    opacity: 0,
                    visibility: "hidden",
                },
                "&:after": {
                    opacity: 0,
                    visibility: "hidden",
                },
            },
        },
        "& $gridColoumInnerBox": {
            width: "100%",
            height: "100%",
            background: `#e8f6f9`,
            padding: "0",
            columnGap: "6px",
            "& > div": {
                WebkitLineClamp: 4
            }
        }
    },
    gridColoumYellow: {
        backgroundColor: "#ffc27a"
    },
    gridColoumGreen: {
        backgroundColor: "#95e6ca"
    },
    gridColoumRed: {
        backgroundColor: "#ff9292"
    },
    prod_group: {
        "& $gridRow": {
            margin: "-38px -13px 0 -13px",
        },
    },
    // PadLR15: {
    //     padding: "0 15px",
    // },
    grpproductName: {
        width: "50%",
        padding: "0 0 0 6px",
    },
    grpproductimage: {
        width: "50%",
        height: "100%",
    },
    grpproductimg: {
        width: "100%",
        height: "100%",
        borderRadius: "0 10px 0 0",
        objectFit: "contain",
    },
    storeSalesRow: {
        "& > div": {
            display: "inline-block",
            verticalAlign: "middle"
        }
    },
    freeProduct: {
        border: "solid 1px #16c88b",
        padding: 5,
        fontSize: 12,
        borderRadius: 6,
        marginLeft: 9,
        cursor: "pointer",
        lineHeight: 1,
        display: "inline-block"
    },
    gridFreeProduct: {
        border: "1px solid #14a4c2",
        backgroundColor: '#fff',
        padding: '5px 10px',
        borderRadius: 10,
        marginTop: 5
    },
    storeSalesLeftSide: {
        width: 650,
        transition: "width .4s"
    },
    storeSalesRightSide: {
        width: "calc(100% - 650px)",
        transition: "width .4s"
    },
    togggleBarcode: {
        "& $storeSalesLeftSide": {
            width: 0, overflow: "hidden"
        },
        "& $storeSalesRightSide": {
            width: "100%"
        },
    },
    toggleProductView: {
        position: "absolute",
        top: "50%",
        left: "-35px",
        backgroundColor: "#ffc27a",
        padding: "8px 7px 8px 7px",
        color: "#fff !important",
        lineHeight: 1,
        zIndex: 999,
        borderRadius: "0 0 10px 10px",
        transform: "rotate(-90deg)",
        display: "none",
        "&:hover": {
            color: "#fff",
        }
    },
    toggleProductViewLeft: {
        position: "absolute",
        top: "50%",
        left: "calc(100% - 38px)",
        backgroundColor: "#ffc27a",
        padding: "8px 7px 8px 7px",
        color: "#fff !important",
        lineHeight: 1,
        borderRadius: "0 0 10px 10px",
        transform: "rotate(-90deg)",
        width: 106,
        opacity: 0,
        transition: "opacity .4s",
        "&:hover": {
            color: "#fff",
        }
    },
    displayInventoryNone: {
        display: "none"
    },
    [theme.breakpoints.down(1860)]: {
        customSalesTotalText: {
            fontSize: "11px",
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        customSalesTotalFont: {
            fontSize: "11px",
            '&$customSalesTotalFontBig': {
                fontSize: "13px",
            },
        },
        customesRowContent: {
            fontSize: 14
        },
        universalScroll: {
            '& .MuiTabs-scroller': {
                overflowX: 'scroll !important',
                width: '1600px'
            }
        },
    },
    [theme.breakpoints.down(1800)]: {
        customesRowContent: {
            fontSize: 13,
        },
        customesRowTitle: {
            fontSize: 13,
        },
    },
    [theme.breakpoints.down(1700)]: {
        gaugeChartDiv: {
            width: "147px",
            top: 0,
        },
        totalSales: {
            fontSize: 11,
            "& span": {
                fontSize: 12,
            }
        },
        gridRow: {
            margin: "-38px -6px 0 -6px",
            paddingRight: 10,
        },
        gridColoum: {
            padding: "0 7px",
        },
        prod_group: {
            "& $gridRow": {
                margin: "-38px -6px 0 -6px",
            },
        },
        fontsize18: {
            fontSize: 16
        }
    },
    [theme.breakpoints.down(1600)]: {
        padding10LeftCustom: {
            paddingLeft: '10px !important'
        },
        totalChartDivCustomers: {
            "& $monthlyDivTitle": {
                "& $monthlyDivTitleSpan": {
                    borderRight: "none",
                    paddingRight: 0,
                    marginRight: 0
                }
            }
        },
        fonSize16: {
            fontSize: "15px !important"
        },
        planColsButton: {
            fontSize: 18
        },
        billingAmount: {
            fontSize: 25
        },
        billingAmountCols: {
            fontSize: 25
        },
        "@global": {
            body: {
                fontSize: 13
            },
            "& .ant-menu": {
                fontSize: 13
            },
            "& .MuiTableCell-root": {
                fontSize: 13
            },
            "& .ant-breadcrumb": {
                fontSize: 13
            },
            "& .ant-dropdown-menu-item": {
                fontSize: 13
            },
            "& .ant-dropdown-menu-submenu-title": {
                fontSize: 13
            },
            "& .ant-card-head": {
                fontSize: 15
            }
        },
        customForm: {
            "& .MuiInput-input": {
                fontSize: 13
            }
        },
        templateView: {
            "& $customAutoComplete": {
                lineHeight: 1
            }
        },
        typographyHeader: {
            fontSize: 13,
        },
        quickLinks: {
            "& $factBoxTitle": {
                fontSize: 13
            }
        },
        dropdownStyle: {
            '& .MuiMenuItem-root': {
                fontSize: 13,
            },
        },
        iconPadding: {
            "& a": {
                padding: "0 0 0 15px"
            },
            "& .ant-space-item > .ant-image": {
                padding: "0 0 0 15px"
            },
            "& .ant-image-img": {
                height: "13px !important",
                width: "auto !important"
            }
        },

        customRadioButton: {
            "& .MuiTypography-root": {
                fontSize: 13
            }
        },
        textFieldLableColorCustom: {
            fontSize: 12,
            paddingRight: 0
        },
        textFieldColor: {
            fontSize: 13
        },
        notificationBar: {
            fontSize: 13
        },
        textFieldLableColor: {
            fontSize: 13,
        },
        fonSize14: {
            fontSize: 13
        },
        triAngleContentAmount: {
            fontSize: 22
        },
        textPrice: {
            fontSize: 24
        },
        totalSupDetails: {
            "& p": {
                fontSize: 11
            },
        },
        netIncomeWrapOuter: {
            padding: 0
        },
        currentMonthText: {
            fontSize: 17
        },
        currentMonthPer: {
            fontSize: 20
        },
        addLink: {
            fontSize: 13,
        },
        comInput: {
            "& input": {
                fontSize: 13,
            }
        },
        sales15Days: {
            "& > div:nth-child(3)": {
                color: "#1c314c",
                fontSize: 14,
            }
        },
        salesByLoc: {
            "& h3": {
                fontSize: "15px",
            }
        },
        addressSmall: {
            fontSize: 14
        },
        customAutoComplete: {
            '& .MuiInput-input': {
                fontSize: 13
            }
        },
        noResultsText: {
            fontSize: 13,
        },
        leftbox: {
            "& h3": {
                fontSize: "14px",
            },
        },
        daysRowText: {
            fontSize: 13
        },
        daysRowContentInner: {
            fontSize: 13,
        },
        totalInvoicesAmount: {
            fontSize: 20
        },
        currentMonth: {
            marginTop: 0,
        },
        monthlySalesDecreases: {
            "& $lastMonth": {
                marginTop: 0
            }
        },
        supNum: {
            width: 40,
            height: 40,
            fontSize: 18
        },
        supNumsimicir: {
            width: 90,
            height: 30
        },
        payingLabels: {
            "& >*": {
                fontSize: 13
            }
        },
        cBlock: {
            "&::after": {
                borderRadius: '0 40px 0 40px',
            },
            "&::before": {
                borderRadius: '0 40px 0 40px',
            }
        },
        cBlock1: {
            borderRadius: '0 40px 0 40px',
        },
        cBlock2: {
            borderRadius: '40px 0 40px 0',
            '&::before': {
                borderRadius: "40px 0 40px 0",
            },
            '&::after': {
                borderRadius: "40px 0 40px 0",
            },
        },
    },
    [theme.breakpoints.down(1520)]: {
        mainContent: {
            "&$quickLinksOpen": {
                "& $scrollBorder": {
                    "&:before": {
                        backgroundSize: '100%'
                    }
                },
            }
        },
        colInlineCat: {
            width: "13.5%",
        },
        totalChartDiv: {
            padding: 10
        },
        customerRowMain: {
            height: "calc(100% - 42px)"
        },
        gaugeChartDiv: {
            width: "130px"
        },
    },
    [theme.breakpoints.down(1500)]: {
        customSalesCount: {
            padding: "3px 0",
        },
        customAutoCompleteCard: {
            "&.ant-card": {
                height: "auto !important",
                "&$fixHeightDropDown": {
                    height: "220px !important"
                }
            }
        },
        fontSizeTotal: {
            fontSize: 10
        },
        cBlock: {
            "&::after": {
                borderRadius: '0 50px 0 50px',
            },
            "&::before": {
                borderRadius: '0 50px 0 50px',
            }
        },
        cBlock1: {
            borderRadius: '0 50px 0 50px',
        },
        cBlock2: {
            borderRadius: '50px 0 50px 0',
            '&::before': {
                borderRadius: "50px 0 50px 0",
            },
            '&::after': {
                borderRadius: "50px 0 50px 0",
            },
        },
        topProductSupplySales: {
            "& $monthlyDivTitle": {
                "& span:first-child": {
                    whiteSpace: "normal"
                }
            },
            "& foreignObject": {
                "& .apexcharts-legend": {
                    width: "58%"
                }
            }
        },
        monthlyDivTitleFilter: {
            width: "175px"
        },
        boxBorderInnerProduct: {
            height: "calc(100% - 47px)"
        },
        storeSalesLeftSide: {
            width: 600
        },
        storeSalesRightSide: {
            width: "calc(100% - 600px)"
        },
    },
    [theme.breakpoints.down(1366)]: {
        colInlineCat: {
            width: "15.5%",
        },
        paddingLeft10P: {
            paddingLeft: '10px'
        },
        fonSize16: {
            fontSize: "14px !important"
        },
        customerRowMain: {
            "& $customerRowCol": {
                display: 'block !important',
                flex: "0 0 100%  !important",
                maxWidth: "100%  !important"
            }
        },
        gaugeChartDiv: {
            width: "150px",
        },
        billingAmount: {
            fontSize: 23
        },
        billingAmountCols: {
            fontSize: 23
        },
        customesRow: {
            paddingTop: "40px"
        },
        top_right_ab: {
            "& .MuiFormControlLabel-labelPlacementStart": {
                "& .MuiTypography-root": {
                    display: "none"
                }
            }
        },
        "@global": {
            body: {
                "& form": {
                    "& .ant-row": {
                        marginLeft: "-10px !important",
                        marginRight: "-10px  !important"
                    },
                    "& .ant-col": {
                        paddingLeft: "10px !important",
                        paddingRight: "10px !important"
                    },
                },
                "& $billingDetails": {
                    "& .ant-row": {
                        marginLeft: "-10px !important",
                        marginRight: "-10px  !important"
                    },
                    "& .ant-col": {
                        paddingLeft: "10px !important",
                        paddingRight: "10px !important"
                    },
                },
                // "& $invoiceDesign": {
                //     "& .ant-row": {
                //         marginLeft: "0px !important",
                //         marginRight: "0px  !important"
                //     },
                //     "& $productImageUpload": {
                //         marginRight: 15
                //     },
                //     "& .ant-col": {
                //         paddingLeft: "0px !important",
                //         paddingRight: "0px !important"
                //     },
                //     "& $ddssectionpadding": {
                //         padding: "15px !important"
                //     },
                //     "& $ddssectionpadding2": {
                //         padding: "15px !important"
                //     },
                //     "& $billtoppadding": {
                //         padding: "15px !important"
                //     },
                //     "& $formatsevenbillrow": {
                //         margin: "0 -15px  !important"
                //     },
                //     "& $billbottompadding": {
                //         padding: "0 15px !important"
                //     },
                //     "& $secondSection": {
                //         "& .ant-col-12": {
                //             padding: "12px !important",
                //             "&$paddingZeroLine": {
                //                 padding: "0px !important"
                //             },
                //         }
                //     },
                //     "& $formatseven": {
                //         "& $billbottompadding": {
                //             padding: "0 !important"
                //         }
                //     },
                //     "& $formatsevenbillcol": {
                //         padding: "0 15px !important",
                //         "& $billtoppadding": {
                //             padding: "13px 0 50px 0 !important"
                //         },
                //         "& billbottompadding": {
                //             padding: "0 !important"
                //         }
                //     },
                //     "& $formatSix": {
                //         "& $billtoppadding": {
                //             "&:last-child": {
                //                 padding: "8px 0px 25px 20px !important"
                //             }
                //         },
                //         '& $billbottompadding': {
                //             "&:last-child": {
                //                 padding: "0 0 0 20px !important"
                //             }
                //         },
                //     },
                //     '& $totalsection': {
                //         "& .ant-col": {
                //             padding: "0 6px !important"
                //         },
                //         "& $totalsectiontaxamount": {
                //             marginLeft: "-6px !important",
                //             marginRight: "-6px !important",
                //             "&$totalsectionamount": {
                //                 marginLeft: "0px !important",
                //                 marginRight: "0px !important",
                //             }
                //         },
                //     }
                // },
                "& .ant-card-body": {
                    padding: 10
                },
                "& .ant-space": {
                    gap: "15px !important"
                },

                "& $iconPadding": {
                    "& a": {
                        padding: 0
                    }
                },
                "& $logoImg": {
                    width: "auto",
                    height: 35,
                }
            },
            formatseven: {
                '& $downloadsRectangle': {
                    paddingLeft: '10px'
                }
            }
        },
        iconPadding: {
            "& .ant-space-item > .ant-image": {
                padding: "0"
            }
        },
        overlFlowResponsive: {
            "& .ant-space": {
                gap: "0 !important",
                display: "flex",
                justifyContent: 'right',
                alignItems: 'center',
                minWidth: 300,
            },
            "& .ant-space-item": {
                marginRight: 10
            }
        },
        padddingIconsProfile: {
            padding: "12px 5px 0 5px"
        },
        padddingIconsProfileNext: {
            padding: "12px 12px 0 7px"
        },
        quickLinks: {
            padding: "15px 15px 15px 28px"
        },
        mainContent: {
            "&$quickLinksOpen": {
                "& $listTableMargin": {
                    margin: '0px 20px 20px 20px',
                },
                "& $scrollBorder": {
                    "&:before": {
                    }
                },
            },
            "& $scrollBorder": {
                "&:before": {
                    backgroundSize: '100%'
                }
            },
        },
        containerBorder: {
            padding: "20px 20px 0 20px",
            height: "calc(100vh - 162px)",
            "& > .ant-row": {
                "& > .ant-col": {
                    paddingBottom: 20
                }
            },
        },
        listTableMargin: {
            margin: "0px 30px 20px 20px",
        },
        headerLogo: { left: 20 },
        listTableMargin2: {
            margin: '15px 30px 0px 20px',
        },
        totalChartDiv: {
            padding: 10
        },
        monthlyDiv: {
            padding: 10
        },
        primaryPaper: {
            marginTop: 20,
        },
        breadBg: {
            padding: "10px 30px 0 20px"
        },
        breadImg: {
            marginLeft: 0
        },
        breadTitle: {
            paddingLeft: 10
        },
        // listTableMargin: {
        //     height: "calc(100% - 168px) !important",
        //     "& > .ant-row": {
        //         height: "100% !important",
        //         "& > .ant-col": {
        //             height: "100% !important",
        //         }
        //     }
        // },
        // stickyContainer: {
        //     height: "100% !important"
        // },
        // quickLinks: {
        //     height: "100% !important"
        // },
        // boxBorder1: {
        //     height: "100% !important",
        //     "& $authContainer": {
        //         height: "100% !important",
        //     },
        //     "& .MuiGrid-container": {
        //         height: "100% !important",
        //     }
        // },
        triAngleContentAmount: {
            fontSize: 16
        },
        primaryMenu: {
            "& $margin10t": {
                marginTop: 5
            }
        },
        textPrice: {
            fontSize: 20
        },
        colInline: {
            width: "16.66%"
        },
        currentMonthText: {
            fontSize: 13,
            marginBottom: 8
        },
        payingLabels: {
            "& >*": {
                fontSize: 12
            }
        },
        currentMonthPer: {
            fontSize: 15
        },
        triAngleContentText: {
            fontSize: 9
        },
        sales15Days: {
            "& > div:nth-child(3)": {
                color: "#1c314c",
                fontSize: 13,
            }
        },
        salesByLoc: {
            "& p": {
                fontSize: "11px",
            },
            "& h3": {
                fontSize: "14px",
            }
        },
        netGst: {
            "& $lastDaysRadio": {
                position: "relative",
                right: 0
            }
        },
        invoiceCounts: {
            fontSize: 10
        },
        invoiceAmount: {
            fontSize: 10
        },
        invoiceMonths: {
            fontSize: 10
        },
        hamburgerMenu: {
            "& .ant-image": {
                width: 15
            }
        },
        totalSalesCustom: {
            "& $hamburgerMenu": {
                top: 0
            }
        },
        leftbox: {
            "& h3": {
                fontSize: "13px",
            },
        },

        //Ajith CSS
        customAccrodinContentInner: {
            padding: "10px 10px",
        },
        AddMoreBtn: {
            padding: "7px 25px",
            fontSize: '13px !important',

        },
        modalBtn: {
            padding: "7px 25px",
            fontSize: '13px !important',
        },
        deleteBtn: {
            padding: "7px 25px",
            fontSize: '13px !important',
        },
        storeSalesLeftSide: {
            width: 0,
            zIndex: 1000,
            overflow: "hidden",
            transition: "width .4s"
        },
        toggleProductView: {
            display: "block",
        },
        storeSalesRightSide: {
            width: "100%"
        },
        togggleOpen: {
            "& $storeSalesLeftSide": {
                position: "absolute",
                top: 0,
                left: 0,
                width: 650,
                height: "100%",
                backgroundColor: "#fff",
                boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.25)",
                overflow: "visible",
            },
            "& $toggleProductViewLeft": {
                opacity: 1
            }
        },
    },
    [theme.breakpoints.down(1300)]: {
        tooltipTrends: {
            top: 20
        }
    },
    [theme.breakpoints.down(1280)]: {
        customerRowMain: {
            overflow: "hidden",
            overflowY: 'auto',
            height: 'calc(100% - 36px)'
        },
        colInlineCat: {
            width: "17.5%",
        },
        marginBillingTop: {
            marginTop: '40px'
        },
        parenAccordion: {
            "&$toggleOpen": {
                height: "calc(100% - 130px)"
            }
        },
        customSalesCount: {
            padding: "2px 0",
        },
        deleteBtn: {
            padding: "7px 20px",
            fontSize: '13px !important',
        },
        textPrice: {
            fontSize: 18
        },
        mainDashIcon: {
            "&$toggleOpen": {
                '& $lottieAnimationHover': {
                    width: '70px',
                    height: "70px",
                },
            }
        },
        netGstChart: {
            "& $chartDiv": {
                padding: 0
            }
        },
        dashicontext: {
            fontSize: 16
        },
        topTenChart: {
            "& $monthlyDivTitle": {
                display: "flex",
                justifyContent: "space-between",
                "& > span:first-child": {
                    width: 55,
                },
                "& > span:nth-child(2)": {
                    marginRight: 20
                }
            },
            "& $chartTopSuppliers": {
                "& $invoiceAmount": {
                    left: "-12%",
                    top: 40,
                },
                "& $chartDiv": {
                    padding: 0,
                    height: 125
                }
            },
            "& $totalSupDetails.ant-col-12": {
                flex: "0 0 100%",
                maxWidth: "100%",
                marginTop: 10,
                "&:first-child": {
                    marginTop: 0,
                }
            }
        },
        leftbox: {
            "& h3": {
                fontSize: "12px",
            },
        },
        mainContent: {
            "&$quickLinksOpen": {
                "& $scrollBorder": {
                    "&:before": {
                        backgroundSize: '100%',
                        width: 'calc(100% - 18px)'
                    }
                },
            }
        },
        scrollBorder: {
            "&:before": {
                backgroundSize: '100%',
            }
        },
        // listTableMarginProduct: {
        //     "& $tablecontain": {
        //         height: "calc(100% - 97px)"
        //     }
        // },
        fullHei: {
            "& .ant-image": {
                width: "100%",
                height: "auto",
                "& > img": {
                    width: "100%",
                    height: "auto"
                }
            }
        },

        customFilterNone: {
            display: 'none'
        },
        customFilter: {
            display: 'flex !important'
        },
        customFilterMyProduct: {
            display: 'flex !important',
            alignItems: 'center',
            "& .ant-space": {
                "& .ant-space-item:first-child": {
                    display: "none"
                }

            }
        },
        customFilterSales: {
            "& .ant-space": {
                "& .ant-space-item:nth-child(2)": {
                    display: "none"
                },
                "& .ant-space-item:nth-child(3)": {
                    display: "none"
                },
                "& .ant-space-item:nth-child(4)": {
                    display: "none"
                },
            }
        },
        customFilterTransaction: {
            "& .ant-space": {
                "& .ant-space-item:nth-child(2)": {
                    display: "none"
                },
                "& .ant-space-item:nth-child(3)": {
                    display: "none"
                },

            }
        },
        customFilterSalesDiscount: {
            "& .ant-space": {
                "& .ant-space-item:nth-child(2)": {
                    display: "none"
                },
                "& .ant-space-item:nth-child(3)": {
                    display: "none"
                },

            }
        },
        topProductSupplySales: {
            "& foreignObject": {
                "& .apexcharts-legend": {
                    width: "59%",
                    "& .apexcharts-legend-series": {
                        "& .apexcharts-legend-text": {
                            fontSize: "11px !important"
                        }
                    }
                }
            }
        },

    },
    [theme.breakpoints.down(1220)]: {
        primaryMenu: {
            "& .ant-row": {
                marginTop: -20,
                "& > .ant-col": {
                    height: "auto",
                    marginTop: 20
                }
            }
        },
    },
    [theme.breakpoints.down(1200)]: {
        boxBorderInnerProduct: {
            height: "calc(100% - 40px)",
            position: "relative",
        },
        productCode: {
            marginTop: 20
        },
        colInlineCat: {
            width: "19.5%",
        },
        secondBox: {
            marginTop: 20
        },
        productNone: {
            display: 'none',
        },
        ProductMobileFilterOpen: {
            display: 'block'
        },
        notificationBar: {
            fontSize: 12
        },
        billingFirstColsCustom: {
            padding: "20px 20px 135px 20px",
            position: "relative",
            marginleft: '80px'
        },
        mobileMargin20t: {
            marginTop: 20
        },
        righttbox: {
            "& div.ant-row": {
                "& div": {
                    alignItems: "center"
                }
            },
        },
        dashboardRow: {
            height: "calc(100% - 20px) !important",
            overflow: "hidden",
            overflowY: "auto",
            paddingTop: 4,
            "& >.ant-col": {
                paddingBottom: "0 !important"
            }
        },
        primaryPaper: {
            "&$primaryMenu": {
                height: "auto !important",
                overflow: "visible !important"
            }
        },
        modalBtn: {
            padding: "7px 20px",
            fontSize: '13px !important',
        },
        AddMoreBtn: {
            padding: "7px 20px !important",
            fontSize: '13px !important',

        },
        padding10Left: {
            paddingLeft: '10px !important'
        },

        customWidth172P: {
            width: '172px !important',

        },
        customWidth250P: {
            width: '270px !important',

        },
        displayNone: {
            display: 'none',
        },
        bd: {
            border: '1px sollid'
        },
        billingRow: {
            padding: 20,
            "&:before": {
                left: 0,
                width: "100%", bottom: 0,
            },
            "& .ant-row": {
                padding: 0
            }
        },
        billingColsThirdMargin: {
            marginTop: 30,
        },
        billingColsForthMargin: {
            marginTop: 30,
        },
        leftStoreSales: {
            padding: 10,
            "& $gridRow": {
                margin: "-38px -10px 0 -10px"
            },
            "& $gridColoum": {
                padding: "0 10px"
            },
            "& $gridColoumQuantity": {
                height: 15,
                "& .ant-image": {
                    "& .ant-image-img": {
                        width: 15
                    }
                },
                "& .MuiInputBase-root": {
                    "& input": {
                        fontSize: 11
                    }
                }
            },
            "& $gridColoumInnerClick": {
                "& $gridColoumInnerBox": {
                    "& > div": {
                        fontSize: 10
                    },
                }
            },
            "& $disabled": {
                opacity: "0.7"
            }
        },
        rightStoreSalesTopBar: {
            padding: 10
        },
        subscriptionExpired: {
            "& span": {
                display: "none"
            }
        }
    },
    [theme.breakpoints.down(1024)]: {
        WhiteSpaceOverFlowSelective: {
            whiteSpace: 'nowrap'
        },
        customShortCutKeys: {
            "&$customShortCutKeysVideo": {
                width: "100% !important"
            }
        },
        colInlineCat: {
            width: "21.5%",
        },
        overFlowSelective: {
            width: '1024px',
        },
        billingAmount: {
            fontSize: 21
        },
        billingAmountCols: {
            fontSize: 21
        },
        overFlowSelectiveAuto: {
            overflow: 'auto',
        },
        header: {
            justifyContent: "right"
        },
        padddingIconsProfileNext: {
            padding: "12px 0px 0 7px"
        },
        notificationTable: {
            '&$accordionHead': {
                "& $searchAnimation": {
                    maxWidth: 190
                },
            }
        },
        customAccrodinHeader: {
            "& span": {
                padding: "13px 10px",
            }
        },
        headerLogo: {
            left: 10
        },
        breadBg: {
            padding: "10px 10px 0 10px"
        },
        menu: {
            paddingRight: 10
        },
        mobileDisplayRegister: {
            display: "none !important"
        },
        cardSize: {
            padding: 15
        },
        registerForm: {
            margin: "auto",
            "& $cardSize": {
                padding: 15
            }
        },
        authContainer: {
            "&.MuiPaper-root": {
                padding: 10,
            }
        },

        loginForm: {
            margin: "auto"
        },
        vertiCalScrollOverFlow: {
            overflow: "auto",
            paddingBottom: 8
        },

        vertiCalScrollOverFlowSales: {
            overflow: "auto",
        },
        vertiCalScroll: {
            width: '870px',
            margin: "auto"
        },
        mobileMargin20t: {
            marginTop: 10
        },
        // listTableMarginProduct: {
        //     "& $tablecontain": {
        //         height: "calc(100% - 73px)"
        //     }
        // },
        dashicontext: {
            fontSize: 14
        },
        lottieAnimationHover: {
            width: 100,
            height: 100
        },
        mainDashIcon: {
            "&$toggleOpen": {
                '& $lottieAnimationHover': {
                    width: 60,
                    height: 60,
                },
            }
        },
        accordionHead: {
            "& $accordionBody": {
                padding: "0 10px"
            }
        },
        listTableMargin: {
            margin: "0px 10px 10px 10px"
        },
        stickyContainer: {
            //  height: 'calc(100vh - 162px)'
            height: 'calc(100dvh - 162px)'
        },
        scrollBorder: {
            "&:before": {
                top: 'calc(100% - 12px)'
            }
        },
        containerBorder: {
            padding: "10px 10px 0 10px"
        },

        dashboardRow: {
            height: "calc(100% - 10px) !important"
        },
        tablecontain: {
            "&.MuiTableContainer-root": {
                width: "auto !important",
                "& span": {
                    width: "auto !important",
                    maxWidth: 200,
                }
            },
        },
        allCustomerTop: {
            "& $overlFlowResponsiveDesign": {
                paddingTop: '8px',
                paddingBottom: '8px'
            }
        },
        tableRoot: {
            "& .MuiTableContainer-root": {
                width: "auto !important",
                "& span": {
                    width: "auto !important",
                }
            },
        },
        dropDown: {
            position: "relative",
            height: "150px",
            backgroundColor: "#ececec",
            borderRadius: "18px",
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            marginTop: '10px'
        },
        boxBorderInnerProduct: {
            height: "calc(100% - 40px)",
            position: "relative",
        },
        priceTopbar: {
            padding: "0px 0 18px 0"
        },
        nodeOpen: {
            "& > $parentNodeUl": {
                paddingLeft: '30px',
                fontSize: '13px'
            },
        },
        nodeLink: {
            padding: "5px 0px",
        },
        customFormFlex: {
            '& $gridColoum': {
                width: "50%"
            },
        },
        width100tab: {
            width: '100% !important',
            "& .ant-col-7": {
                flex: "0 0 100%",
                maxWidth: "100%",
            },
            "& .ant-col-17": {
                flex: "0 0 100%",
                maxWidth: "100%",
            },
            "& .ant-col-6": {
                flex: "0 0 100%",
                maxWidth: "100%",
            },
            "& .ant-col-18": {
                flex: "0 0 100%",
                maxWidth: "100%",
            },
            "& .ant-col-8": {
                flex: "0 0 100%",
                maxWidth: "100%",
            },
            "& .ant-col-16": {
                flex: "0 0 100%",
                maxWidth: "100%",
            },
        },
        // rightStoreSalesTopBar: {
        //     "& $customerLabelNone": {
        //         borderRight: "none",
        //         borderBottom: "1px solid #14a4c2",
        //         paddingBottom: "20px",
        //         marginBottom: "20px",
        //     },
        // },
        width1024: {
            width: "1024px",
        },
        rightStoreSalesBottomBar: {
            "& .ant-space": {
                flexDirection: "column",
                width: "100%",
            },
            "& .ant-space-item": {
                width: "100%",
            },
            "& .ant-space a": {
                width: "100%",
                textAlign: "center",
            }
        },
        subscriptionExpired: {
            display: "none"
        }
    },
    [theme.breakpoints.down(992)]: {
        colInlineCat: {
            width: "23.5%",
        },
        globalView: {
            marginTop: '-10px'
        },
        actualPlanAmount: {
            marginTop: "0px",
        },
        globalAddressBookView: {
            '&$margin55t': {
                marginTop: '30px'
            }
        },
        globalAddressView: {
            marginTop: '35px'
        },
        globalMobileView: {
            marginTop: 0
        },
        billingDetails: {
            height: "auto",
            minHeight: "none"
        },
        planColsButton: {
            fontSize: 16
        },
        planHeader: {
            "& + .ant-row": {
                paddingTop: 110
            }
        },
        margin00t: {
            marginTop: "20px  !important",
        },
        mobileViewSalesCreate: {
            "& $margin50t": {
                marginTop: "20px  !important",
            },

            '& $margin30t': {
                marginTop: "35px  !important",
            }
        },
        listTableTeamManagement: {
            "& $tablecontain": {
                "&.MuiTableContainer-root": {
                    height: "calc(100% -110px)",
                }
            },
        },
        marginTop10AppTransactions: {
            marginTop: '0px',
        },
        margin30TopTrans: {
            marginTop: '0px !important'
        },
        margin32t: {
            marginTop: '00px'
        },

        mobileViewTotal: {
            "& $margin30t": {
                marginTop: "20px  !important",
            }
        },
        actualPlanAmountView: {
            "&$margin30t": {
                marginTop: "0px  !important",
            }
        },
        actualPlanDescriptionView: {
            marginTop: "30px  !important",
        },
        mobileAreaAddress: {
            "& $margin30t": {
                marginTop: "20px  !important",
            }
        },
        marginTop10Mobile: {
            "&$marginTop10": {
                marginTop: 0
            }
        },
        marginTopDash10: {
            "&$marginTop10": {
                marginTop: 0
            }
        },
        mobileAddressView: {
            "& $margin50t": {
                marginTop: "20px  !important",
            },
            "& $margin10t": {
                marginTop: "35px  !important",
            },
            "& $margin65t": {
                marginTop: "30px  !important",
            },
            "& $margin75t": {
                marginTop: "30px  !important",
            },

            "& $margin70t": {
                marginTop: "30px  !important",
            },
            "& $margin35t": {
                marginTop: "30px  !important",
            },
        },
        businessPanID: {
            marginTop: "30px  !important",
        },
        mobileAddressTotal: {
            "& $margin30t": {
                marginTop: "20px  !important",
            }
        },
        BusinessAddress: {
            marginTop: "35px  !important",
        },

        mobileViewPinCode: {
            "& $margin30t": {
                marginTop: "20px  !important",
            }
        },

        tableRootSelectInvoice: {
            "&$tableRoot": {
                '& .MuiTableContainer-root': {
                    height: "calc(100% - 53px)",
                },
            }
        },
        tableRootSelectInvoiceView: {
            "&$tableRoot": {
                '& .MuiTableContainer-root': {
                    height: "calc(100% - 0px)",
                },
            }
        },
        mobileAddressSales: {
            "& $margin50t": {
                marginTop: "20px  !important",
            },
            "& $margin70t": {
                marginTop: "20px  !important",
            },
        },
        mobileAddressPurchaase: {
            "& $margin45t": {
                marginTop: "20px  !important",
            },
            "& $margin70t": {
                marginTop: "20px  !important",
            },
        },
        mobileAddressSalesEdit: {
            "& $margin50t": {
                marginTop: "20px  !important",
            },
            "& $margin30t": {
                marginTop: "35px  !important",
            },

            "& $margin60t": {
                marginTop: "20px  !important",
            },
        }
    },
    [theme.breakpoints.down(950)]: {
        colInlineCat: {
            width: "24.5%",
        },
        topProductSupplySales: {
            "& $monthlyDivTitle": {
                paddingBottom: 5,
                marginBottom: 5,
            },
        },
        colInline: {
            width: "19.66%"
        },
        gridColoum: {
            width: "50%"
        }
    },
    [theme.breakpoints.down(830)]: {
        colInline: {
            width: "24.66%"
        },
        colInlineCat: {
            width: "24.5%",
        },
        notificationBar: {
            fontSize: 11
        },
        overlFlowResponsive: {
            "& .ant-space": {
                gap: "0 !important",
            },
        },
        customWidth160P: {
            width: '160px !important',

        },
        PaddingLeftIndex: {
            paddingLeft: '10px'
        },
        mobileDisplay: {
            display: "none !important"
        },
        notificationTable: {
            '&$accordionHead': {
                '& $accordionBody': {
                    '& .MuiTableContainer-root': {
                        height: "calc(100% + 13px)",
                    }
                },
            },
        },
        changeLanguage: {
            "& .MuiInputBase-root": {
                margin: "0 10px 0 0"
            }
        },
        lottieAnimationHover: {
            width: 80,
            height: 80
        },
        header: {
            padding: 0
        },
        mainMenu: {
            display: "none"
        },
        mobileBurgerIcon: {
            display: "block"
        },
        new: {
            fontSize: 0,
            padding: "2px 4px",
            "&:after": {
                content: "'N'",
                fontSize: 12,
            }
        },
        primaryMenu: {
            "& .ant-row": {
                "& > .ant-col": {
                    width: "50%"
                }
            }
        },
        mainContent: {
            "&$quickLinksOpen": {
                width: "100%"
            }
        },
        quickLinks: {
            right: 0,
            zIndex: 9999,
            transform: "translateX(100%)",
            "&$quickLinksOpen": {
                transform: "translateX(0)",
            }
        },
        width100PImport: {
            "& .MuiPaper-root": {
                width: '100% !important'
            }
        },
        width100Pern: {
            width: '100% !important'
        },
        subscriptionExpired: {
            padding: 0,
            "& span": {
                display: "none"
            }
        }
    },
    [theme.breakpoints.down(768)]: {
        businessPan: {
            marginTop: "30px  !important",
        },
        colInlineCat: {
            width: "32.5%",
        },
        globalMobileView: {
            marginTop: '30px'
        },
        actualPlanAmount: {
            marginTop: "20px",
        },
        mobileViewPinCode: {
            "& $margin30t": {
                marginTop: "30px  !important",
            }
        },
        actualPlanAmountView: {
            "&$margin30t": {
                marginTop: "30px  !important",
            }
        },
        rightStoreSalesTopBar: {
            "& > .ant-row": {
                margin: "0 -10px",
                "& > .ant-col": {
                    padding: "0 10px"
                },
                "& $customerLabelNone": {
                    marginBottom: 20
                }
            }
        },
        mobileViewPinCodeSalesBill: {
            "& $margin30t": {
                marginTop: "30px  !important",
            }
        },

        importListFields: {
            height: 415,
            overflow: "auto",
            "& .MuiFormControlLabel-label": {
                fontSize: 13
            }
        },
        margin30TopTrans: {
            marginTop: '30px !important'
        },

        mobileAddressTotal: {
            "& $margin30t": {
                marginTop: "30px  !important",
            }
        },

        containerBorder: {
            "& > .ant-row": {
                height: "auto",
                "& > .ant-col": {
                    height: "auto",
                }
            },
        },
        boxBorderInnerProduct: {
            height: "calc(100% - 30px)",
            position: "relative",
        },

        positionAbsolute: {
            position: 'absolute',
            right: '0px',
        },
        positionRelative: {
            position: 'relative'

        },
        overlFlowResponsive: {
            "& .ant-space": {
                gap: "0 !important",
            },

        },
        primaryPaper: {

        },
        thirdBox: {
            marginTop: 20
        },
        boxBorderH: {
            height: "350px !important"
        },
        width100PCustomerandSales: {
            "& .MuiPaper-root": {
                width: '100% !important'
            }
        },
        mainContent: {
            "& $scrollBorder": {
                "&:before": {
                    backgroundImage: `url(${scrollBarMobile})`,
                    top: "calc(100% - 11px)",
                    left: "-2px",
                    width: "calc(100% - 17px)"
                }
            },
        },

        mobileViewSalesConfirm: {
            marginTop: "30px  !important",
            '& $margin10t': {
                marginTop: "0px"
            }
        },
        mobileViewTransaction: {
            '&$margin30t': {
                marginTop: "0px"
            }
        },
        mobileViewSerialNo: {
            '& $margin10t': {
                marginTop: "30px"
            }
        },
        mobileViewPaymentConfirm: {
            marginTop: "30px  !important",
        },
        mobileAddressViewCustom: {
            "& $margin30t": {
                marginTop: "20px  !important",
            },
            "& $margin35t": {
                marginTop: "20px  !important",
            },
        },
        businessOverMobile: {
            marginTop: "20px  !important",
        },
        collectPayment: {
            marginTop: "20px  !important",
        },
        mobileAddressAreaView: {
            "& $margin20t": {
                marginTop: "30px  !important",
            },
        },
        importExport: {
            marginTop: "30px  !important",
        },

        ButtonAbsolute: {
            position: "absolute",
            top: 0,
            right: 0,
        },
        ButtonStatic: {
            position: "static",
        },
        ButtonRelative: {
            position: "relative",
        },
        OverallPaymentButton: {
            "&.ant-space": {
                gap: "6px !important",
                marginRight: '10px'
            },
        },
        catalogue: {
            height: "98%",
        },
        customStickyTop: {

            "& .ant-image": {
                width: '15px !important'
            },
        },
        tabDesign: {
            paddingTop: 30,
            "& $tabWrap": {
                position: "static",
                marginTop: 10
            }
        },
        tableRoot: {
            "&$customerSettlement": {
                "& .MuiTabPanel-root": {
                    overflow: "hidden",
                    overflowY: "auto",
                    paddingRight: 10,
                    height: "calc(100% - 145px)"
                }
            }
        },
        customFormFlex: {
            "& .ant-col-12": {
                flex: "0 0 100%",
                maxWidth: "100%",
            },
            '& $gridColoum': {
                width: "100%"
            },
        },
    },
    [theme.breakpoints.down(576)]: {
        notificationBar: {
            fontSize: 10
        },
        nodeOpen: {
            "& > $parentNodeUl": {
                paddingLeft: '20px',
                fontSize: '13px'
            },
        },
        togggleOpen: {
            "& $storeSalesLeftSide": {
                width: "100%"
            }
        },
        rightStoreSalesSecondBar: {
            "& .ant-col": {
                padding: "0 5px"
            }
        },
        viewPlanDetails: {
            height: '100%',
            overflow: 'hidden',
            overflowY: 'auto',
            paddingRight: '10px'
        },
        colInlineCat: {
            width: "48.5%",
        },
        colInline: {
            width: "32.66%"
        },
        planHeader: {
            "& + .ant-row": {
                flexWrap: "wrap",
                "& .ant-col": {
                    marginTop: 45,
                    "&:first-child": {
                        marginTop: 0
                    }
                }
            }
        },
        billingRow: {
            backgroundColor: "#e8f6f9",
            "&:before": {
                content: "none"
            }
        },
        planDetails: {
            "& .ant-card-body": {
                height: "calc(100% - 80px)"
            }
        },
        billingColsSecondMargin: {
            marginTop: 40
        },
        feature: {
            marginTop: "20px  !important",
        },
        planNameView: {
            marginTop: "30px  !important",
        },
        younoteAdminProduct: {
            marginTop: '200px'
        },
        tableRootParameters: {

            '& .ant-card-body': {
                height: "calc(100% - 55px) !important",
                position: "relative !important",
                overflow: 'scroll !important',

            },
        },
        width100P: {
            "& .MuiPaper-root": {
                width: '100% !important'
            }
        },
        InvoiceView: {
            marginTop: "30px  !important",
        },
        mobileAddressCheckingAll: {
            "& $margin30t": {
                marginTop: "30px  !important",
            }
        },

        mobileViewHold: {
            "& $margin20t": {
                marginTop: "30px  !important",
            },
        },

        mobileViewHoldSupplier: {
            "& $margin10t": {
                marginTop: "30px  !important",
            },
        },
        CountryMobilePurView: {
            "&$margin65t": {
                marginTop: "30px  !important",
            },
        },
        margin30TopBill: {
            marginTop: '20px !important'
        },
        CountryMobileView: {
            "& $margin50t": {
                marginTop: "30px  !important",
            },
        },
        collectPaymentSpefic: {
            marginTop: "20px  !important",
        },

        businessOverMobile: {
            marginTop: "30px  !important",
        },
        businessOverMargin: {
            marginTop: "20px  !important",
        },
        mobileAddressCountry: {
            "& $margin50t": {
                marginTop: "20px  !important",
            },
        },
        priceTopbar: {
            padding: "0 0 0 0  !important"
        },
        displayFlexPayment: {
            display: 'flex',
        },
        customerLabelNone: {
            "& $autoCustomLabel": {
                paddingTop: '10px !important',
                textAlign: 'center !important'
            }
        },
        customerInvoice: {
            paddingLeft: '15px !important'
        },
        customerInvoiceNone: {
            display: 'none !important'
        },
        vertiCalScrollOverFlowParent: {
            marginTop: "20px"
        },


        tableRoot: {
            '& .ant-card-body': {
                height: "calc(100% - 43px)",
                position: "relative"
            },
            '& .MuiTableContainer-root': {
                height: "calc(100% - 110px)",
                overflow: "auto",
                paddingRight: "15px",
                overflowY: "scroll",
                "&$catelogueProducts": {
                    paddingBottom: 30
                }
            },
        },
        inAppTransactions: {
            "& $margin10t": {
                marginTop: "30px  !important",
            }
        },
        marginTop30: {
            marginTop: '30px !important'
        },
        marginTop20: {
            marginTop: '20px !important'
        },
        listTableTeamManagement: {
            "& $tablecontain": {
                "&.MuiTableContainer-root": {
                    height: "calc(100% - 155px)",
                }
            },
        },
        mobileViewSerialNo: {
            '& $margin10t': {
                marginTop: "0px"
            }
        },
        gabId: {
            marginTop: '30px'
        },
        nodeCustomName: {
            paddingRight: 0,
            marginLeft: 0,
            paddingLeft: 10,
        },
        noneImage: {
            display: 'none !important'
        },
        padding20: {
            padding: "0px 10px",
        },
        boxBorderTitle: {
            top: 10,
            margin: "0 0 0",
            padding: "10px 0"
        },
        unSelectedButton: {
            right: 10
        },
        leftScrollCatalogue: {
            "&.ant-space": {
                padding: '03px 13px'
            },
        },
        customStickyTop: {
            "& .ant-space": {
                width: "20%"
            },
            "& .ant-image": {
                width: 15
            },
            "& $addLink": {
                whiteSpace: "nowrap",
                paddingLeft: 40

            }
        },
        nodeLink: {
            padding: "5px 15px",
        },
        catalogue: {
            height: "89%",
        },
        nodeCustomArrow: {
            right: 0,
            display: 'none'

        },

        leftScroll: {
            "& $sideBarMenu": {
                height: "calc(100% - 54px) !important",
                overflow: "auto"
            },
            paddingBottom: 0,
            fontSize: '13px'
        },
        gridColoum: {
            width: "100%"
        }
    },
    [theme.breakpoints.down(500)]: {
        width100PCustomer: {
            "& .MuiPaper-root": {
                width: '100% !important'
            }
        },
        nodeOpen: {
            "& > $parentNodeUl": {
                paddingLeft: '15px',
            },
        },
        leftScrollCatalogue: {
            "&.ant-space": {
                padding: '03px 11px',

            },
        },
        customStickyTop: {
            "& .ant-space": {
                width: "25%",
                paddingBottom: '10px'
            },
            "& .ant-image": {
                width: 15
            },
        },
        nodeLink: {
            padding: "5px 15px",
        },
        colInlineCat: {
            width: "62.5%",
        },
        catalogue: {
            height: "93%",
        },
        "@global": {
            body: {
                "& .Toastify__toast": {
                    minWidth: 0,
                    width: "100%"
                }
            }
        },
        accordionHead: {
            "& $accordionBody": {
                height: "calc(100% - 80px)"
            }
        },

        lottieAnimationHover: {
            width: 50,
            height: 50
        },
        mainDashIcon: {
            "&$toggleOpen": {
                '& $lottieAnimationHover': {
                    width: 30,
                    height: 30,
                },
            }
        },
        primaryMenu: {
            "& .ant-row": {
                "& > .ant-col": {
                    width: "100%"
                }
            }
        },
        closeBackGround: {
            width: '100% !important'
        },
        boxBorderInnerProduct: {
            height: "calc(100% - 35px)",
            position: "relative",
        },
        topProductSupplySales: {
            "& $monthlyDivTitle": {
                paddingBottom: 5,
                marginBottom: 5,
            },
            "& .apexcharts-legend-marker": {
                position: "absolute",
                top: "50% !important",
                left: "0 !important",
                transform: "translateY(-50%)",
                height: "15px !important",
                width: "15px !important"
            },
        },
        tableRoot: {
            '& .ant-card-body': {
                height: "calc(100% - 43px)",
                position: "relative"
            },
            '& .MuiTableContainer-root': {
                height: "calc(100% - 110px)",
                overflow: "auto",
                paddingRight: "15px",
                overflowY: "scroll",
                "&$catelogueProducts": {
                    paddingBottom: 30
                }
            },
        },
        tableRootParameters: {

            '& .ant-card-body': {
                height: "calc(100% - 55px)",
                position: "relative",
                overflow: 'scroll',

            },
        },
        templateView: {
            "& $textFieldColor": {
                width: 50,
            },
        },
        BusinessRelative: {
            "& $productImageUpload": {
                height: "auto",
                width: "100%",
                "& $productImageUploadInner": {
                    position: "relative",
                    height: "auto",
                    "& $imageContainerText": {
                        position: "relative",
                        transform: "none",
                        left: 0,
                    },
                    "& $imageContainer": {
                        position: "relative",
                        width: "100%",
                        marginBottom: 20,
                        left: 0
                    }
                }
            }
        }
    },
    [theme.breakpoints.down(370)]: {
        boxBorderInnerProduct: {
            height: "calc(100% - 50px)"
        },
        customStickyTop: {

            "& .ant-space": {
                width: "35%",
            },
        },
        colInlineCat: {
            width: "80.5%",
        },
        catalogue: {
            height: "83%",
        },
        colInline: {
            width: "49.66%"
        },
        customSalesTotalFont: {
            fontSize: "8px",
            '&$customSalesTotalFontBig': {
                fontSize: "8px",
                paddingTop: '2px',
            },
        },

        customSalesTotalText: {
            fontSize: "8px",
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        width100MaintainPrice: {
            "& .MuiPaper-root": {
                width: '100% !important'
            }
        },
        topProductSupplySales: {
            "& foreignObject": {
                "& .apexcharts-legend": {
                    width: "59%",
                    "& .apexcharts-legend-series": {
                        "& .apexcharts-legend-text": {
                            fontSize: "9px !important"
                        },
                        "& .apexcharts-legend-marker": {
                            height: "15px !important",
                            width: "15px !important"
                        },
                    }
                }
            },
            '& .apexcharts-title-text': {
                display: 'none'
            },
            '& .apexcharts-subtitle-text': {
                display: 'none'
            },
        },



    },
    [theme.breakpoints.down(320)]: {
        catalogue: {
            height: "63%",
        },
    },
    '@media (max-width: 900px) and (orientation: landscape)': {
        containerBorder: {
            minHeight: "400px"
        }
    },
    '@media (max-width: 520px) and (orientation: portrait)': {


    },
    billCustom: {
        // "& p": {
        //     margin: 0
        // },
    },
    avoid: {
        position: "relative",
        pageBreakInside: "avoid"
    },


}));

export default customStyles;